// This file is auto-generated by @hey-api/openapi-ts

export type ASNContainer = {
    inASNContainerId?: number;
    inASNId?: number;
    containerParent?: number | null;
    containerWeight?: number | null;
    containerWeightUOM?: string | null;
    containerLength?: number | null;
    containerWidth?: number | null;
    containerHeight?: number | null;
    containerDimensionsUOM?: string | null;
    containerIdentifier?: string | null;
    comments?: string | null;
    qtyCount?: number | null;
    items?: Array<ASNItem> | null;
    itemSKUs?: string | null;
    itemsCount?: number;
};

export type ASNItem = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    inASNItemId?: number;
    poDetailId?: number;
    itemQty?: number;
    itemUOM?: number;
    itemVendorReference?: string | null;
    inASNContainerId?: number;
    itemQtyReceived?: number;
    uomName?: string | null;
    ean?: string | null;
    upc?: string | null;
    unitCost?: number;
    unitCostCurrency?: string | null;
    unitCostLCY?: number;
    itemQtyTotal?: number;
    packages?: number;
    itemQtyPerPackage?: number;
    itemImageUrl?: string | null;
};

export enum partType {
    STOCK_ITEM = 'STOCK_ITEM',
    SERVICE_ITEM = 'SERVICE_ITEM',
    KIT_ITEM = 'KIT_ITEM',
    BOM_ITEM = 'BOM_ITEM',
    GROUP_ITEM = 'GROUP_ITEM'
}

export enum pricingMethod {
    QUANTITY = 'QUANTITY',
    WEIGHT = 'WEIGHT',
    SIZE = 'SIZE'
}

export type AccountInfo = {
    id?: string | null;
    name?: string | null;
    balance?: AccountInfoBalance;
    currency?: string | null;
    liveMode?: boolean;
};

export type AccountInfoBalance = {
    outstanding?: number;
    overdue?: number;
};

export type AccountInfoUnpagedListResults = {
    results?: Array<AccountInfo> | null;
};

export type AccountInvoice = {
    id?: string | null;
    number?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'INVOICE' | 'CREDIT_NOTE';
    paymentStatus?: 'UNPAID' | 'PAID' | 'PENDING' | null;
    date?: Date;
    dueDate?: Date;
    readonly isOverdue?: boolean;
    total?: number;
    amountPaid?: number;
    readonly amountOutstanding?: number;
    currency?: string | null;
    readonly currencySymbol?: string | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum type {
    INVOICE = 'INVOICE',
    CREDIT_NOTE = 'CREDIT_NOTE'
}

export enum paymentStatus {
    UNPAID = 'UNPAID',
    PAID = 'PAID',
    PENDING = 'PENDING'
}

export type AccountInvoiceListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<AccountInvoice> | null;
};

export type AccountPaymentMethod = {
    id?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'CARD' | 'BANK';
    name?: string | null;
    displayName?: string | null;
    expiry?: string | null;
    readonly isExpired?: boolean;
    default?: boolean;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum type2 {
    CARD = 'CARD',
    BANK = 'BANK'
}

export type AccountPaymentMethodUnpagedListResults = {
    results?: Array<AccountPaymentMethod> | null;
};

export type Address = {
    addressName?: string | null;
    attentionName?: string | null;
    address1?: string | null;
    address2?: string | null;
    town?: string | null;
    state?: string | null;
    zip?: string | null;
    country?: string | null;
    gln?: string | null;
    phone?: string | null;
    email?: string | null;
    readonly countryIsEU?: boolean;
    geoLat?: number | null;
    geoLong?: number | null;
    readonly countryName?: string | null;
    readonly lined?: string | null;
    readonly linedFormatted?: string | null;
    readonly linedAddress?: string | null;
    readonly linedAddressSplit?: Array<(string)> | null;
    readonly linedAddressFormatted?: string | null;
    readonly linedAddress2?: string | null;
    readonly linedAddress2Formatted?: string | null;
};

export type AlternativeUom = {
    uomId?: number;
    name?: string | null;
    multiplier?: number;
    divisor?: number;
    isolated?: boolean;
};

export type Amount = {
    currencyCode?: string | null;
    value?: number;
};

export type ApiUser = {
    readonly id?: string | null;
    name?: string | null;
    scopes?: ApiUserScope;
    apiKey?: string | null;
};

export type ApiUserScope = {
    carrier?: Int32IdName;
    salesRep?: GuidIdName;
    warehousing?: GuidIdName;
    reports?: boolean;
};

export type ApiUserUnpagedListResults = {
    results?: Array<ApiUser> | null;
};

export type AppendItemImage = {
    /**
     * Publicly available URL of image
     */
    url: string;
    /**
     * Mark image as private
     */
    markAsPrivate?: boolean;
};

export type AppendItemImageDetailResponse = {
    error?: string | null;
    url?: string | null;
};

export type AppendItemImageDetailResponseResponseData = {
    data?: AppendItemImageDetailResponse;
};

export type AppendItemImageRequest = {
    images: Array<AppendItemImage>;
};

export type AppendItemImageResponse = {
    requestUrl?: string | null;
    output?: AppendItemImageDetailResponse;
};

export type AppendItemImageResponseUnpagedListResults = {
    results?: Array<AppendItemImageResponse> | null;
};

export type AppsConfigurationResponse = {
    marketplaces?: {
        [key: string]: ConfigurationAttribute;
    } | null;
    carriers?: {
        [key: string]: ConfigurationAttribute;
    } | null;
    thirdPartyFulfilment?: {
        [key: string]: ConfigurationAttribute;
    } | null;
    returnServices?: {
        [key: string]: ConfigurationAttribute;
    } | null;
    insuranceServices?: {
        [key: string]: ConfigurationAttribute;
    } | null;
};

export type AppsConfigurationResponseResponseData = {
    data?: AppsConfigurationResponse;
};

export type AsnDetail = {
    asnId?: number;
    po?: string | null;
    vendorReference?: string | null;
    palletCount?: number | null;
    supplierName?: string | null;
};

export type AsnInshpInfo = {
    id?: number;
    readonly documentName?: string | null;
    status?: InboundStatus;
};

export type AsnPoInfo = {
    id?: number;
    readonly documentName?: string | null;
    supplierName?: string | null;
    expectedDate?: Date | null;
    tags?: Array<(number)> | null;
};

export type AsnResult = {
    id?: number;
    warehouseName?: string | null;
    status?: InboundStatus;
    po?: AsnPoInfo;
    inshp?: AsnInshpInfo;
    totalWeight?: number | null;
    packagesCount?: number | null;
    palletsCount?: number | null;
    packagesVolume?: number;
    asnValue?: MoneyWithLcy;
    customFields?: Array<CustomFieldResult> | null;
};

export type AsnResultListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<AsnResult> | null;
};

export type AuthResponseAction = {
    description?: string | null;
    type?: string | null;
};

export type AuthResponseOrganisation = {
    redirect?: string | null;
    organization?: Organisation;
};

export type AuthenticationRequest = {
    host: string;
    username: string;
    password: string;
    grecaptcha: string;
};

export type AuthenticationResponse = {
    captchaRetry?: boolean;
    /**
     * Use as Bearer token on Authorization header
     */
    accessToken?: string | null;
    loginName?: string | null;
    settings?: PortalAccountSettings;
};

export type AuthenticationResponsePortalResponseData = {
    data?: AuthenticationResponse;
    error?: string | null;
};

export type AuthenticationResponseResponseData = {
    data?: AuthenticationResponse;
};

export type AuthenticationTokenRequest = {
    host: string;
    token: string;
};

export type BLL = {
    header?: BLLHeader;
    lines?: Array<BLLDetails> | null;
    totals?: DocTotal;
    tags?: Array<DocumentTag> | null;
    readonly docType?: string | null;
    readonly docId?: string | null;
    readonly isCredit?: boolean;
    readonly exported?: boolean;
    readonly exportConfirmed?: boolean;
    readonly exportReference?: string | null;
};

export type BLLDetails = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    detailID?: number;
    billId?: number | null;
    productID?: string | null;
    qty?: number | null;
    unitPrice?: number | null;
    unitDiscount?: number | null;
    lineTotal?: number;
    lineVATValue?: number;
    description?: string | null;
    vatRate?: number | null;
    scaledType?: number | null;
    unitWeight?: number | null;
    unitSize?: number | null;
    qtyBilling?: number;
    uomid?: number | null;
    discountType?: number | null;
    linkedBaseType?: string | null;
    linkedBaseDetailId?: number | null;
    linkedBaseId?: string | null;
    uomName?: string | null;
    contactReference?: string | null;
    uomDetails?: ProductUOM;
    vatCode?: string | null;
    vatCodeInternal?: string | null;
    uomWarn?: boolean;
    nominalCode?: string | null;
    unitPriceNet?: number;
    vatCodeExtended?: string | null;
};

export type BLLHeader = {
    billId?: number;
    warehouseID?: string | null;
    contactId?: string | null;
    contactName?: string | null;
    billDate?: Date | null;
    billReference?: string | null;
    billStatus?: number | null;
    vatGroup?: string | null;
    currency?: string | null;
    currencyRate?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    joinMethod?: 'qty' | 'value' | 'weight' | 'volume' | 'custom';
    confirmExport?: boolean;
    exportReference?: string | null;
    exported?: boolean;
    dueDate?: Date | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    bllType?: 'bll' | 'creditBLL';
    readonly exportConfirmed?: boolean;
    readonly docType?: string | null;
    readonly docId?: string | null;
    isExpense?: boolean;
    billEndDate?: Date | null;
    isExpenseContact?: boolean;
    warehouseName?: string | null;
    supplierName?: string | null;
    supplierCode?: string | null;
    supplierReferenceID?: string | null;
    supplierLedgerCode?: string | null;
    supplierNominalCode?: string | null;
    warehouseAddress?: Address;
    supplierAddress?: Address;
    readonly isCredit?: boolean;
    customFields?: {
        [key: string]: (string | null);
    } | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum joinMethod {
    QTY = 'qty',
    VALUE = 'value',
    WEIGHT = 'weight',
    VOLUME = 'volume',
    CUSTOM = 'custom'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum bllType {
    BLL = 'bll',
    CREDIT_BLL = 'creditBLL'
}

export type BaseAuthFirstRequest = {
    deviceId?: string | null;
    deviceSignature?: string | null;
    scope?: string | null;
    returnUrl?: string | null;
    tid?: string | null;
};

export type BasketSummary = {
    lines?: number;
    items?: number;
};

export type BasketSummaryResponseData = {
    data?: BasketSummary;
};

export type BillItem = {
    docId?: number;
    isCredit?: boolean;
};

export type BoxContentsFeeDetails = {
    totalUnits?: number | null;
    feePerUnit?: Amount;
    totalFee?: Amount;
};

export type BulkInsertRequestParam = {
    name?: string | null;
    value?: string | null;
};

export type BulkPrintItemLabelJobBatch = {
    bestBeforeDate?: Date | null;
    productionDate?: Date | null;
    name?: string | null;
};

export type BulkPrintItemLabelJobRequest = {
    id?: number;
    uomId?: number | null;
    /**
     * Quantity, Default: 1
     */
    quantity?: number;
    itemWeight?: number | null;
    /**
     * GS1 Item quantity information
     */
    itemQuantity?: number | null;
    batch?: BulkPrintItemLabelJobBatch;
    freeText?: string | null;
};

export type BulkPrintItemLabelRequest = {
    jobs: Array<BulkPrintItemLabelJobRequest>;
    queueId?: number | null;
    queueTags?: string | null;
    templateId?: number | null;
    uomId?: number | null;
    pricelistId?: string | null;
};

export type BySection = {
    salesValueNet?: number;
    salesValueGross?: number;
    orders?: number;
    itemsSold?: number;
    grossProfit?: number;
    grossProfitMarkup?: number;
    grossProfitMargin?: number;
    name?: string | null;
};

export type BySectionUnpagedListResults = {
    results?: Array<BySection> | null;
};

export type ColumnDisplay = {
    field?: string | null;
    headerName?: string | null;
    readonly hide?: boolean;
};

export type ColumnDisplayUnpagedListResults = {
    results?: Array<ColumnDisplay> | null;
};

export type Common_ProductBatchDetails = {
    batchID?: number;
    batchNumber?: string | null;
    expiryDate?: Date | null;
    manufacturingDate?: Date | null;
    lotNumber?: string | null;
    qty?: number;
};

export type ConditionalDiscount = {
    payBy?: Date;
    discountPercent?: number;
    discountNet?: number;
    discountTax?: number;
    readonly discountTotal?: number;
    discountValue?: number;
    currentInvoiceTotal?: number;
};

export type ConfigurationAttribute = {
    type?: string | null;
    name?: string | null;
    description?: string | null;
    parameters?: Array<PropertyAttribute> | null;
    imageUrl?: string | null;
};

export type ConfigurationAttributeUnpagedListResults = {
    results?: Array<ConfigurationAttribute> | null;
};

export type ConfigurationParameter = {
    name: string;
    value?: string | null;
};

export type ConfigurationRequest = {
    type: string;
    parameters?: Array<ConfigurationParameter> | null;
};

export type ContactAddress = {
    id?: string | null;
    address?: DocumentAddress;
    isDefaultBilling?: boolean;
    isDefaultShipping?: boolean;
};

export type ContactAddressUnpagedListResults = {
    results?: Array<ContactAddress> | null;
};

export type ContactBase = {
    id?: string;
    name?: string | null;
    code?: string | null;
    readonly codeName?: string | null;
};

export type ContactBaseUnpagedListResults = {
    results?: Array<ContactBase> | null;
};

export type ContactDetails = {
    /**
     * Internal contact id
     */
    id?: string;
    /**
     * Contact code
     */
    code?: string | null;
    /**
     * Contact name
     */
    name?: string | null;
    grouping1?: string | null;
    grouping2?: string | null;
    grouping3?: string | null;
};

export type ContactDetailsList = {
    id?: string;
    name?: string | null;
    code?: string | null;
    readonly codeName?: string | null;
    gln?: string | null;
    eori?: string | null;
    attentionMessage?: string | null;
    referenceId?: string | null;
    balance?: number | null;
    tags?: Array<ContactTag> | null;
    salesRep?: GuidIdName;
    taxGroup?: GuidIdName;
    pricelist?: GuidIdName;
};

export type ContactDetailsListListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ContactDetailsList> | null;
};

export type ContactDetailsWithAddress = {
    id?: string;
    name?: string | null;
    code?: string | null;
    readonly codeName?: string | null;
    gln?: string | null;
    eori?: string | null;
    attentionMessage?: string | null;
    referenceId?: string | null;
    balance?: number | null;
    tags?: Array<ContactTag> | null;
    salesRep?: GuidIdName;
    taxGroup?: GuidIdName;
    pricelist?: GuidIdName;
    currency?: string | null;
    email?: string | null;
    phone?: string | null;
};

export type ContactLedger = {
    accountNumber?: string | null;
    accountName?: string | null;
    creditLimit?: number | null;
    currencyISOCode?: string | null;
    countryCode?: string | null;
    taxRegistrationNumber?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressLine3?: string | null;
    city?: string | null;
    county?: string | null;
    country?: string | null;
    postCode?: string | null;
};

export type ContactTag = {
    id?: number;
    name?: string | null;
    color?: string | null;
};

export type ContactTagUnpagedListResults = {
    results?: Array<ContactTag> | null;
};

export type CreateItemRequest = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    sku: string;
    title?: string | null;
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    categoryId: number;
    /**
     * @deprecated
     */
    appCategoryId?: number | null;
    inventoryModelId?: number | null;
    brandId?: number | null;
    departmentId?: number | null;
    identifier?: ItemIdentifier;
    commodity?: ItemHarmonization;
    parentSku?: string | null;
    /**
     * Tax Type, when unspecified defaults to category settings
     */
    taxType?: string | null;
    app?: CreateItemRequestAppInfo;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum type3 {
    STOCK_ITEM = 'STOCK_ITEM',
    SERVICE_ITEM = 'SERVICE_ITEM',
    KIT_ITEM = 'KIT_ITEM',
    BOM_ITEM = 'BOM_ITEM',
    GROUP_ITEM = 'GROUP_ITEM'
}

export enum pricing {
    QUANTITY = 'QUANTITY',
    WEIGHT = 'WEIGHT',
    SIZE = 'SIZE'
}

export type CreateItemRequestAppInfo = {
    hidden?: boolean;
    new?: boolean;
    newEndDate?: Date | null;
    categoryId?: number | null;
};

export type CreatePayment = {
    methodId: string;
    amount: number;
    idempotencyKey: string;
};

export type CreatePaymentMethodResponse = {
    clientSecret?: string | null;
};

export type CreatePaymentMethodResponseResponseData = {
    data?: CreatePaymentMethodResponse;
};

export type CreatePaymentResponse = {
    requiresAction?: boolean;
    complete?: boolean;
    clientSecret?: string | null;
};

export type CreatePaymentResponseResponseData = {
    data?: CreatePaymentResponse;
};

export type CreateSO = {
    contactCode: string;
    salesRepCode?: string | null;
    warehouseCode?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    customerReference?: string | null;
    orderDate?: Date | null;
    deliveryStart?: Date | null;
    dueDate?: Date | null;
    lines: Array<CreateSOLine>;
    billingAddress?: Address;
    shippingAddress?: Address;
    billing?: DocumentAddress;
    shipping?: DocumentAddress;
};

export type CreateSOLine = {
    qty: number;
    uomName?: string | null;
    itemDescription?: string | null;
    itemCustomerReference?: string | null;
    itemSku: string;
    price?: number | null;
    discount?: number | null;
    discountFixed?: boolean;
    priceIncludesTaxes?: boolean;
};

export type CurrencyDetails = {
    code?: string | null;
    name?: string | null;
    value?: number;
    symbol?: string | null;
    isDefault?: boolean;
};

export type CurrencyDetailsUnpagedListResults = {
    results?: Array<CurrencyDetails> | null;
};

export type CustomFieldResult = {
    id?: number;
    name?: string | null;
    value?: string | null;
    type?: string | null;
};

export type CustomerPeriodicSalesPeriod = {
    periodId?: number;
    startDate?: Date;
    endDate?: Date;
};

export type CustomerPeriodicSalesQty = {
    periodId?: number;
    quantity?: number;
};

export type CustomerPeriodicSalesResults = {
    periods?: Array<CustomerPeriodicSalesPeriod> | null;
    items?: Array<CustomerPeriodicSalesSku> | null;
};

export type CustomerPeriodicSalesResultsResponseData = {
    data?: CustomerPeriodicSalesResults;
};

export type CustomerPeriodicSalesSku = {
    itemSku?: string | null;
    parentItemSku?: string | null;
    siblings?: boolean | null;
    results?: Array<CustomerPeriodicSalesQty> | null;
    readonly quantity?: number;
};

export type DateRanges = {
    range1?: ReportDateRange;
    range2?: ReportDateRange;
};

export type DateUnpagedListResults = {
    results?: Array<SalesOverviewSegmentDate> | null;
};

export type Dimensions = {
    width?: number | null;
    height?: number | null;
    length?: number | null;
    uom?: 'cm' | 'ft' | 'in' | 'm' | 'mm' | null;
};

export enum uom {
    CM = 'cm',
    FT = 'ft',
    IN = 'in',
    M = 'm',
    MM = 'mm'
}

export type DocMultiPack = {
    carrierId?: number | null;
    carrierCode?: string | null;
    trackingNumber?: string | null;
    shipDate?: Date | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * <li><b>none</b>: Do not create a carrier label</li>
     * <li><b>create</b>: Create a carrier label, if the label failed to create the packaging and shipment is still accepted</li>
     * <li><b>force</b>: Create a carrier label, if the label failed to create the packaging and shipment are rejected</li>
     * </ul>
     *
     */
    carrierLabel?: 'none' | 'create' | 'force';
    packages: Array<DocPackageDetails>;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>none</b>: Do not create a carrier label</li>
 * <li><b>create</b>: Create a carrier label, if the label failed to create the packaging and shipment is still accepted</li>
 * <li><b>force</b>: Create a carrier label, if the label failed to create the packaging and shipment are rejected</li>
 * </ul>
 *
 */
export enum carrierLabel {
    NONE = 'none',
    CREATE = 'create',
    FORCE = 'force'
}

export type DocPackDetail = {
    sku: string;
    uom?: number | null;
    batchId?: number | null;
    binLocation?: string | null;
    qty: number;
};

export type DocPackageDetails = {
    packageWidth?: number;
    packageHeight?: number;
    packageDepth?: number;
    dimensionUom?: 'cm' | 'ft' | 'in' | 'm' | 'mm' | null;
    weightValue?: number;
    weightUom?: 'kg' | 'g' | 'oz' | 'lb' | null;
    packDate?: Date | null;
    lines: Array<DocPackDetail>;
};

export enum dimensionUom {
    CM = 'cm',
    FT = 'ft',
    IN = 'in',
    M = 'm',
    MM = 'mm'
}

export enum weightUom {
    KG = 'kg',
    G = 'g',
    OZ = 'oz',
    LB = 'lb'
}

export type DocTotal = {
    totalNet?: number;
    totalNetLcy?: number;
    totalGross?: number;
    totalGrossLcy?: number;
    totalDiscount?: number;
    totalVAT?: number;
    readonly totalTax?: number;
    totalPaid?: number | null;
    totalDue?: number | null;
    total?: number;
    uomTotals?: Array<UOMTotal> | null;
    totalQtyInDefaultUOM?: number | null;
    totalQty?: number;
    totalUnreceivedValue?: number;
};

export type DocumentAddress = {
    name?: string | null;
    att?: string | null;
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    state?: string | null;
    postal?: string | null;
    countryCode?: string | null;
    email?: string | null;
    gln?: string | null;
    phone?: string | null;
    readonly countryName?: string | null;
};

export type DocumentAttachment = {
    readonly id?: string | null;
    author?: string | null;
    createdDate?: Date;
    description?: string | null;
    url?: string | null;
    signature?: string | null;
};

export type DocumentAttachmentUnpagedListResults = {
    results?: Array<DocumentAttachment> | null;
};

export type DocumentContactDetails = {
    id?: string;
    name?: string | null;
    code?: string | null;
    readonly codeName?: string | null;
    attentionMessage?: string | null;
    referenceId?: string | null;
    gln?: string | null;
    eori?: string | null;
    tags?: string | null;
    readonly tagsList?: Array<(string)> | null;
};

export type DocumentCustomField = {
    name?: string | null;
    documentType?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    valueType?: 'TEXT' | 'NUMBER' | 'DATE' | 'LIST' | 'DATE_TIME';
    mandatory?: boolean;
    options?: Array<(string)> | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum valueType {
    TEXT = 'TEXT',
    NUMBER = 'NUMBER',
    DATE = 'DATE',
    LIST = 'LIST',
    DATE_TIME = 'DATE_TIME'
}

export type DocumentCustomFieldUnpagedListResults = {
    results?: Array<DocumentCustomField> | null;
};

export type DocumentDefinition = {
    definitionType?: 'INBOUND' | 'OUTBOUND' | null;
    documentType?: string | null;
    documentId?: string | null;
};

export enum definitionType {
    INBOUND = 'INBOUND',
    OUTBOUND = 'OUTBOUND'
}

export type DocumentDefinitionResponseData = {
    data?: DocumentDefinition;
};

export type DocumentDetails = {
    contactId?: string;
    contactName?: string | null;
    warehouseId?: string;
    pricelistId?: string;
    contactAlerts?: string | null;
    currency?: string | null;
    docReference?: string | null;
    currencyRate?: number;
    isCredit?: boolean;
    isExported?: boolean;
    exportConfirmed?: boolean;
    documentTags?: Array<(number)> | null;
    contactTags?: Array<(number)> | null;
};

export type DocumentDetailsResponseData = {
    data?: DocumentDetails;
};

export type DocumentExportUpdate = {
    exported: boolean;
    exportToken?: string | null;
    errorMessage?: string | null;
    successMessage?: string | null;
    exception?: string | null;
};

export type DocumentItemBulkInsert = {
    /**
     * Item Identifier, SKU, EAN, UPC etc
     */
    item?: string | null;
    /**
     * Item description
     */
    description?: string | null;
    /**
     * Item quantity, default is 1
     */
    qty?: string | null;
    /**
     * Item UOM, default is item default UOM
     */
    uom?: string | null;
    /**
     * Price
     */
    price?: string | null;
    /**
     * Discount
     */
    discount?: string | null;
    /**
     * Total weight, used for weight priced item
     */
    weight?: string | null;
    size?: string | null;
    /**
     * SQ: RRP
     */
    rrp?: string | null;
    /**
     * SQ: Minimum Qty
     */
    minimumQty?: string | null;
    /**
     * Item contact reference
     */
    contactReference?: string | null;
    lineNotes?: string | null;
    batch?: string | null;
    bin?: string | null;
    custom1?: string | null;
};

export type DocumentItemBulkInsertBulkUpsertRequest = {
    items?: Array<DocumentItemBulkInsert> | null;
    readonly source?: string | null;
    params?: Array<BulkInsertRequestParam> | null;
};

export type DocumentItemDetailsBase = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    brand?: string | null;
    category?: string | null;
    department?: string | null;
    inventoryModel?: string | null;
    inventoryProfile?: string | null;
};

export type DocumentItemInfo = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    defaultUomId?: number;
    inventoryModelId?: number;
    isPurchasable?: boolean;
    isSellable?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE';
    isEol?: boolean;
    brand?: string | null;
    category?: string | null;
    department?: string | null;
    imageUrl?: string | null;
    inventoryModel?: InventoryModel;
};

export type DocumentNote = {
    readonly id?: string | null;
    note?: string | null;
    classes?: string | null;
    author?: string | null;
    createdDate?: Date;
};

export type DocumentNoteResponseData = {
    data?: DocumentNote;
};

export type DocumentNoteUnpagedListResults = {
    results?: Array<DocumentNote> | null;
};

export type DocumentProperties = {
    stageName?: string | null;
    stageUpdated?: Date | null;
    notesCount?: number;
    notesError?: boolean;
    author?: string | null;
    created?: Date | null;
    readonly tags?: Array<(number)> | null;
    attachments?: number;
    emailed?: boolean;
};

export type DocumentQueue = {
    id?: number;
    name?: string | null;
    isPublic?: boolean;
    isAttention?: boolean;
    queueCount?: DocumentQueueCount;
};

export type DocumentQueueCount = {
    count?: number;
    updated?: Date | null;
};

export type DocumentQueueUnpagedListResults = {
    results?: Array<DocumentQueue> | null;
};

export type DocumentSearchResult = {
    documentType?: string | null;
    documentId?: string | null;
    documentDate?: Date | null;
    documentPartner?: string | null;
    details?: string | null;
};

export type DocumentSearchResultUnpagedListResults = {
    results?: Array<DocumentSearchResult> | null;
};

export type DocumentStage = {
    id?: number;
    documentTypes?: Array<(string)> | null;
    name?: string | null;
};

export type DocumentStageUnpagedListResults = {
    results?: Array<DocumentStage> | null;
};

export type DocumentTag = {
    tagId?: number;
    tagName?: string | null;
    shortCode?: string | null;
    tagColor?: string | null;
    readonly tagTextColor?: string | null;
};

export type DocumentTagResponseData = {
    data?: DocumentTag;
};

export type DocumentTagUnpagedListResults = {
    results?: Array<DocumentTag> | null;
};

export type DocumentTagUpsert = {
    tagName?: string | null;
    shortCode?: string | null;
    tagColor?: string | null;
};

export type DocumentTagsUpdate = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    operation: 'ADD' | 'SET' | 'REMOVE';
    tags: Array<(number)>;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum operation {
    ADD = 'ADD',
    SET = 'SET',
    REMOVE = 'REMOVE'
}

export type DocumentType = {
    docType?: string | null;
    docId?: string | null;
    readonly docName?: string | null;
};

export type DraftShipmentPayload = {
    carrierId: number;
    /**
     * Used when label failed to create, when this is in use, anything related to label (Like carrierReference, labelContent etc) is ignored
     */
    errorMessage?: string | null;
    /**
     * Overwrite existing label for order, if this is set to false (default) and SO already has a draft shipment, HTTP response will be 400
     */
    overwrite?: boolean;
    /**
     * Contains a unique carrier tracking number for this shipment
     */
    carrierReference: string;
    /**
     * Optional, Contains a unique carrier Consignment Id for this shipment
     */
    shipmentConsignmentId?: string | null;
    /**
     * base64 containing the label
     */
    labelContent: string;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    labelType: 'pdf' | 'png' | 'jpg' | 'zpl';
    shipmentCost?: Money;
    eta?: Date | null;
    requireManifesting?: boolean;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum labelType {
    PDF = 'pdf',
    PNG = 'png',
    JPG = 'jpg',
    ZPL = 'zpl'
}

export type DraftShipmentRequest = {
    wait?: boolean;
    carrierId?: number | null;
    omitNotes?: boolean;
};

export type EmailTemplate = {
    id?: number;
    name?: string | null;
    default?: Array<(string)> | null;
};

export type EmailTemplateDetails = {
    id?: number;
    name?: string | null;
    default?: Array<(string)> | null;
    subject?: string | null;
    body?: string | null;
};

export type EmailTemplateDetailsResponseData = {
    data?: EmailTemplateDetails;
};

export type EmailTemplateResponseData = {
    data?: EmailTemplate;
};

export type EmailTemplateUnpagedListResults = {
    results?: Array<EmailTemplate> | null;
};

export type EmailTemplateUpsert = {
    name: string;
    default?: Array<(string)> | null;
    subject: string;
    body: string;
};

export type ErrorDetail = {
    field?: string | null;
    code?: string | null;
    description?: string | null;
};

export type ErrorResponse = {
    errors?: Array<(string)> | null;
    errorDetails?: Array<ErrorDetail> | null;
    /**
     * Consolidates 'errors' array to a single message
     */
    error?: string | null;
    metadata?: {
        [key: string]: (string);
    } | null;
};

export type ExportPending = {
    customers?: Array<ContactLedger> | null;
    suppliers?: Array<ContactLedger> | null;
    inovices?: Array<InvoiceItem> | null;
    bills?: Array<BillItem> | null;
    transaction?: Array<StockTransaction> | null;
};

export type ExportPendingResponseData = {
    data?: ExportPending;
};

export type FbaInboundCreatePlanItemPrepRequest = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    prepInstruction: 'Polybagging' | 'BubbleWrapping' | 'Taping' | 'BlackShrinkWrapping' | 'Labeling' | 'HangGarment' | 'SetCreation' | 'Boxing' | 'RemoveFromHanger' | 'Debundle' | 'SuffocationStickering' | 'CapSealing' | 'SetStickering' | 'BlankStickering' | 'ShipsInProductPackaging' | 'NoPrep';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    prepOwner: 'AMAZON' | 'SELLER';
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum prepInstruction {
    POLYBAGGING = 'Polybagging',
    BUBBLE_WRAPPING = 'BubbleWrapping',
    TAPING = 'Taping',
    BLACK_SHRINK_WRAPPING = 'BlackShrinkWrapping',
    LABELING = 'Labeling',
    HANG_GARMENT = 'HangGarment',
    SET_CREATION = 'SetCreation',
    BOXING = 'Boxing',
    REMOVE_FROM_HANGER = 'RemoveFromHanger',
    DEBUNDLE = 'Debundle',
    SUFFOCATION_STICKERING = 'SuffocationStickering',
    CAP_SEALING = 'CapSealing',
    SET_STICKERING = 'SetStickering',
    BLANK_STICKERING = 'BlankStickering',
    SHIPS_IN_PRODUCT_PACKAGING = 'ShipsInProductPackaging',
    NO_PREP = 'NoPrep'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum prepOwner {
    AMAZON = 'AMAZON',
    SELLER = 'SELLER'
}

export type FbaInboundCreatePlanItemRequest = {
    sellerSku: string;
    quantity: number;
    preps?: Array<FbaInboundCreatePlanItemPrepRequest> | null;
};

export type FbaInboundCreatePlanRequest = {
    shipToCountryCode: string;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    labelPrepPreference: 'SELLER_LABEL' | 'AMAZON_LABEL_ONLY' | 'AMAZON_LABEL_PREFERRED';
    shipFromWarehouseId: string;
    items: Array<FbaInboundCreatePlanItemRequest>;
    preferUomId?: number | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum labelPrepPreference {
    SELLER_LABEL = 'SELLER_LABEL',
    AMAZON_LABEL_ONLY = 'AMAZON_LABEL_ONLY',
    AMAZON_LABEL_PREFERRED = 'AMAZON_LABEL_PREFERRED'
}

export type FbaInboundCreatePlanResponse = {
    shipmentId?: string | null;
    destinationFulfillmentCenterId?: string | null;
    shipToAddress?: SpApi_FulfillmentInbound_Address;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    labelPrepType?: 'NO_LABEL' | 'SELLER_LABEL' | 'AMAZON_LABEL';
    estimatedBoxContentsFee?: BoxContentsFeeDetails;
    items?: Array<FbaInboundShipmentPlanItem> | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum labelPrepType {
    NO_LABEL = 'NO_LABEL',
    SELLER_LABEL = 'SELLER_LABEL',
    AMAZON_LABEL = 'AMAZON_LABEL'
}

export type FbaInboundCreatePlanResponseUnpagedListResults = {
    results?: Array<FbaInboundCreatePlanResponse> | null;
};

export type FbaInboundCreateShipmentItemRequest = {
    sellerSku: string;
    quantity: number;
    fulfillmentNetworkSKU?: string | null;
    itemUom?: FbaInboundShipmentItemUom;
    preps?: Array<FbaInboundCreatePlanItemPrepRequest> | null;
};

export type FbaInboundCreateShipmentRequest = {
    shipmentId: string;
    shipmentName?: string | null;
    shipFromWarehouseId: string;
    fulfillmentCenterId: string;
    shipToAddress: SpApi_FulfillmentInbound_Address;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    labelPrepPreference: 'SELLER_LABEL' | 'AMAZON_LABEL_ONLY' | 'AMAZON_LABEL_PREFERRED';
    intendedBoxContentsSource?: 'NONE' | 'FEED' | '2D_BARCODE' | null;
    items: Array<FbaInboundCreateShipmentItemRequest>;
};

export enum intendedBoxContentsSource {
    NONE = 'NONE',
    FEED = 'FEED',
    _2D_BARCODE = '2D_BARCODE'
}

export type FbaInboundCreateShipmentResponse = {
    shipmentId?: string | null;
    trnId?: string | null;
    trnUrl?: string | null;
};

export type FbaInboundCreateShipmentResponseResponseData = {
    data?: FbaInboundCreateShipmentResponse;
};

export type FbaInboundDocument = {
    readonly trn?: string | null;
    trnId?: number;
    date?: Date | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'DRAFT' | 'CONFIRMED';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    packingStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE' | 'NA';
    receiveStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE' | 'NA' | null;
    trnReference?: string | null;
    marketplace?: StringIdName;
    itemQtyConfirmed?: number;
    itemQtyPacked?: number;
    itemQtyReceived?: number;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum status {
    DRAFT = 'DRAFT',
    CONFIRMED = 'CONFIRMED'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum packingStatus {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE',
    NA = 'NA'
}

export enum receiveStatus {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE',
    NA = 'NA'
}

export type FbaInboundDocumentListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<FbaInboundDocument> | null;
};

export type FbaInboundDocumentWithShipment = {
    readonly trn?: string | null;
    trnId?: number;
    date?: Date | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'DRAFT' | 'CONFIRMED';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    packingStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE' | 'NA';
    receiveStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE' | 'NA' | null;
    trnReference?: string | null;
    marketplace?: StringIdName;
    itemQtyConfirmed?: number;
    itemQtyPacked?: number;
    itemQtyReceived?: number;
    inboundInfo?: FbaInboundShipmentStatus;
    shipments?: Array<ShipmentWithPackages> | null;
    pendingPackages?: Array<PackageInfo> | null;
};

export type FbaInboundDocumentWithShipmentResponseData = {
    data?: FbaInboundDocumentWithShipment;
};

export type FbaInboundGetPrepInstructionsRequest = {
    shipToCountryCode: string;
    items: Array<FbaInboundItemPrepInstructionsRequest>;
};

export type FbaInboundItemListPrepInstructionDetail = {
    name?: string | null;
    amazonFee?: Money;
};

export type FbaInboundItemListPrepInstructionsResponse = {
    sellerSku?: string | null;
    error?: string | null;
    barcodeInstruction?: string | null;
    prepGuidance?: string | null;
    prepInstructions?: Array<FbaInboundItemListPrepInstructionDetail> | null;
};

export type FbaInboundItemListPrepInstructionsResponseUnpagedListResults = {
    results?: Array<FbaInboundItemListPrepInstructionsResponse> | null;
};

export type FbaInboundItemPrepInstructionsRequest = {
    sellerSku: string;
    quantity: number;
};

export type FbaInboundPutTransportDetailsRequest = {
    packages?: Array<(number)> | null;
    isLtl?: boolean;
    /**
     * Non Partnered Carrier Name, required for non partnered
     */
    carrierName?: string | null;
};

export type FbaInboundPutTransportDetailsResponse = {
    carrierName?: string | null;
    cost?: Money;
};

export type FbaInboundPutTransportDetailsResponseResponseData = {
    data?: FbaInboundPutTransportDetailsResponse;
};

export type FbaInboundShipmentItemUom = {
    uomId?: number;
    uomName?: string | null;
    uomQuantity?: number;
};

export type FbaInboundShipmentPlanItem = {
    sellerSKU?: string | null;
    fulfillmentNetworkSKU?: string | null;
    quantity?: number;
    prepDetailsList?: Array<PrepDetails> | null;
    itemUom?: FbaInboundShipmentItemUom;
};

export type FbaInboundShipmentStatus = {
    shipmentStatus?: string | null;
    confirmedNeedByDate?: Date | null;
    boxContentsSource?: string | null;
    areCasesRequired?: boolean;
    fulfillmentCenterId?: string | null;
};

export type FbaInboundSubmitPakcageInfoRequest = {
    packages?: Array<(number)> | null;
};

export type FieldMappingConfig = {
    propertyName?: string | null;
    customFieldName?: string | null;
};

export type ForgotPasswordRequest = {
    email: string;
    captcha: string;
};

export type GenericDocumentDetails = {
    contactId?: string | null;
    contactName?: string | null;
    warehouseId?: string | null;
    pricelistId?: string | null;
    contactAlerts?: string | null;
    currency?: string | null;
    docReference?: string | null;
    currencyRate?: number | null;
    isCredit?: boolean;
    isExported?: boolean;
    exportConfirmed?: boolean;
    documentTags?: Array<(number)> | null;
    contactTags?: Array<(number)> | null;
    metadata?: {
        [key: string]: (string | null);
    } | null;
};

export type Grouped = {
    groupName?: string | null;
    alerts?: number;
    lastAlertDate?: Date;
    readonly lastAlert?: string | null;
};

export type GroupedUnpagedListResults = {
    results?: Array<Grouped> | null;
};

export type GuidIdName = {
    id?: string;
    name?: string | null;
};

export type INV = {
    header?: INVHeader;
    lines?: Array<INVDetail> | null;
    totals?: INVTotals;
    tags?: Array<DocumentTag> | null;
    kitComponenets?: Array<KitItem> | null;
    conditionalDiscounts?: Array<ConditionalDiscount> | null;
    payments?: Array<Payment> | null;
    linkedDeliveries?: Array<LinkedShp> | null;
};

export type INVDetail = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    detailID?: number;
    invid?: string | null;
    baseType?: string | null;
    baseID?: string | null;
    baseReference?: string | null;
    baseDetailID?: number | null;
    productID?: string | null;
    /**
     * @deprecated
     */
    productDescription?: string | null;
    productReference?: string | null;
    productEAN?: string | null;
    uom?: number | null;
    uomDescription?: string | null;
    qty?: number;
    unitPrice?: number;
    readonly unitPriceGross?: number;
    readonly unitPriceNet?: number;
    unitDiscount?: number;
    vatRate?: number;
    lineVATValue?: number;
    comments?: string | null;
    unitWeight?: number | null;
    unitSize?: number | null;
    defaultPrice?: number | null;
    scaledType?: number | null;
    qtyBilling?: number;
    ver?: string | null;
    lineTotal?: number;
    lineDiscount?: number;
    lineGrossTotal?: number;
    readonly discountPercentage?: number;
    readonly discountPercentage5?: number;
    baseDocReference?: string | null;
    contactReference?: string | null;
    uomCode?: string | null;
    qtyOrdered?: number;
    vatCode?: string | null;
    vatCodeExtended?: string | null;
    readonly packingDetailsQtyConcat?: string | null;
    readonly packingDetailsTotalQty?: number;
    readonly packingDetailsWeightContact?: string | null;
    packingDetails?: Array<Packing_PackingDetail> | null;
    partGTIN?: string | null;
    uomQty?: number | null;
    uomVolume?: string | null;
    qtyReceived?: number | null;
    qtyItems?: number;
    customerReferenceEAN?: string | null;
    customerReferenceUPC?: string | null;
    nominalCode?: string | null;
    uomDetails?: ProductUOM;
    displayUomDetails?: ProductUOM;
    rrp?: number | null;
    isPriceAlert?: boolean;
    readonly isSpecialOffer?: boolean;
    isTax?: boolean;
    batchDetails?: ItemBatchInfo;
};

export type INVHeader = {
    invid?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    invoiceType?: 'invoice' | 'credit';
    invoiceDate?: Date;
    dueDate?: Date | null;
    soDueDate?: Date | null;
    customerID?: string;
    customerName?: string | null;
    customerCode?: string | null;
    customerTags?: string | null;
    customerEORI?: string | null;
    customerNominalCode?: string | null;
    agentID?: string | null;
    agentName?: string | null;
    warehouseID?: string;
    vatGroup?: string;
    vatGroupNominal?: string | null;
    agentNominalCode?: string | null;
    currency?: string | null;
    currencyRate?: number;
    creditTerm?: number;
    creditTermDescription?: string | null;
    creditDays?: number;
    vatNumber?: string | null;
    invoiceDiscount?: number;
    invoiceDiscountVAT?: number;
    invTaxGroup?: string | null;
    headerID?: number | null;
    printCount?: number | null;
    exported?: boolean;
    invoiceNotes?: string | null;
    appliedVATDiscount?: number | null;
    confirmExport?: boolean | null;
    exportReference?: string | null;
    ediTransfer?: Date | null;
    billingAddress?: Address;
    shippingAddress?: Address;
    warehouseAddress?: Address;
    documents?: string | null;
    emailSent?: boolean | null;
    remainingBalance?: number | null;
    remainingBalanceUpdateUTC?: Date | null;
    readonly ediTransfered?: boolean;
    totalCount?: number;
    isconsignment?: boolean;
    readonly exportConfirmed?: boolean;
    paidAmount?: number | null;
    readonly docType?: string | null;
    readonly docId?: string | null;
    soNumbers?: string | null;
    soRefrences?: string | null;
    soAuthor?: string | null;
    soDate?: Date | null;
    nominalAccount?: string | null;
    readonly isCredit?: boolean;
    customerLedgerCode?: string | null;
    hasConditionalDiscounts?: boolean;
    relatedDocument?: Array<DocumentType> | null;
    customFields?: {
        [key: string]: (string | null);
    } | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum invoiceType {
    INVOICE = 'invoice',
    CREDIT = 'credit'
}

export type INVTotals = {
    totalNet?: number;
    totalNetLcy?: number;
    totalGross?: number;
    totalGrossLcy?: number;
    totalDiscount?: number;
    totalVAT?: number;
    readonly totalTax?: number;
    totalPaid?: number | null;
    totalDue?: number | null;
    total?: number;
    uomTotals?: Array<UOMTotal> | null;
    totalQtyInDefaultUOM?: number | null;
    totalQty?: number;
    totalUnreceivedValue?: number;
    totalWeight?: number;
    totalDiscountPercent?: number;
    readonly totalDiscountPercent5?: number;
    totalSize?: number;
    totalNetWeightInGr?: number;
    totalNetWeightInKg?: number;
    totalNetWeightInLb?: number;
    totalGrossWeightInGr?: number;
    totalGrossWeightInKg?: number;
    totalGrossWeightInLb?: number;
    totalBillingQty?: number;
    contactBalance?: number;
    totalUndiscounted?: number;
    vatBreakdown?: Array<VATBreakdown> | null;
    depositRequired?: number | null;
    totalSaving?: number | null;
    soTotal?: number | null;
    soPaymentTotal?: number | null;
};

export type IdName = {
    id?: number;
    name?: string | null;
};

export type IdValue_2 = {
    id?: number;
    value?: ItemBatchBase;
};

export type InShpTotals = {
    packagesCount?: number;
    itemsCount?: number;
    itemsUniqueCount?: number;
};

export type InboundASN = {
    items?: Array<ASNItem> | null;
    header?: InboundASNHeader;
    containers?: Array<ASNContainer> | null;
    rcTs?: Array<(number)> | null;
    readonly docType?: string | null;
    readonly docId?: string | null;
};

export type InboundASNHeader = {
    inASNId?: number;
    warehouseId?: string;
    poid?: number;
    vendorReference?: string | null;
    createdUTC?: Date | null;
    inSHPId?: number | null;
    inASNStatus?: number | null;
    palletCount?: number | null;
    inSHPStatus?: number | null;
    inASNStatusName?: string | null;
    inASNStatusState?: string | null;
    thirdPartyStatus?: number | null;
};

export type InboundDocument = {
    document?: GenericDocumentDetails;
    lines?: Array<InboundDocumentLine> | null;
    costs?: Array<InboundDocumentCost> | null;
    merge?: boolean;
};

export type InboundDocumentCarrierInfo = {
    carrierId: number;
    trackingNumber: string;
};

export type InboundDocumentCost = {
    id?: number;
    name?: string | null;
    reference?: string | null;
    cost?: MoneyCurrencyRate;
    contact?: StringIdName;
};

export type InboundDocumentLine = {
    id?: number;
    item?: DocumentItemInfo;
    uomId?: number;
    quantity?: number;
    contactReference?: string | null;
    price?: Price;
    additionalCost?: Price;
    restrictBatchId?: number | null;
    batches?: Array<ItemBatchInfo> | null;
    substituteUom?: Array<AlternativeUom> | null;
};

export type InboundDocumentReceive = {
    date?: Date | null;
    warehouseCode?: string | null;
    importReference?: string | null;
    documentReferenceType?: 'DELIVERY_NOTE' | 'INVOICE' | null;
    documentReference?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    receivingNotes?: string | null;
    merge?: boolean | null;
    costs?: Array<InboundDocumentReceiveCost> | null;
    items?: Array<InboundDocumentReceiveItem> | null;
    carrier?: InboundDocumentCarrierInfo;
};

export enum documentReferenceType {
    DELIVERY_NOTE = 'DELIVERY_NOTE',
    INVOICE = 'INVOICE'
}

export type InboundDocumentReceiveCost = {
    costId: number;
    cost: MoneyCurrencyRate;
    reference: string;
    contactCode: string;
};

export type InboundDocumentReceiveItem = {
    lineId: number;
    qty?: number;
    uomId?: number | null;
    contactReference?: string | null;
    price?: Price;
    additionalCost?: Price;
    alternativeSku?: string | null;
    batch?: IdValue_2;
    bin?: string | null;
    weight?: number | null;
    weightTotal?: boolean;
};

export type InboundDocumentResponseData = {
    data?: InboundDocument;
};

export type InboundReceiveMultipleDocumentsRequest = {
    receiveDate?: Date | null;
    contactId?: Array<(string)> | null;
    items?: Array<InboundReceiveMultipleDocumentsRequestItem> | null;
};

export type InboundReceiveMultipleDocumentsRequestItem = {
    documentLineId?: number | null;
    /**
     * @deprecated
     */
    sku?: string | null;
    item?: string | null;
    qty?: string | null;
    uom?: string | null;
    price?: string | null;
    discount?: string | null;
    batch?: string | null;
    bin?: string | null;
    weight?: string | null;
    document?: string | null;
    carrier?: string | null;
    carrierTracking?: string | null;
    '[key: string]': (unknown | number | string) | undefined;
};

export type InboundReceiveRequest = {
    receiveDate?: Date | null;
    warehouseCode?: string | null;
    receiveReference?: string | null;
    receiveReferenceType?: string | null;
    currency?: string | null;
    currencyRate?: number | null;
    items?: Array<InboundReceiveRequestItem> | null;
    /**
     * @deprecated
     */
    lines?: Array<InboundReceiveRequestItem> | null;
};

export type InboundReceiveRequestItem = {
    documentLineId?: number | null;
    /**
     * @deprecated
     */
    sku?: string | null;
    item?: string | null;
    qty?: string | null;
    uom?: string | null;
    price?: string | null;
    discount?: string | null;
    batch?: string | null;
    bin?: string | null;
    weight?: string | null;
    '[key: string]': (unknown | number | string) | undefined;
};

export type InboundSHP = {
    items?: Array<ASNItem> | null;
    header?: InboundSHPHeader;
    inboundASNs?: Array<InboundASN> | null;
    totals?: InShpTotals;
    readonly docType?: string | null;
    readonly docId?: string | null;
};

export type InboundSHPHeader = {
    inSHPId?: number;
    shipperName?: string | null;
    shipperSID?: string | null;
    bolNumber?: string | null;
    sealNumbers?: string | null;
    carrierScac?: string | null;
    proNumber?: string | null;
    shipETD_UTC?: Date | null;
    shipETA_UTC?: Date | null;
    shipDate_UTC?: Date | null;
    orderedDate?: Date | null;
    readonly loadingDate?: Date | null;
    readonly departureDate?: Date | null;
    readonly arrivalDate?: Date | null;
    readonly containerNumber?: string | null;
    containerType?: string | null;
    shipStatus?: number | null;
    inSHPReference?: string | null;
    warehouses?: string | null;
    asnpOs?: string | null;
    asnCount?: number | null;
    customFields?: {
        [key: string]: (string | null);
    } | null;
};

export type InboundStatus = {
    name?: string | null;
    state?: string | null;
};

export type Int32IdName = {
    id?: number;
    name?: string | null;
};

export type Int32ResponseData = {
    data?: number;
};

export type Int32SuccessMessage = {
    success?: boolean;
    message?: string | null;
    warning?: string | null;
    objectId?: string | null;
    props?: unknown;
    messages?: Array<(string)> | null;
    tag?: number;
    readonly value?: number;
};

export type InventoryModel = {
    id?: number;
    name?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    batchEntryMode?: 'NONE' | 'ACTIVE' | 'STRICT';
    batchDataMode?: 'BEST_BEFORE_DATE' | 'FULL_BATCH_INFO' | 'PRODUCTION_DATE' | 'LOT_NUMBER' | 'SERIAL_NUMBER' | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    binMode?: 'NONE' | 'ACTIVE' | 'STRICT';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    cogs?: 'FIFO' | 'WAC';
    batchFields?: Array<(string)> | null;
    requiresQc?: boolean;
    batchNameFormat?: string | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum batchEntryMode {
    NONE = 'NONE',
    ACTIVE = 'ACTIVE',
    STRICT = 'STRICT'
}

export enum batchDataMode {
    BEST_BEFORE_DATE = 'BEST_BEFORE_DATE',
    FULL_BATCH_INFO = 'FULL_BATCH_INFO',
    PRODUCTION_DATE = 'PRODUCTION_DATE',
    LOT_NUMBER = 'LOT_NUMBER',
    SERIAL_NUMBER = 'SERIAL_NUMBER'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum binMode {
    NONE = 'NONE',
    ACTIVE = 'ACTIVE',
    STRICT = 'STRICT'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum cogs {
    FIFO = 'FIFO',
    WAC = 'WAC'
}

export type InventoryProfile = {
    readonly id?: string | null;
    profileName?: string | null;
};

export type InventoryProfileDetail = {
    readonly id?: string | null;
    marketplaces?: Array<StringIdName> | null;
    percentage?: number;
    inventoryUpdateMin?: number | null;
    inventoryUpdateMax?: number | null;
    sourceField?: string | null;
    staticAmount?: number | null;
};

export type InventoryProfileUnpagedListResults = {
    results?: Array<InventoryProfile> | null;
};

export type InventoryProfileWithDetails = {
    readonly id?: string | null;
    profileName?: string | null;
    details?: Array<InventoryProfileDetail> | null;
};

export type InventoryProfileWithDetailsResponseData = {
    data?: InventoryProfileWithDetails;
};

export type InventorySyncStatus = {
    sync?: boolean;
    lastSync?: Date | null;
    min?: number | null;
    max?: number | null;
    fulfillmentWarehouses?: Array<GuidIdName> | null;
};

export type InviteProcessRequest = {
    token: string;
    accept: boolean;
    profile?: InviteProfile;
};

export type InviteProfile = {
    nameFirst: string;
    nameLast: string;
    password1: string;
    password2: string;
};

export type InviteStatusRequest = {
    token: string;
};

export type InviteStatusResponse = {
    profileRequired?: boolean;
    inviteDescription?: string | null;
    profile?: UserProfileBase;
};

export type InviteStatusResponseResponseData = {
    data?: InviteStatusResponse;
};

export type InvoiceItem = {
    docId?: string | null;
    isCredit?: boolean;
};

export type ItemAppInfo = {
    category?: string | null;
    hidden?: boolean;
    new?: boolean;
    newEndDate?: Date | null;
    sortValue?: string | null;
};

export type ItemBatchBase = {
    name?: string | null;
    productionDate?: Date | null;
    bestBeforeDate?: Date | null;
    fields?: {
        [key: string]: (string | null);
    } | null;
};

export type ItemBatchInfo = {
    readonly id?: number;
    name?: string | null;
    productionDate?: Date | null;
    bestBeforeDate?: Date | null;
    readonly fields?: {
        [key: string]: (string);
    } | null;
};

export type ItemBatchInfoUnpagedListResults = {
    results?: Array<ItemBatchInfo> | null;
};

export type ItemCategory = {
    id?: number;
    name?: string | null;
    nominal?: string | null;
    taxType?: StringIdName;
    hsCode?: string | null;
    defaultInventoryModel?: number | null;
    itemSkuPrefix?: string | null;
    discount?: number | null;
};

export type ItemCategoryResponseData = {
    data?: ItemCategory;
};

export type ItemCategoryUnpagedListResults = {
    results?: Array<ItemCategory> | null;
};

export type ItemCategoryUpsert = {
    /**
     * Name, Required for new category
     */
    name?: string | null;
    nominal?: string | null;
    /**
     * TaxType Code, Required for new category
     */
    taxType?: string | null;
    hsCode?: string | null;
    defaultInventoryModel?: number | null;
    itemSkuPrefix?: string | null;
    discount?: number | null;
};

export type ItemContactInfoUpsert = {
    sku?: string | null;
    title?: string | null;
    defatulUomId?: number | null;
};

export type ItemDetails = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    defaultUomId?: number;
    inventoryModelId?: number;
    isPurchasable?: boolean;
    isSellable?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE';
    isEol?: boolean;
    parentSku?: string | null;
    identifier?: ItemIdentifier;
    brand?: string | null;
    category?: string | null;
    department?: string | null;
    inventoryModel?: string | null;
    inventoryProfile?: string | null;
    inventory?: ItemInventory;
    app?: ItemAppInfo;
    image?: ItemImage;
    tags?: Array<Int32IdName> | null;
    specs?: Array<ItemSpec> | null;
    commodity?: ItemHarmonization;
    uom?: ItemUom;
};

export type ItemHarmonization = {
    hsCode?: string | null;
    countryOfOrigin?: string | null;
    readonly countryOfOriginName?: string | null;
};

export type ItemIdentifier = {
    ean?: string | null;
    upc?: string | null;
    asin?: string | null;
    isbn?: string | null;
};

export type ItemImage = {
    id?: string | null;
    small?: string | null;
    large?: string | null;
    medium?: string | null;
    original?: string | null;
    notes?: string | null;
    signature?: string | null;
};

export type ItemImageUnpagedListResults = {
    results?: Array<ItemImage> | null;
};

export type ItemInventory = {
    onHand?: number | null;
    available?: number | null;
    onOrder?: number | null;
    blocked?: number | null;
    reserved?: number | null;
    uninvoiced?: number | null;
    availableOtherWarehouses?: number | null;
    onOrderEta?: Date | null;
    binLocation?: string | null;
    binPriority?: number | null;
};

export type ItemInventory3dSummary = {
    warehouse?: GuidIdName;
    onHand?: number | null;
    binLocation?: string | null;
    quarantined?: boolean;
    batchDetails?: ItemBatchInfo;
};

export type ItemInventory3dSummaryUnpagedListResults = {
    results?: Array<ItemInventory3dSummary> | null;
};

export type ItemInventoryByItemWarehouse = {
    onHand?: number | null;
    available?: number | null;
    onOrder?: number | null;
    warehouseCode?: string | null;
    itemSku?: string | null;
    itemTitle?: string | null;
    itemUom?: string | null;
    lastModified?: Date | null;
};

export type ItemInventoryByItemWarehouseDetailed = {
    onHand?: number | null;
    available?: number | null;
    onOrder?: number | null;
    warehouseCode?: string | null;
    itemSku?: string | null;
    itemTitle?: string | null;
    itemUom?: string | null;
    lastModified?: Date | null;
    binLocation?: string | null;
    batchDetails?: ItemBatchInfo;
};

export type ItemInventoryByItemWarehouseDetailedUnpagedListResults = {
    results?: Array<ItemInventoryByItemWarehouseDetailed> | null;
};

export type ItemInventoryByItemWarehouseUnpagedListResults = {
    results?: Array<ItemInventoryByItemWarehouse> | null;
};

export type ItemInventoryDrilldown = {
    readonly document?: string | null;
    documentType?: string | null;
    documentId?: string | null;
    details?: string | null;
    date?: Date | null;
    qty?: number;
    qtyUom?: number;
    uomId?: number;
    uomName?: string | null;
    notes?: string | null;
};

export type ItemInventoryDrilldownListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ItemInventoryDrilldown> | null;
};

export type ItemInventoryLog = {
    warehouse?: GuidIdName;
    date?: Date;
    code?: string | null;
    price?: Money;
    weight?: number | null;
    readonly qty?: number;
    uomName?: string | null;
    balance?: number;
    balanceUom?: string | null;
    document?: string | null;
    rootDocument?: string | null;
    documentDetails?: string | null;
    bin?: string | null;
    batchInfo?: ItemBatchInfo;
};

export type ItemInventoryLogListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ItemInventoryLog> | null;
};

export type ItemInventorySummary = {
    inventories?: Array<ItemInventoryWithWarehouse> | null;
    summary?: Array<ItemInventoryWithWarehouseGroup> | null;
};

export type ItemInventorySummaryResponseData = {
    data?: ItemInventorySummary;
};

export type ItemInventoryWithWarehouse = {
    warehouse?: GuidIdName;
    onHand?: number | null;
    available?: number | null;
    blocked?: number | null;
    onOrder?: number | null;
    reserved?: number | null;
    uninvoiced?: number | null;
    directDispatch?: number | null;
    backToBack?: number | null;
    inTransit?: number | null;
    achievable?: number | null;
    weight?: number | null;
    cost?: MoneyWithLcy;
    landedCost?: MoneyWithLcy;
    wacValue?: number | null;
};

export type ItemInventoryWithWarehouseGroup = {
    warehouse?: GuidIdName;
    onHand?: number | null;
    available?: number | null;
    blocked?: number | null;
    onOrder?: number | null;
    reserved?: number | null;
    uninvoiced?: number | null;
    directDispatch?: number | null;
    backToBack?: number | null;
    inTransit?: number | null;
    achievable?: number | null;
    weight?: number | null;
    cost?: MoneyWithLcy;
    landedCost?: MoneyWithLcy;
    wacValue?: number | null;
    warehouseGroup?: GuidIdName;
};

export type ItemLabel = {
    id?: number;
    quantity?: number;
    itemWeight?: number | null;
    batchMode?: 'BEST_BEFORE_DATE' | 'FULL_BATCH_INFO' | 'PRODUCTION_DATE' | 'LOT_NUMBER' | 'SERIAL_NUMBER' | null;
    item?: ItemLookup;
    batch?: ItemBatchInfo;
};

export enum batchMode {
    BEST_BEFORE_DATE = 'BEST_BEFORE_DATE',
    FULL_BATCH_INFO = 'FULL_BATCH_INFO',
    PRODUCTION_DATE = 'PRODUCTION_DATE',
    LOT_NUMBER = 'LOT_NUMBER',
    SERIAL_NUMBER = 'SERIAL_NUMBER'
}

export type ItemLabelUnpagedListResults = {
    results?: Array<ItemLabel> | null;
};

export type ItemLookup = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    defaultUomId?: number;
    inventoryModelId?: number;
    isPurchasable?: boolean;
    isSellable?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE';
    isEol?: boolean;
};

export type ItemLookupBasic = {
    id?: string;
    sku?: string | null;
    title?: string | null;
};

export type ItemLookupDocument = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    defaultUomId?: number;
    inventoryModelId?: number;
    isPurchasable?: boolean;
    isSellable?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE';
    isEol?: boolean;
    imageUrl?: string | null;
    showWeight?: boolean;
    showSize?: boolean;
    contactReference?: string | null;
    extraFields?: string | null;
    weightValue?: number | null;
    shelfQty?: number;
    inventoryAvailable?: number;
    inventoryModel?: InventoryModel;
};

export type ItemLookupDocumentUnpagedListResults = {
    results?: Array<ItemLookupDocument> | null;
};

export type ItemLookupImage = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    defaultUomId?: number;
    inventoryModelId?: number;
    isPurchasable?: boolean;
    isSellable?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE';
    isEol?: boolean;
    imageUrl?: string | null;
};

export type ItemLookupImageResponseData = {
    data?: ItemLookupImage;
};

export type ItemOnOrderDetail = {
    baseType?: string | null;
    baseId?: string | null;
    partnerName?: string | null;
    expectedDate?: Date | null;
    qty?: number;
    uom?: number;
};

export type ItemPriceLookup = {
    value?: number | null;
    discount?: number | null;
    manualPrice?: number | null;
    rrp?: number | null;
    qtyBasedDiscounts?: boolean | null;
};

export type ItemPriceLookupResponseData = {
    data?: ItemPriceLookup;
};

export type ItemQuickViewResults = {
    readonly document?: string | null;
    documentType?: string | null;
    documentId?: string | null;
    details?: string | null;
    date?: Date | null;
    qty?: number;
    uomName?: string | null;
    price?: Money;
};

export type ItemQuickViewResultsListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ItemQuickViewResults> | null;
};

export type ItemSpec = {
    specId?: number;
    name?: string | null;
    value?: string | null;
};

export type ItemSpecUnpagedListResults = {
    results?: Array<ItemSpec> | null;
};

export type ItemTag = {
    tagId?: number;
    tagName?: string | null;
    tagColor?: string | null;
    isPromo?: boolean;
    isClearance?: boolean;
    portalView?: boolean;
    autoAppend?: boolean;
};

export type ItemTagUnpagedListResults = {
    results?: Array<ItemTag> | null;
};

export type ItemTagsUpdate = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * <li><b>ADD</b>: Add tags to item</li>
     * <li><b>SET</b>: Set tags to item, Adds missing tags, and removed tags that or not in list</li>
     * <li><b>REMOVE</b>: Remove tags from item</li>
     * </ul>
     *
     */
    mode: 'add' | 'set' | 'remove';
    sku: Array<(string)>;
    tagId: Array<(number)>;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>ADD</b>: Add tags to item</li>
 * <li><b>SET</b>: Set tags to item, Adds missing tags, and removed tags that or not in list</li>
 * <li><b>REMOVE</b>: Remove tags from item</li>
 * </ul>
 *
 */
export enum mode {
    ADD = 'add',
    SET = 'set',
    REMOVE = 'remove'
}

export type ItemUnpagedListResults = {
    results?: Array<SalesOverviewSegmentItem> | null;
};

export type ItemUom = {
    id?: number;
    name?: string | null;
    shelfQty?: number | null;
    weightNet?: number | null;
    weightGross?: number | null;
    weightUom?: 'kg' | 'g' | 'oz' | 'lb' | null;
    height?: number;
    width?: number;
    length?: number;
    dimensionUom?: 'cm' | 'ft' | 'in' | 'm' | 'mm' | null;
    volume?: string | null;
    ean?: string | null;
    skuIdentifier?: string | null;
    readonly cbm?: number;
};

export type ItemUomUnpagedListResults = {
    results?: Array<ItemUom> | null;
};

export type ItemVendorCatalogUpsert = {
    price?: number | null;
    currency?: string | null;
    discount?: number | null;
    minimumOrder?: number | null;
    defaultVendor?: boolean | null;
    fixedCost?: number | null;
    fixedPerncetage?: number | null;
    uomId?: number | null;
    orderQtys?: number | null;
};

export type ItemsCatalogUpsert = {
    /**
     * Item Identifier, SKU, EAN, UPC etc
     */
    item?: string | null;
    sort_value?: string | null;
};

export type ItemsCatalogUpsertBulkUpsertRequest = {
    items?: Array<ItemsCatalogUpsert> | null;
    readonly source?: string | null;
    params?: Array<BulkInsertRequestParam> | null;
};

export type KitItem = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    invoiceDetailId?: number;
    childPartQty?: number;
    childPartQtyLineTotal?: number;
    costPrice?: number;
    sellPriceIncLineTotal?: number;
    vatCode?: string | null;
    vatRate?: number;
    vatAmount?: number;
    readonly lineTotal?: number;
};

export type KpiDashboard = {
    id?: string;
    title?: string | null;
    columns?: number;
    locked?: boolean;
    accessToken?: string | null;
};

export type KpiDashboardUnpagedListResults = {
    results?: Array<KpiDashboard> | null;
};

export type KpiDashboardUpsert = {
    title: string;
    columns: number;
    locked?: boolean;
};

export type KpiDashboardWithWidgets = {
    id?: string;
    title?: string | null;
    columns?: number;
    locked?: boolean;
    accessToken?: string | null;
    widgets?: Array<KpiWidgetDetails> | null;
};

export type KpiDashboardWithWidgetsResponseData = {
    data?: KpiDashboardWithWidgets;
};

export type KpiWidgetConfigDetail = {
    type: string;
    parameters?: Array<ConfigurationParameter> | null;
    id?: number;
    title?: string | null;
};

export type KpiWidgetConfigDetailUnpagedListResults = {
    results?: Array<KpiWidgetConfigDetail> | null;
};

export type KpiWidgetDetails = {
    id?: number;
    row?: number;
    col?: number;
    width?: number;
    height?: number;
    type?: string | null;
};

export type KpiWidgetPositionRequest = {
    row: number;
    col: number;
    width: number;
    height: number;
    id: number;
};

export type LinkedServices = {
    shippingService?: ItemLookupBasic;
    giftwrapService?: ItemLookupBasic;
    giftwrapServiceTag?: StringIdName;
    orderDiscountServiceId?: ItemLookupBasic;
};

export type LinkedServicesResponseData = {
    data?: LinkedServices;
};

export type LinkedShp = {
    shpId?: number;
    readonly shp?: string | null;
    carrierName?: string | null;
    carrierService?: string | null;
    carrierReference?: string | null;
    labelUrl?: string | null;
    status?: string | null;
};

export type ListItemDetail = {
    id?: string;
    sku?: string | null;
    title?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM';
    defaultUomId?: number;
    inventoryModelId?: number;
    isPurchasable?: boolean;
    isSellable?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    pricing?: 'QUANTITY' | 'WEIGHT' | 'SIZE';
    isEol?: boolean;
    imageUrl?: string | null;
};

export type ListItemDetailListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ListItemDetail> | null;
};

export type ListResultsPo = {
    contact?: ContactDetails;
    document?: DocumentProperties;
    customFields?: Array<CustomFieldResult> | null;
    id?: string | null;
    warehouseName?: string | null;
    isCredit?: boolean;
    date?: Date;
    currency?: string | null;
    etaDate?: Date | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'DRAFT' | 'CONFIRMED' | 'CANCELLED';
    contactReference?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    receiveStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    billingStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE';
    totalNet?: number;
    totalGross?: number;
    totalTax?: number;
    directDelivery?: boolean;
    backorder?: boolean;
    finalized?: boolean;
    due?: boolean;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum status2 {
    DRAFT = 'DRAFT',
    CONFIRMED = 'CONFIRMED',
    CANCELLED = 'CANCELLED'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum receiveStatus2 {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum billingStatus {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE'
}

export type ListResultsPoListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ListResultsPo> | null;
};

export type ListResultsSo = {
    contact?: ContactDetails;
    document?: DocumentProperties;
    customFields?: Array<CustomFieldResult> | null;
    id?: string | null;
    warehouseName?: string | null;
    isCredit?: boolean;
    date?: Date;
    totalNet?: number;
    totalGross?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'DRAFT' | 'CONFIRMED' | 'CANCELLED';
    currency?: string | null;
    isParked?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    packingStage?: 'PENDING' | 'PARTIALLY' | 'COMPLETE';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    packingPendingStage?: 'PENDING' | 'PARTIALLY' | 'COMPLETE';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    invoiceStage?: 'PENDING' | 'PARTIALLY' | 'COMPLETE';
    invoiceProcessed?: boolean;
    contactReference?: string | null;
    dispatchStart?: Date;
    dispatchDue?: Date;
    isBackOrder?: boolean;
    pickingDocPrint?: number;
    generatedUtcDate?: Date;
    deliveryStatus?: number;
    carrierReferenceNumber?: string | null;
    hasPickingNotes?: boolean;
    pckId?: number | null;
    thirdPartyFulfilmentStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE' | 'EXCEPTION' | null;
    paymentStatus?: 'PENDING' | 'PARTIALLY' | 'COMPLETE' | null;
    mergedIntoSo?: string | null;
    isResend?: boolean;
    itemsDue?: number;
    assignedCarrierName?: string | null;
    shipping?: DocumentAddress;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum packingStage {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum packingPendingStage {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum invoiceStage {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE'
}

export enum thirdPartyFulfilmentStatus {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE',
    EXCEPTION = 'EXCEPTION'
}

export enum paymentStatus2 {
    PENDING = 'PENDING',
    PARTIALLY = 'PARTIALLY',
    COMPLETE = 'COMPLETE'
}

export type ListResultsSoListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ListResultsSo> | null;
};

export type ListingBulkSearch = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    linked?: 'ANY' | 'LINKED' | 'UNLINKED';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    fulfillment?: 'ANY' | 'MERCHANT' | 'MARKETPLACE';
    includeInventory?: string | null;
    search?: string | null;
    sellerSku?: Array<(string)> | null;
    includeValues?: boolean | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum linked {
    ANY = 'ANY',
    LINKED = 'LINKED',
    UNLINKED = 'UNLINKED'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum fulfillment {
    ANY = 'ANY',
    MERCHANT = 'MERCHANT',
    MARKETPLACE = 'MARKETPLACE'
}

export type ListingDetail = {
    mpSku?: string | null;
    marketplaceItemId?: string | null;
    listingTitle?: string | null;
    listingUrl?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    fulfillment?: 'MERCHANT' | 'MARKETPLACE';
    qtyListed?: number | null;
    linkedItem?: ListingLinkedItem;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum fulfillment2 {
    MERCHANT = 'MERCHANT',
    MARKETPLACE = 'MARKETPLACE'
}

export type ListingDetailInventory = {
    onHand?: number | null;
    available?: number | null;
    wacValue?: Money;
};

export type ListingDetailListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ListingDetail> | null;
};

export type ListingDetailUnpagedListResults = {
    results?: Array<ListingDetail> | null;
};

export type ListingLinkedItem = {
    item?: ItemLookupBasic;
    uom?: IdName;
    inventory?: ListingDetailInventory;
};

export type ListingSyncStatus = {
    lastSync?: Date | null;
    linkedItems?: number | null;
    unlinkedItems?: number | null;
};

export type LoginEmailRequest = {
    deviceId?: string | null;
    deviceSignature?: string | null;
    email: string;
    scope?: string | null;
    captcha: string;
    returnUrl?: string | null;
    tid?: string | null;
};

export type LoginEmailResponse = {
    requestId?: string | null;
    email?: string | null;
    sso?: Array<(string)> | null;
    captchaValidated?: boolean;
};

export type LoginEmailResponseResponseData = {
    data?: LoginEmailResponse;
};

export type LoginMfaNotifyRequest = {
    deviceId?: string | null;
    deviceSignature?: string | null;
    requestId: string;
    type: string;
};

export type LoginMfaRequest = {
    deviceId?: string | null;
    deviceSignature?: string | null;
    requestId: string;
    type: string;
    response: string;
    trustDevice?: boolean;
};

export type LoginPasswordMfaMethod = {
    readonly id?: string | null;
    title?: string | null;
    type?: string | null;
    description?: string | null;
    isPrimary?: boolean;
    canDelete?: boolean;
    instructions?: string | null;
    notify?: boolean;
    responseType?: string | null;
    responseLength?: number;
    publicKey?: string | null;
};

export type LoginPasswordRequest = {
    deviceId?: string | null;
    deviceSignature?: string | null;
    requestId: string;
    password: string;
    captcha?: string | null;
};

export type LoginPasswordResponse = {
    displayMessage?: string | null;
    token?: string | null;
    redirectUrl?: string | null;
    profile?: UserProfileBase;
    billing?: boolean;
    requiredAction?: AuthResponseAction;
    mfa?: Array<LoginPasswordMfaMethod> | null;
    organizations?: Array<AuthResponseOrganisation> | null;
};

export type LoginPasswordResponseResponseData = {
    data?: LoginPasswordResponse;
};

export type MagicLinkRequest = {
    email: string;
    captcha: string;
};

export type MarketplaceDetails = {
    id?: string | null;
    active?: boolean;
    type?: string | null;
    name?: string | null;
    marketplaceFulfilmentWarehouse?: MarketplaceFulfilmentWarehouse;
    ordersSync?: SyncStatus;
    pricesSync?: SyncStatus;
    inventorySync?: SyncStatus;
    exception?: MarketplaceErrorDetails;
};

export type MarketplaceDetailsExtended = {
    id?: string | null;
    active?: boolean;
    type?: string | null;
    name?: string | null;
    marketplaceFulfilmentWarehouse?: MarketplaceFulfilmentWarehouse;
    pricesSync?: SyncStatus;
    exception?: MarketplaceErrorDetails;
    ordersSync?: OrdersSyncStatus;
    inventorySync?: InventorySyncStatus;
    listingSync?: ListingSyncStatus;
    configuration?: Array<SerializableConfigItemWithValue> | null;
};

export type MarketplaceDetailsExtendedResponseData = {
    data?: MarketplaceDetailsExtended;
};

export type MarketplaceDetailsUnpagedListResults = {
    results?: Array<MarketplaceDetails> | null;
};

export type MarketplaceErrorDetails = {
    date?: Date;
    message?: string | null;
};

export type MarketplaceFulfilmentWarehouse = {
    id?: string;
    name?: string | null;
    country?: string | null;
};

export type Message = {
    id?: number;
    alertDate?: Date;
    groupName?: string | null;
    message?: string | null;
    dismissedDate?: Date | null;
    dismissedBy?: string | null;
};

export type MessageUnpagedListResults = {
    results?: Array<Message> | null;
};

export type MfaDeviceSetupConfirmRequest = {
    mfaType: string;
    token: string;
    response: string;
};

export type MfaDeviceSetupRequest = {
    mfaType: string;
    info?: string | null;
};

export type MfaDeviceSetupResponse = {
    token: string;
    imageData?: string | null;
};

export type MfaDeviceSetupResponseResponseData = {
    data?: MfaDeviceSetupResponse;
};

export type MfaMethod = {
    readonly id?: string | null;
    title?: string | null;
    type?: string | null;
    description?: string | null;
    isPrimary?: boolean;
    canDelete?: boolean;
};

export type MfaMethodsResponse = {
    used?: Array<MfaMethod> | null;
    available?: Array<MfaMethod> | null;
};

export type MfaMethodsResponseResponseData = {
    data?: MfaMethodsResponse;
};

export type MfaSetupConfirmResponse = {
    recoveryCodes?: Array<(string)> | null;
};

export type MfaSetupConfirmResponseResponseData = {
    data?: MfaSetupConfirmResponse;
};

export type Money = {
    currencyCode?: string | null;
    amount?: number;
};

export type MoneyCurrencyRate = {
    currencyCode?: string | null;
    amount?: number;
    currencyRate?: number | null;
};

export type MoneyWithLcy = {
    currencyCode?: string | null;
    amount?: number;
    amountLcy?: number;
};

export type Monitor = {
    id?: number;
    name?: string | null;
    active?: boolean;
    conditions?: Array<MonitorCondition> | null;
    alerts?: Array<MonitorAlert> | null;
};

export type MonitorAlert = {
    id?: number;
    user?: Int32IdName;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    alertType?: 'NOTIFICATION' | 'EMAIL' | 'SMS';
    readonly interval?: number;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum alertType {
    NOTIFICATION = 'NOTIFICATION',
    EMAIL = 'EMAIL',
    SMS = 'SMS'
}

export type MonitorBase = {
    id?: number;
    name?: string | null;
    active?: boolean;
};

export type MonitorBaseUnpagedListResults = {
    results?: Array<MonitorBase> | null;
};

export type MonitorCondition = {
    id?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    level?: 'ERROR' | 'WARNING';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    eventType?: 'PIPELINE' | 'EDI' | 'OUTGOING_EMAIL';
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum level {
    ERROR = 'ERROR',
    WARNING = 'WARNING'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum eventType {
    PIPELINE = 'PIPELINE',
    EDI = 'EDI',
    OUTGOING_EMAIL = 'OUTGOING_EMAIL'
}

export type MonitorResponseData = {
    data?: Monitor;
};

export type MonitorUpsert = {
    name: string;
    active?: boolean;
    conditions: Array<MonitorUpsertCondition>;
    alerts: Array<MonitorUpsertAlert>;
};

export type MonitorUpsertAlert = {
    userId: number;
    alertType: 'NOTIFICATION' | 'EMAIL' | 'SMS';
};

export type MonitorUpsertCondition = {
    eventType: 'PIPELINE' | 'EDI' | 'OUTGOING_EMAIL';
};

export type MpBulkInsertRequest = {
    items?: Array<MpItemBulkInsert> | null;
    params?: Array<BulkInsertRequestParam> | null;
};

export type MpItemBulkInsert = {
    /**
     * Item SKU, EAN or any identifier
     */
    item?: string | null;
    /**
     * Item quantity, default is 1
     */
    qty?: string | null;
};

export type NameValue_1 = {
    name?: string | null;
    value?: string | null;
};

export type NewDocumentNote = {
    note?: string | null;
    classes?: string | null;
};

export type Notification = {
    id?: number;
    createdAtUtc?: Date;
    title?: string | null;
    message?: string | null;
    isRead?: boolean;
    url?: string | null;
    progress?: number | null;
    type?: string | null;
};

export type NotificationCount = {
    notifications?: number;
    emailQueue?: number;
};

export type NotificationCountResponseData = {
    data?: NotificationCount;
};

export type NotificationListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<Notification> | null;
};

export type OauthAuthenticationRequest = {
    deviceId?: string | null;
    deviceSignature?: string | null;
    scope?: string | null;
    returnUrl?: string | null;
    tid?: string | null;
    requestId: string;
    provider: string;
    autoCode: string;
};

export type OrdersSyncStatus = {
    sync?: boolean;
    lastSync?: Date | null;
    contact?: GuidIdName;
    minimumDate?: Date | null;
    warehouse?: GuidIdName;
};

export type Organisation = {
    id?: string | null;
    name?: string | null;
    logo?: string | null;
    taxNumber?: string | null;
    appUrl?: string | null;
    currency?: string | null;
    readonly currencySymbol?: string | null;
};

export type OutboundDocument = {
    documentType?: string | null;
    documentId?: number;
    isBackOrder?: boolean;
    destinationName?: string | null;
    documentDate?: Date;
    soStatusPack?: number;
    unishippedPacks?: number;
    shippingAddressName?: string | null;
    shippingAttentionName?: string | null;
    shippingAddress1?: string | null;
    shippingAddress2?: string | null;
    shippingTown?: string | null;
    shippingState?: string | null;
    shippingZip?: string | null;
    shippingCountry?: string | null;
    shippingPhone?: string | null;
    shippingEmail?: string | null;
    deliveryStart?: Date;
    deliveryDue?: Date;
    packedPercentage?: number;
    documentReference?: string | null;
};

export type PO = {
    header?: POHeader;
    lines?: Array<PODetail> | null;
    totals?: POTotals;
    tags?: Array<DocumentTag> | null;
    readonly docType?: string | null;
    readonly docId?: string | null;
    readonly isCredit?: boolean;
};

export type PODetail = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    detailID?: number;
    productID?: string;
    pDescription?: string | null;
    supplierReference?: string | null;
    uom?: number | null;
    uomName?: string | null;
    qty?: number;
    qtyInAsn?: number | null;
    qtyInAsnTotal?: number | null;
    qtyReceived?: number;
    qtyRequested?: number;
    unitPrice?: number | null;
    unitPriceNet?: number | null;
    unitPriceLcy?: number | null;
    unitPriceNetLcy?: number | null;
    prevPrice?: number | null;
    unitDiscount?: number | null;
    vatRate?: number;
    vatCode?: string | null;
    lineVATValue?: number;
    unitWeight?: number | null;
    expectedDate?: Date | null;
    unitSize?: number | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    discountType?: 'percentage' | 'fix';
    lineTotal?: number;
    lineTotalGross?: number | null;
    contactReference?: string | null;
    uomDetails?: ProductUOM;
    readonly packingDetailsWeightContact?: string | null;
    packingDetails?: Array<Packing_PackingDetail> | null;
    billId?: number | null;
    qtyTotalBilled?: number | null;
    canPurchase?: boolean;
    rctCostId?: number | null;
    soDetailID?: number;
    soDetailIDSOID?: string | null;
    soDetailContactName?: string | null;
    soDetailContactCode?: string | null;
    uomWarn?: boolean;
    isDue?: boolean | null;
    totalLineDiscount?: number | null;
    qtyConfirmedVendor?: number | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum discountType {
    PERCENTAGE = 'percentage',
    FIX = 'fix'
}

export type POHeader = {
    po?: string | null;
    poid?: number;
    isCredit?: boolean;
    supplierID?: string;
    warehouseID?: string;
    purchaseDate?: Date;
    expectedDate?: Date | null;
    vendorExpectedDate?: Date | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    poStatus?: 'unconfirmed' | 'confirmed' | 'acknowledged';
    poReference?: string | null;
    currency?: string | null;
    currencyRate?: number;
    creditTerm?: string | null;
    creditTermId?: number;
    receiveStatus?: number;
    printingNotes?: string | null;
    warehouseName?: string | null;
    warehouseCode?: string | null;
    supplierName?: string | null;
    supplierCode?: string | null;
    supplierReferenceID?: string | null;
    supplierEORI?: string | null;
    warehouseAddress?: Address;
    supplierAddress?: Address;
    originAddress?: Address;
    shippingAddress?: Address;
    vatGroup?: string;
    isFinalised?: boolean;
    authorName?: string | null;
    docStage?: number;
    isDirectDelivery?: boolean;
    deliveryInstructionsNotes?: string | null;
    isBackorder?: boolean;
    customFields?: {
        [key: string]: (string | null);
    } | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum poStatus {
    UNCONFIRMED = 'unconfirmed',
    CONFIRMED = 'confirmed',
    ACKNOWLEDGED = 'acknowledged'
}

export type POTotals = {
    totalNet?: number;
    totalNetLcy?: number;
    totalGross?: number;
    totalGrossLcy?: number;
    totalDiscount?: number;
    totalVAT?: number;
    readonly totalTax?: number;
    totalPaid?: number | null;
    totalDue?: number | null;
    total?: number;
    uomTotals?: Array<UOMTotal> | null;
    totalQtyInDefaultUOM?: number | null;
    totalQty?: number;
    totalUnreceivedValue?: number;
    totalNetWeightInGr?: number;
    totalNetWeightInKg?: number;
    totalNetWeightInLb?: number;
    totalGrossWeightInGr?: number;
    totalGrossWeightInKg?: number;
    totalGrossWeightInLb?: number;
    totalQtyReceived?: number;
    vatBreakdown?: Array<VATBreakdown> | null;
};

export type PackResponse = {
    packId?: Array<(number)> | null;
    packages?: Array<Packing_Package> | null;
};

export type PackageInfo = {
    id?: number;
    serial?: string | null;
    sscc?: string | null;
    readonly formattedSscc?: string | null;
    packingDate?: Date | null;
    number?: number | null;
    isPallet?: boolean;
    weight?: Weight;
    dimensions?: Dimensions;
};

export type PackagesDeleteRequest = {
    packId: Array<(number)>;
};

export type Packing_AlternativeUom = {
    uomid?: number;
    shelfQty?: number;
    uomName?: string | null;
    /**
     * @deprecated
     */
    ratio?: number;
    /**
     * @deprecated
     */
    ratioToUom?: number;
    multiplier?: number;
    divisor?: number;
    isolate?: boolean;
    identifiers?: Array<ProductIdentifier> | null;
};

export type Packing_DocumentDetails = {
    baseType?: string | null;
    baseID?: string | null;
    readonly documentId?: string | null;
    destinationID?: string;
    contactCode?: string | null;
    destinationName?: string | null;
    documentDate?: Date | null;
    printCount?: number;
    packingStatus?: number;
    shippingAddressName?: string | null;
    shippingAttentionName?: string | null;
    shippingAddress1?: string | null;
    shippingAddress2?: string | null;
    shippingTown?: string | null;
    shippingState?: string | null;
    shippingZip?: string | null;
    shippingCountry?: string | null;
    shippingGLN?: string | null;
    shippingPhone?: string | null;
    shippingEmail?: string | null;
    deliveryDateFrom?: Date | null;
    deliveryDateTo?: Date | null;
    pickingNotes?: string | null;
    deliveryNotes?: string | null;
    warehouseID?: string;
    warehouseType?: number;
    tags?: string | null;
    documentReference?: string | null;
    salesRepName?: string | null;
    packageTypeId?: number;
    assignedCarrierId?: number | null;
    assignedCarrier?: string | null;
    zoneIdPreference?: number | null;
    originAddress?: Address;
    shippingAddress?: Address;
};

export type Packing_Package = {
    packageInfo?: Packing_PackageInfo;
    innerPacks?: Array<Packing_PackageInfo> | null;
    lines?: Array<Packing_PackageContentLine> | null;
};

export type Packing_PackageContentLine = {
    aid?: number;
    baseDetailID?: number;
    packID?: number;
    packedQty?: number;
    validatedQty?: number | null;
    scannedQty?: number | null;
    batchID?: number | null;
    unitWeight?: number | null;
    unitSize?: number | null;
    totalWeight?: number | null;
    totalSize?: number | null;
    batchExpiryDate?: Date | null;
    batchManufacturingDate?: Date | null;
    batchLotNumber?: string | null;
    batchNumber?: string | null;
    batchName?: string | null;
    batchFields?: string | null;
    readonly batchFieldsText?: string | null;
    readonly batchFieldsList?: Array<NameValue_1> | null;
    batchRemaining?: number | null;
    uom?: number | null;
    uomName?: string | null;
    printNet?: number | null;
    packedProductID?: string | null;
    /**
     * @deprecated
     */
    packedProductCode?: string | null;
    /**
     * @deprecated
     */
    packedProductTitle?: string | null;
    packedBINLocation?: string | null;
    valueEach?: number | null;
    valueEachGross?: number | null;
    readonly valueTotal?: number | null;
    readonly valueTotalGross?: number | null;
    valueCurrency?: string | null;
    itemWeightInGr?: number | null;
    readonly itemWeightInKg?: number;
    partDetails?: PartDetails;
    shelfQty?: number | null;
    kitQtyTotal?: number | null;
};

export type Packing_PackageInfo = {
    weightValue?: number | null;
    weightUOM?: string | null;
    dimensionsW?: number | null;
    dimensionsH?: number | null;
    dimensionsD?: number | null;
    dimensionsUOM?: string | null;
    packReference?: string | null;
    readonly dimensions?: string | null;
    readonly weight?: string | null;
    packID?: number;
    packType?: 'pack' | 'pallet' | null;
    packSerial?: string | null;
    packSSCC?: string | null;
    readonly packSSCCFormated?: string | null;
    baseType?: string | null;
    baseID?: string | null;
    baseDocumentReference?: string | null;
    packDate?: Date | null;
    packNumber?: number | null;
    totalPackagesCount?: number | null;
    packUser?: string | null;
    shippingID?: number | null;
    parentID?: number | null;
    readonly shpid?: string | null;
    shipmentLabelFormat?: string | null;
    shipmentLabelContent?: string | null;
    shipmentLabelUrl?: string | null;
    parentSerialNumber?: string | null;
    packTotalQty?: number;
    amazon2dBarcode?: string | null;
    packageReference?: string | null;
    isVirtualPackage?: boolean;
};

export enum packType {
    PACK = 'pack',
    PALLET = 'pallet'
}

export type Packing_PackingDetail = {
    aid?: number;
    baseDetailID?: number;
    eachUnitWeight?: number | null;
    eachUnitSize?: number | null;
    batchID?: number | null;
    packedQty?: number | null;
    batchNumber?: string | null;
    expiryDate?: Date | null;
    manufacturingDate?: Date | null;
    batchFields?: string | null;
    packDate?: Date | null;
    readonly daysToExpiryDate?: number | null;
    readonly batchCustomFields?: {
        [key: string]: (string);
    } | null;
};

export type Packing_PackingDocument = {
    document?: Packing_DocumentDetails;
    packs?: Array<Packing_PackageInfo> | null;
    lines?: Array<Packing_PackingDocumentDetail> | null;
    newPackageInfo?: Packing_PackageInfo;
    newTagIds?: Array<(number)> | null;
    unlisted?: Array<Packing_PackingDocumentDetail> | null;
    startTime?: Date | null;
    docNote?: string | null;
    docNoteClass?: string | null;
};

export type Packing_PackingDocumentDetail = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    partID?: string;
    partDocumentDescription?: string | null;
    uom?: number;
    uomText?: string | null;
    subInventoryCount?: number | null;
    subInventoryAvailable?: number | null;
    partImageURL?: string | null;
    partPricingMethod?: number;
    shelfLifeDays?: number | null;
    batchable?: boolean;
    inventoryModel?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    batchDataMode?: 'BEST_BEFORE_DATE' | 'FULL_BATCH_INFO' | 'PRODUCTION_DATE' | 'LOT_NUMBER' | 'SERIAL_NUMBER';
    batchStrict?: boolean;
    binMode?: number;
    uomShelfQty?: number | null;
    uomDimVolume?: string | null;
    uomWeight?: number | null;
    uomWeightGross?: number | null;
    uomWeightUOM?: string | null;
    uomWeightKG?: number | null;
    uomWeightGR?: number | null;
    uomDimHeight?: number | null;
    uomDimWidth?: number | null;
    uomDimLength?: number | null;
    uomDimUOM?: string | null;
    detailID?: number;
    qty?: number;
    baseID?: string | null;
    baseType?: string | null;
    uomWarn?: boolean;
    qtyOnPurchase?: number;
    requestedBatchID?: number | null;
    requestedBatchDetails?: string | null;
    noBatchQty?: number;
    separatePacking?: boolean;
    hasBackToBack?: boolean;
    packingContent?: Array<Packing_PackageContentLine> | null;
    inventoryDetails?: Array<Packing_PackingInventoryDetail> | null;
    identifiers?: Array<ProductIdentifier> | null;
    alternativeUOMs?: Array<Packing_AlternativeUom> | null;
    batches?: Array<Common_ProductBatchDetails> | null;
    alternatives?: Array<Packing_PackingDocumentDetail> | null;
    taughtBarcodes?: Array<(string)> | null;
    updatedBinLocationA?: string | null;
    updatedBinLocationB?: string | null;
    pickingNotes?: string | null;
    packingNotes?: string | null;
    parentPartCode?: string | null;
    parentPartTitle?: string | null;
    stockingCompanyName?: string | null;
};

export type Packing_PackingInventoryDetail = {
    qty?: number;
    batchID?: number;
    batchDate?: Date | null;
    binLocation?: string | null;
    binType?: number;
    binPriority?: number;
};

export type PalletizeRequest = {
    packId: Array<(number)>;
    packageWidth?: number;
    packageHeight?: number;
    packageDepth?: number;
    dimensionUom?: 'cm' | 'ft' | 'in' | 'm' | 'mm' | null;
    weightValue?: number;
    weightUom?: 'kg' | 'g' | 'oz' | 'lb' | null;
    packDate?: Date | null;
};

export type PartBatchDetails = {
    batchID?: number | null;
    batchNumber?: string | null;
    productionDate?: Date | null;
    bestBeforeDate?: Date | null;
    batchFields?: string | null;
    readonly customFields?: {
        [key: string]: (string);
    } | null;
};

export type PartDetails = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
};

export type PartDetailsQty = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    qty?: number;
    uomId?: number | null;
    uomName?: string | null;
};

export type PasswordResetRequest = {
    host: string;
    captcha: string;
    password1: string;
    password2: string;
    resetToken: string;
};

export type PasswordRestoreResponse = {
    captchaRetry?: boolean;
};

export type PasswordRestoreResponsePortalResponseData = {
    data?: PasswordRestoreResponse;
    error?: string | null;
};

export type Payment = {
    paymentDate?: Date;
    paymentAmount?: number;
    paymentMethod?: string | null;
    paymentReference?: string | null;
};

export type PckHeader = {
    id?: number;
    createdAt?: Date;
    createdBy?: Int32IdName;
    assignedTo?: Int32IdName;
    workflow?: WorkflowBase;
    totalOrders?: number;
    pendingOrders?: number;
    readonly progress?: number;
};

export type PckHeaderUnpagedListResults = {
    results?: Array<PckHeader> | null;
};

export type PendingInboundDocument = {
    documentType?: string | null;
    documentId?: string | null;
    supplierName?: string | null;
    documentDate?: Date | null;
    documentReference?: string | null;
    deliveryDue?: Date | null;
};

export type Pipeline = {
    id?: number;
    name?: string | null;
    type?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    direction?: 'OUTBOUND' | 'INBOUND';
    triggerMinute?: Array<(string)> | null;
    triggerHour?: Array<(string)> | null;
    triggerDelay?: number | null;
    lastOperation?: PipelineLastOperation;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum direction {
    OUTBOUND = 'OUTBOUND',
    INBOUND = 'INBOUND'
}

export type PipelineActivity = {
    id?: number;
    startTime?: Date;
    completeTime?: Date | null;
    status?: string | null;
    details?: string | null;
    hasLogItems?: boolean;
};

export type PipelineActivityLog = {
    timestamp?: Date;
    level?: string | null;
    message?: string | null;
};

export type PipelineActivityLogUnpagedListResults = {
    results?: Array<PipelineActivityLog> | null;
};

export type PipelineActivityUnpagedListResults = {
    results?: Array<PipelineActivity> | null;
};

export type PipelineConfiguration = {
    fields?: Array<PipelineFieldItem> | null;
    configuration?: ConfigurationAttribute;
};

export type PipelineDetails = {
    id?: number;
    name?: string | null;
    type?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    direction?: 'OUTBOUND' | 'INBOUND';
    triggerMinute?: Array<(string)> | null;
    triggerHour?: Array<(string)> | null;
    triggerDelay?: number | null;
    lastOperation?: PipelineLastOperation;
    formatConfig?: PipelineFormatConfig;
    fileConfig?: PipelineFileConfig;
    uri?: string | null;
    pipelineConfiguration?: unknown;
};

export type PipelineDetailsResponseData = {
    data?: PipelineDetails;
};

export type PipelineEndpoint = {
    sftp?: string | null;
};

export type PipelineEndpointResponseData = {
    data?: PipelineEndpoint;
};

export type PipelineFieldItem = {
    fieldName?: string | null;
    displayName?: string | null;
    help?: string | null;
    dateType?: string | null;
};

export type PipelineFileConfig = {
    outputFileName?: string | null;
    keepFile?: boolean | null;
    ignoreReadErrors?: boolean | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    processCompleteAction?: 'KEEP' | 'DELETE' | 'MOVE';
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum processCompleteAction {
    KEEP = 'KEEP',
    DELETE = 'DELETE',
    MOVE = 'MOVE'
}

export type PipelineFormatConfig = {
    mapping?: Array<FieldMappingConfig> | null;
    headless?: boolean;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    format?: 'CSV' | 'TSV' | 'JSON' | 'XML' | 'XLSX';
    culture?: string | null;
    csvDelimiter?: string | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum format {
    CSV = 'CSV',
    TSV = 'TSV',
    JSON = 'JSON',
    XML = 'XML',
    XLSX = 'XLSX'
}

export type PipelineLastOperation = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'SUCCESSFUL' | 'FAILED' | 'WARNING';
    message?: string | null;
    date?: Date;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum status3 {
    SUCCESSFUL = 'SUCCESSFUL',
    FAILED = 'FAILED',
    WARNING = 'WARNING'
}

export type PipelineUnpagedListResults = {
    results?: Array<Pipeline> | null;
};

export type PipelineUpsert = {
    name: string;
    type: string;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    direction: 'OUTBOUND' | 'INBOUND';
    triggerMinute?: Array<(string)> | null;
    triggerHour?: Array<(string)> | null;
    triggerDelay?: number | null;
    formatConfig: PipelineFormatConfig;
    fileConfig: PipelineFileConfig;
    uri?: string | null;
    pipelineConfiguration: Array<ConfigurationParameter>;
};

export type PipelinesConfigurationResponse = {
    inbound?: {
        [key: string]: PipelineConfiguration;
    } | null;
    outbound?: {
        [key: string]: PipelineConfiguration;
    } | null;
};

export type PipelinesConfigurationResponseResponseData = {
    data?: PipelinesConfigurationResponse;
};

export type PortalAccountDetails = {
    balance?: number;
};

export type PortalAccountDetailsResponseData = {
    data?: PortalAccountDetails;
};

export type PortalAccountInvoice = {
    invoiceId?: string | null;
    invoiceDate?: Date;
    invoiceTotal?: number;
};

export type PortalAccountInvoiceUnpagedListResults = {
    results?: Array<PortalAccountInvoice> | null;
};

export type PortalAccountOrder = {
    soId?: string | null;
    readonly so?: string | null;
    orderDate?: Date;
    orderStatus?: string | null;
};

export type PortalAccountOrderUnpagedListResults = {
    results?: Array<PortalAccountOrder> | null;
};

export type PortalAccountSettings = {
    stockStatus?: boolean;
    placeOrders?: boolean;
    displayPrices?: boolean;
    disableAddAddress?: boolean;
    disableDueDate?: boolean;
    displayItemSpecs?: boolean;
    categoryFilterType?: string | null;
    disableOosItems?: boolean;
    splitUomPrice?: boolean;
    dateFormat?: string | null;
};

export type PortalAddress = {
    name?: string | null;
    attention?: string | null;
    address1?: string | null;
    address2?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    country?: string | null;
    phone?: string | null;
    email?: string | null;
};

export type PortalBasketAddress = {
    addressId?: string;
    address?: string | null;
    isDefault?: boolean;
};

export type PortalBasketItem = {
    entryId?: number;
    itemId?: string;
    qty?: number;
    itemSKU?: string | null;
    itemTitle?: string | null;
    imageUrl?: string | null;
    priceEach?: number | null;
    sellPrice?: number | null;
    isEstimated?: boolean;
    discount?: number;
    vatRate?: number;
    lineTotal?: number;
    lineTotalEstimated?: number;
    lineDiscount?: number;
    lineDiscountEstimated?: number;
    lineVat?: number;
    lineVatEstimated?: number;
    uomName?: string | null;
    uomWeight?: number;
    pricingMethod?: number;
    availableStock?: number;
};

export type PortalBasketItemRequest = {
    itemId?: string;
    qty?: number;
};

export type PortalBasketItemResponse = {
    updatedQty?: number;
    basket?: BasketSummary;
};

export type PortalBasketItemResponseResponseData = {
    data?: PortalBasketItemResponse;
};

export type PortalBasketResponse = {
    items?: Array<PortalBasketItem> | null;
    basketTotals?: PortalBasketTotals;
    address?: Array<PortalBasketAddress> | null;
};

export type PortalBasketResponseResponseData = {
    data?: PortalBasketResponse;
};

export type PortalBasketTotals = {
    totalExc?: number;
    totalExcEst?: number;
    totalDiscount?: number;
    totalDiscountEst?: number;
    totalVat?: number;
    totalVatEst?: number;
    total?: number;
    totalEst?: number;
};

export type PortalCatalogAppCategory = {
    id?: number;
    parentId?: number | null;
    name?: string | null;
    imageUrl?: string | null;
    sort?: number;
    hasSubItems?: boolean;
};

export type PortalCatalogCurrency = {
    code?: string | null;
    symbol?: string | null;
};

export type PortalCatalogFilter = {
    name?: string | null;
    imageUrl?: string | null;
};

export type PortalCatalogItem = {
    positionId?: number;
    itemId?: string;
    parentItemId?: string | null;
    itemSKU?: string | null;
    itemTitle?: string | null;
    itemBrandName?: string | null;
    itemDepartmentName?: string | null;
    itemCategoryName?: string | null;
    itemEan?: string | null;
    itemUpc?: string | null;
    sellPrice?: number;
    isPromotion?: boolean;
    isClearance?: boolean;
    wasPrice?: number | null;
    vatRat?: number;
    rrp?: number;
    pricingMethod?: number;
    availableStock?: number | null;
    discount?: number | null;
    uomName?: string | null;
    uomId?: number;
    isMarkedNew?: boolean;
    inStock?: boolean;
    shelfQty?: number;
    uomVolume?: string | null;
    uomWeight?: string | null;
    isFrequent?: boolean;
    frequentQty?: number;
    qtyInBasket?: number;
    leadTime?: Date | null;
    isParent?: boolean;
    appCatId?: number;
    parentAppCatId?: number;
    tags?: Array<(string)> | null;
    itemImages?: Array<(string)> | null;
    subItems?: Array<PortalCatalogItem> | null;
    promos?: Array<PortalCatalogPromo> | null;
};

export type PortalCatalogItemResponseData = {
    data?: PortalCatalogItem;
};

export type PortalCatalogPromo = {
    qty?: number;
    endDate?: Date | null;
    price?: number;
    discount?: number | null;
    description?: string | null;
};

export type PortalCatalogResponse = {
    currency?: PortalCatalogCurrency;
    items?: Array<PortalCatalogItem> | null;
    brands?: Array<PortalCatalogFilter> | null;
    departments?: Array<PortalCatalogFilter> | null;
    categories?: Array<PortalCatalogFilter> | null;
    appCategories?: Array<PortalCatalogAppCategory> | null;
    tags?: Array<(string)> | null;
    catalogComplete?: boolean;
};

export type PortalCatalogResponseResponseData = {
    data?: PortalCatalogResponse;
};

export type PortalChckoutRequest = {
    /**
     * Due Date, Optional, when null default due date is used
     */
    dueDate?: Date | null;
    /**
     * Customer order instructions
     */
    instructions?: string | null;
    /**
     * When using address from list, supplier existing addressId
     */
    addressId?: string | null;
    /**
     * Customer order reference
     */
    reference?: string | null;
    address?: PortalAddress;
};

export type PortalChckoutResponse = {
    soId?: string | null;
    success?: boolean;
};

export type PortalChckoutResponseResponseData = {
    data?: PortalChckoutResponse;
};

export type PortalForgotPasswordRequest = {
    email: string;
    captcha: string;
    host: string;
};

export type PrepDetails = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    prepInstruction?: 'Polybagging' | 'BubbleWrapping' | 'Taping' | 'BlackShrinkWrapping' | 'Labeling' | 'HangGarment' | 'SetCreation' | 'Boxing' | 'RemoveFromHanger' | 'Debundle' | 'SuffocationStickering' | 'CapSealing' | 'SetStickering' | 'BlankStickering' | 'ShipsInProductPackaging' | 'NoPrep';
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    prepOwner?: 'AMAZON' | 'SELLER';
};

export type Price = {
    each?: number | string | null;
    discount?: number | string | null;
    discountFixed?: boolean;
};

export type PricelistConditionalUpsert = {
    /**
     * Item Identifier, SKU, EAN, UPC etc
     */
    item?: string | null;
    minimum?: string | null;
    autoApply?: string | null;
    preventDiscount?: string | null;
    startDate?: string | null;
    endDate?: string | null;
    price?: string | null;
    discount?: string | null;
    description?: string | null;
};

export type PricelistConditionalUpsertPricelistUpsert = {
    items?: Array<PricelistConditionalUpsert> | null;
    readonly source?: string | null;
    params?: Array<BulkInsertRequestParam> | null;
    pricelistId?: string | null;
};

export type PricelistDetails = {
    id?: string;
    name?: string | null;
    currency?: string | null;
    isDefault?: boolean;
    targetMargin?: number | null;
    discount?: number | null;
    priceFlattened?: boolean;
    parentPricelist?: GuidIdName;
};

export type PricelistDetailsUnpagedListResults = {
    results?: Array<PricelistDetails> | null;
};

export type PricelistEntry = {
    price?: number | null;
    rrp?: number | null;
    pricelistReference?: string | null;
    pricelistEan?: string | null;
    targetMargin?: number | null;
    discount?: number | null;
    updatedAt?: Date | null;
    prevPrice?: number | null;
    prevDiscount?: number | null;
    conditionalPricing?: Array<PricelistEntryConditional> | null;
    uomPricing?: Array<PricelistUomEntry> | null;
    sku?: string | null;
};

export type PricelistEntryConditional = {
    minimumQty?: number | null;
    autoApply?: boolean;
    startDate?: Date | null;
    endDate?: Date | null;
    price?: number | null;
    discount?: number | null;
    discountFixed?: boolean | null;
    description?: string | null;
    updatedAt?: Date | null;
};

export type PricelistEntryListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<PricelistEntry> | null;
};

export type PricelistEntryPerItem = {
    price?: number | null;
    rrp?: number | null;
    pricelistReference?: string | null;
    pricelistEan?: string | null;
    targetMargin?: number | null;
    discount?: number | null;
    updatedAt?: Date | null;
    prevPrice?: number | null;
    prevDiscount?: number | null;
    conditionalPricing?: Array<PricelistEntryConditional> | null;
    uomPricing?: Array<PricelistUomEntry> | null;
    pricelist?: GuidIdName;
};

export type PricelistEntryPerItemUnpagedListResults = {
    results?: Array<PricelistEntryPerItem> | null;
};

export type PricelistEntryUpsert = {
    /**
     * Item Identifier, SKU, EAN, UPC etc
     */
    item?: string | null;
    /**
     * Pricelist name, required if payload pricelistId is undefined
     */
    pricelist?: string | null;
    price?: string | null;
    description?: string | null;
    reference?: string | null;
    rrp?: string | null;
    discount?: string | null;
    pricelist_ean?: string | null;
    target_pm?: string | null;
    target_price?: string | null;
};

export type PricelistEntryUpsertPricelistUpsert = {
    items?: Array<PricelistEntryUpsert> | null;
    readonly source?: string | null;
    params?: Array<BulkInsertRequestParam> | null;
    pricelistId?: string | null;
};

export type PricelistUomEntry = {
    uomId?: number;
    uomName?: string | null;
    price?: number | null;
    updatedAt?: Date | null;
};

export type PricelistUomUpsert = {
    /**
     * Item Identifier, SKU, EAN, UPC etc
     */
    item?: string | null;
    price?: string | null;
    reference?: string | null;
    uom?: string | null;
};

export type PricelistUomUpsertPricelistUpsert = {
    items?: Array<PricelistUomUpsert> | null;
    readonly source?: string | null;
    params?: Array<BulkInsertRequestParam> | null;
    pricelistId?: string | null;
};

export type PrintItemLabelBatchRequest = {
    bestBeforeDate?: Date | null;
    productionDate?: Date | null;
    lotNumber?: string | null;
};

export type PrintItemLabelBulkRequest = {
    jobs: Array<PrintItemLabelRequestBase>;
    queueId?: number | null;
    queueTags?: string | null;
    templateId?: number | null;
    pricelistId?: string | null;
};

export type PrintItemLabelRequest = {
    sku: string;
    uomId?: number | null;
    /**
     * Quantity, Default: 1
     */
    quantity?: number;
    itemWeight?: number | null;
    itemQuantity?: number | null;
    batch?: PrintItemLabelBatchRequest;
    freeText?: string | null;
    queueId?: number | null;
    queueTags?: string | null;
    templateId?: number | null;
};

export type PrintItemLabelRequestBase = {
    sku: string;
    uomId?: number | null;
    /**
     * Quantity, Default: 1
     */
    quantity?: number;
    itemWeight?: number | null;
    itemQuantity?: number | null;
    batch?: PrintItemLabelBatchRequest;
    freeText?: string | null;
};

export type PrintStationAccess = {
    configuration?: PrintStationConfiguration;
};

export type PrintStationAccessResponseData = {
    data?: PrintStationAccess;
};

export type PrintStationConfiguration = {
    name?: string | null;
    accessKey?: string | null;
    entityName?: string | null;
};

export type ProductIdentifier = {
    identifier?: string | null;
    uom?: number;
    inputType?: number;
    multiplied?: number;
};

export type ProductUOM = {
    uomid?: number;
    shelfQty?: number | null;
    dimWeight?: number | null;
    dimVolume?: string | null;
    dimHeight?: number | null;
    dimWidth?: number | null;
    dimLength?: number | null;
    uomean?: string | null;
    qtyRatio?: number | null;
    uomNotes?: string | null;
    uomPartReference?: string | null;
    uomAsin?: string | null;
    uomName?: string | null;
    dimensionUOM?: 'cm' | 'ft' | 'in' | 'm' | 'mm' | null;
    weightUOM?: 'kg' | 'g' | 'oz' | 'lb' | null;
    readonly weightValue?: number | null;
    weightInKg?: number | null;
    readonly weightInLb?: number | null;
    weightInGr?: number | null;
    totalCmVolume?: number | null;
    weightGross?: number | null;
    readonly grossWeight?: number | null;
    grossWeightInKg?: number | null;
    grossWeightInGr?: number | null;
    readonly grossWeightInLb?: number | null;
    readonly dimVolumeNumber?: number;
    readonly uomcbm?: number;
};

export enum dimensionUOM {
    CM = 'cm',
    FT = 'ft',
    IN = 'in',
    M = 'm',
    MM = 'mm'
}

export enum weightUOM {
    KG = 'kg',
    G = 'g',
    OZ = 'oz',
    LB = 'lb'
}

export type PropertyAttribute = {
    name?: string | null;
    description?: string | null;
    help?: string | null;
    required?: boolean;
    defaultValue?: string | null;
    multiple?: boolean;
    small?: boolean;
    type?: 'TEXT' | 'LIST' | 'CHECKBOX' | 'NUMBER' | 'WAREHOUSE' | 'DOC_QUEUE' | 'DOC_TAG' | 'COLOR' | 'CONTACT' | 'UOM' | 'DATE' | 'DATE_RANGE' | 'DIVIDER' | 'SALES_REP' | 'CARRIER' | 'CURRENCY' | 'COUNTRY' | 'ITEM_TAG' | 'ITEM_CATEGORY' | 'ITEM_BRAND' | 'ITEM_PRICELIST' | 'CUSTOM_FEED' | null;
    options?: {
        [key: string]: (string | null);
    } | null;
};

export enum type4 {
    TEXT = 'TEXT',
    LIST = 'LIST',
    CHECKBOX = 'CHECKBOX',
    NUMBER = 'NUMBER',
    WAREHOUSE = 'WAREHOUSE',
    DOC_QUEUE = 'DOC_QUEUE',
    DOC_TAG = 'DOC_TAG',
    COLOR = 'COLOR',
    CONTACT = 'CONTACT',
    UOM = 'UOM',
    DATE = 'DATE',
    DATE_RANGE = 'DATE_RANGE',
    DIVIDER = 'DIVIDER',
    SALES_REP = 'SALES_REP',
    CARRIER = 'CARRIER',
    CURRENCY = 'CURRENCY',
    COUNTRY = 'COUNTRY',
    ITEM_TAG = 'ITEM_TAG',
    ITEM_CATEGORY = 'ITEM_CATEGORY',
    ITEM_BRAND = 'ITEM_BRAND',
    ITEM_PRICELIST = 'ITEM_PRICELIST',
    CUSTOM_FEED = 'CUSTOM_FEED'
}

export type RctCost = {
    cost?: MoneyCurrencyRate;
    currencyCost?: number | null;
    billId?: number | null;
    name?: string | null;
};

export type RctDetail = {
    id?: number;
    item?: DocumentItemInfo;
    uomId?: number;
    quantity?: number;
    price?: Price;
    landedPrice?: number | null;
    totalWeight?: number | null;
    additionalCost?: Price;
};

export type RctDocument = {
    header?: RctDocumentHeader;
    lines?: Array<RctDetail> | null;
    costs?: Array<RctCost> | null;
};

export type RctDocumentHeader = {
    id?: number;
    date?: Date | null;
    documentType?: string | null;
    documentId?: string | null;
    warehouse?: GuidIdName;
    currency?: string | null;
    currencyRate?: number | null;
    documentReferenceType?: 'DELIVERY_NOTE' | 'INVOICE' | null;
    documentReference?: string | null;
    exportPending?: boolean;
    exported?: boolean;
};

export type RctDocumentUnpagedListResults = {
    results?: Array<RctDocument> | null;
};

export type ReceiveResponse = {
    rctId?: Array<(number)> | null;
};

export type Receiving_DocumentDetails = {
    baseType?: string | null;
    baseID?: string | null;
    contactName?: string | null;
    contactCode?: string | null;
    tags?: string | null;
    billingAddress?: Address;
    shippingAddress?: Address;
    warehouseId?: string | null;
    warehouseType?: number;
    readonly documentId?: string | null;
    documentDate?: Date | null;
    readonly destinationName?: string | null;
    documentReference?: string | null;
    isVirtual?: boolean;
};

export type Receiving_ReceiveContentLine = {
    batchExpiryDate?: Date | null;
    batchProductionDate?: Date | null;
    batchLotNumber?: string | null;
    batchID?: number | null;
    baseDetailID?: number;
    receivedQty?: number;
    unitWeight?: number | null;
    totalWeight?: number | null;
    unitSize?: number | null;
    receivedProductID?: string | null;
    receivedProductCode?: string | null;
    receivedBINLocation?: string | null;
    receivedProductTitle?: string | null;
    priceEach?: number | null;
    discountEach?: number | null;
    discountFixed?: boolean | null;
    addPerncet?: number | null;
    addFixed?: number | null;
};

export type Receiving_ReceiveDocument = {
    document?: Receiving_DocumentDetails;
    lines?: Array<Receiving_ReceiveDocumentDetail> | null;
    importReference?: string | null;
    receivingNotes?: string | null;
    receivingReference?: string | null;
    receivingCurrency?: string | null;
    receivingCurrencyRate?: number | null;
};

export type Receiving_ReceiveDocumentDetail = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    partID?: string;
    partDocumentDescription?: string | null;
    uom?: number;
    uomText?: string | null;
    subInventoryCount?: number | null;
    subInventoryAvailable?: number | null;
    partImageURL?: string | null;
    partPricingMethod?: number;
    shelfLifeDays?: number | null;
    batchable?: boolean;
    inventoryModel?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    batchDataMode?: 'BEST_BEFORE_DATE' | 'FULL_BATCH_INFO' | 'PRODUCTION_DATE' | 'LOT_NUMBER' | 'SERIAL_NUMBER';
    batchStrict?: boolean;
    binMode?: number;
    uomShelfQty?: number | null;
    uomDimVolume?: string | null;
    uomWeight?: number | null;
    uomWeightGross?: number | null;
    uomWeightUOM?: string | null;
    uomWeightKG?: number | null;
    uomWeightGR?: number | null;
    uomDimHeight?: number | null;
    uomDimWidth?: number | null;
    uomDimLength?: number | null;
    uomDimUOM?: string | null;
    detailID?: number;
    qty?: number;
    baseID?: string | null;
    baseType?: string | null;
    inAsnId?: number | null;
    inAsnItemId?: number | null;
    isBackToBack?: boolean;
    receiveBatchId?: number | null;
    binLocations?: Array<(string)> | null;
    identifiers?: Array<ProductIdentifier> | null;
    lines?: Array<Receiving_ReceiveContentLine> | null;
    alternatives?: Array<Receiving_ReceiveDocumentDetail> | null;
    alternativeUoms?: Array<Packing_AlternativeUom> | null;
    batches?: Array<Common_ProductBatchDetails> | null;
    taughtBarcodes?: Array<(string)> | null;
    packSSCC?: string | null;
    palletSSCC?: string | null;
    uomDetailsUpdated?: boolean;
};

export type ReportAction = {
    name?: string | null;
    url?: string | null;
    method?: string | null;
};

export type ReportDateRange = {
    start?: Date;
    end?: Date;
};

export type ReportResultSchema = {
    field: string;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type: 'TEXT' | 'SKU' | 'MONEY' | 'INVENTORY' | 'DATE' | 'DATE_TIME' | 'DATE_AGO' | 'INVENTORY_DRILLDOWN';
    summary: 'COUNT' | 'SUM' | 'AVG';
    readonly headerName: string;
    exportOnly?: boolean;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum type5 {
    TEXT = 'TEXT',
    SKU = 'SKU',
    MONEY = 'MONEY',
    INVENTORY = 'INVENTORY',
    DATE = 'DATE',
    DATE_TIME = 'DATE_TIME',
    DATE_AGO = 'DATE_AGO',
    INVENTORY_DRILLDOWN = 'INVENTORY_DRILLDOWN'
}

export enum summary {
    COUNT = 'COUNT',
    SUM = 'SUM',
    AVG = 'AVG'
}

export type ReportResults = {
    report: ConfigurationRequest;
    schema: Array<ReportResultSchema>;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    renderType: 'TABLE' | 'FORECAST';
    records: Array<{
        [key: string]: unknown;
    }>;
    helpers?: {
        [key: string]: unknown;
    } | null;
    actions?: Array<ReportAction> | null;
    selectField?: string | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum renderType {
    TABLE = 'TABLE',
    FORECAST = 'FORECAST'
}

export type ReportScheduleCreateRequest = {
    name: string;
    emailAddress: string;
    removeColumns?: string | null;
    cron: string;
    report: ConfigurationRequest;
};

export type ReportScheduleInfo = {
    id?: number;
    user?: string | null;
    isActive?: boolean;
    name?: string | null;
    readonly report?: string | null;
    cron?: string | null;
    readonly cronExpression?: string | null;
    nextOccurringDateUtc?: Date | null;
    reportType?: string | null;
    emailAddress: string;
    removeColumns: string;
};

export type ReportScheduleInfoUnpagedListResults = {
    results?: Array<ReportScheduleInfo> | null;
};

export type ReportScheduleUpdateRequest = {
    name: string;
    emailAddress: string;
    removeColumns?: string | null;
    cron: string;
    isActive?: boolean;
};

export type ReportTypeConfiguration = {
    type?: string | null;
    name?: string | null;
    description?: string | null;
    parameters?: Array<PropertyAttribute> | null;
    imageUrl?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    reportClass?: 'inventory' | 'sales' | 'other';
    filter?: ReportTypeFilter;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum reportClass {
    INVENTORY = 'inventory',
    SALES = 'sales',
    OTHER = 'other'
}

export type ReportTypeConfigurationUnpagedListResults = {
    results?: Array<ReportTypeConfiguration> | null;
};

export type ReportTypeFilter = {
    filterItems?: boolean;
    filterSales?: boolean;
};

export type ReturnShipment = {
    id?: number;
    returnReference?: string | null;
    carrierReference?: string | null;
    labelUrl?: string | null;
    qrUrl?: string | null;
    returnExpiry?: Date | null;
};

export type SHP = {
    header?: SHPHeader;
    lines?: Array<SHPDetails> | null;
    totals?: ShpDocTotal;
    tags?: Array<DocumentTag> | null;
    unlisted?: Array<PartDetailsQty> | null;
    packages?: Array<Packing_PackageInfo> | null;
    invoices?: Array<INVHeader> | null;
};

export type SHPDetails = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    readonly lineId?: number;
    description?: string | null;
    qty?: number;
    validatedQty?: number | null;
    validationDetails?: string | null;
    packNumber?: number | null;
    packSerial?: string | null;
    packSSCC?: string | null;
    palletSerial?: string | null;
    palletSSCC?: string | null;
    packID?: number;
    uomName?: string | null;
    totalWeight?: number | null;
    totalSize?: number | null;
    priceNet?: number;
    priceGross?: number;
    discount?: number;
    vatRate?: number;
    unitSize?: number | null;
    discountType?: number | null;
    documentContactReference?: string | null;
    deliveryDueDate?: Date | null;
    documentReference?: string | null;
    soSource?: 'direct' | 'edi' | 'pos' | 'repApp' | 'amazonMarketplace' | 'cDiscount' | 'eBay' | 'bolCom' | 'magento' | 'custom' | 'groupon' | 'fnac' | 'wooCommerce' | 'fruugo' | 'shopify' | 'b2BPortal' | 'sq' | 'import' | 'api' | 'repeatedSO' | 'realDe' | 'tradeByte' | 'onBuy' | 'wowcher' | 'linnworks' | 'limango' | 'rakutenFr' | 'goGroopie' | 'zalando' | 'visualSoft' | 'cdon' | 'bigCommerce' | 'etsy' | 'wayfair' | 'allegro' | 'theRange' | 'openCart' | 'mirakl' | 'pipeline' | 'tikTok' | 'walmart' | null;
    contactReference?: string | null;
    lineVATValue?: number;
    deliveryInstructions?: string | null;
    documentType?: string | null;
    documentId?: string | null;
    documentNumber?: string | null;
    salesRepName?: string | null;
    customField1?: string | null;
    uomDetails?: ProductUOM;
    readonly packingDetailsWeightConcat?: string | null;
    packingDetails?: Array<Packing_PackingDetail> | null;
};

export enum soSource {
    DIRECT = 'direct',
    EDI = 'edi',
    POS = 'pos',
    REP_APP = 'repApp',
    AMAZON_MARKETPLACE = 'amazonMarketplace',
    C_DISCOUNT = 'cDiscount',
    E_BAY = 'eBay',
    BOL_COM = 'bolCom',
    MAGENTO = 'magento',
    CUSTOM = 'custom',
    GROUPON = 'groupon',
    FNAC = 'fnac',
    WOO_COMMERCE = 'wooCommerce',
    FRUUGO = 'fruugo',
    SHOPIFY = 'shopify',
    B2BPORTAL = 'b2BPortal',
    SQ = 'sq',
    IMPORT = 'import',
    API = 'api',
    REPEATED_SO = 'repeatedSO',
    REAL_DE = 'realDe',
    TRADE_BYTE = 'tradeByte',
    ON_BUY = 'onBuy',
    WOWCHER = 'wowcher',
    LINNWORKS = 'linnworks',
    LIMANGO = 'limango',
    RAKUTEN_FR = 'rakutenFr',
    GO_GROOPIE = 'goGroopie',
    ZALANDO = 'zalando',
    VISUAL_SOFT = 'visualSoft',
    CDON = 'cdon',
    BIG_COMMERCE = 'bigCommerce',
    ETSY = 'etsy',
    WAYFAIR = 'wayfair',
    ALLEGRO = 'allegro',
    THE_RANGE = 'theRange',
    OPEN_CART = 'openCart',
    MIRAKL = 'mirakl',
    PIPELINE = 'pipeline',
    TIK_TOK = 'tikTok',
    WALMART = 'walmart'
}

export type SHPHeader = {
    shp?: string | null;
    shpid?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    shipmentStatus?: 'PENDING_PICKUP' | 'IN_TRANSIT' | 'DELIVERED' | 'EXCEPTION' | 'UNKNOWN' | 'DRAFT';
    destinationId?: string;
    carrierReferenceNumber?: string | null;
    consignmentId?: string | null;
    warehouseID?: string;
    contactName?: string | null;
    carrierId?: number;
    carrierName?: string | null;
    carrierServiceName?: string | null;
    receiverReference?: string | null;
    deliveryDate?: Date;
    deliveryDueDate?: Date | null;
    etaDate?: Date | null;
    warehouseAddress?: Address;
    shippingAddress?: Address;
    documentsOrigin?: string | null;
    documentReferences?: string | null;
    documents?: string | null;
    documentContactReferences?: string | null;
    documentTags?: string | null;
    driverNotes?: string | null;
    pickupId?: number | null;
    pickupDocId?: string | null;
    pickupDate?: Date | null;
    pickupDriver?: string | null;
    salesRepName?: string | null;
    contactCode?: string | null;
    deliveryInstructions?: string | null;
    documentNotes?: string | null;
    trackingUrl?: string | null;
    carrierBOLNumber?: string | null;
    carrierSCAC?: string | null;
    requiresManifest?: boolean | null;
    shipmentCost?: number | null;
    shipmentCostCurrency?: string | null;
    marketplaceNotificationDate?: Date | null;
    marketplaceNotificationPending?: boolean;
    ediCreationDate?: Date | null;
    receivedBy?: string | null;
    customFields?: {
        [key: string]: (string | null);
    } | null;
    insuranceId?: number;
    returnShipment?: ReturnShipment;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum shipmentStatus {
    PENDING_PICKUP = 'PENDING_PICKUP',
    IN_TRANSIT = 'IN_TRANSIT',
    DELIVERED = 'DELIVERED',
    EXCEPTION = 'EXCEPTION',
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT'
}

export type SO = {
    header?: SOHeader;
    lines?: Array<SODetails> | null;
    totals?: SOTotals;
    tags?: Array<DocumentTag> | null;
    linkedDeliveries?: Array<LinkedShp> | null;
};

export type SODetails = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    detailID?: number;
    parentDetailID?: number;
    productID?: string;
    pDescription?: string | null;
    uom?: number | null;
    uomName?: string | null;
    qtyRequested?: number;
    qtyConfirmed?: number;
    qtyPacked?: number;
    readonly qtyRemaining?: number;
    qtyInvoiced?: number;
    qtyBilling?: number;
    priceGross?: number;
    readonly priceWithTax?: number;
    discount?: number;
    vatRate?: number;
    vatCode?: string | null;
    priceNet?: number;
    priceExpected?: number | null;
    discountExpected?: number | null;
    readonly priceExpectedAlert?: boolean;
    priceDefault?: number | null;
    unitWeight?: number | null;
    unitSize?: number | null;
    discountType?: number | null;
    contactReference?: string | null;
    contactLineReference?: string | null;
    lineVATValue?: number;
    readonly lineVATCalculatedValue?: number;
    isFreightCharge?: boolean;
    notes?: string | null;
    originatingSoId?: string | null;
    readonly isBelowExpectedPrice?: boolean;
    readonly isAboveExpectedPrice?: boolean;
    qtyReturned?: number | null;
    qtyCredited?: number | null;
    readonly packingDetailsWeightContact?: string | null;
    calculatedWeight?: number;
    weightGrams?: number;
    dimensionsMinCM?: number;
    dimensionsMedCM?: number;
    dimensionsMaxCM?: number;
    readonly cbmEach?: number;
    packingDetails?: Array<Packing_PackingDetail> | null;
    readonly isKitComponent?: boolean;
    rrp?: number | null;
    customFieldValueId1?: number | null;
    customFieldValue1?: string | null;
    mpsku?: string | null;
    customFieldSort1?: number | null;
    notForDispatch?: boolean;
    sortCol?: number;
    qtyReserved?: number;
    readonly qtyAvailableFromReserved?: number;
    detailPickingRange?: 'strict' | 'sibling' | 'siblingBrand' | null;
    isWeightEstimated?: boolean;
    uomWarn?: boolean;
    eachCostLCY?: number | null;
    eachCost?: number | null;
    readonly profitEach?: number;
    readonly profitTotalConfirmed?: number;
    readonly isFulfillable?: boolean;
    readonly isFulfillableAvailable?: boolean;
    lineTotalConfirmed?: number;
    eachVATInput?: number | null;
    profit?: number | null;
    customerBarcode?: string | null;
    kitParentPartCode?: string | null;
    kitParentPartTitle?: string | null;
    uomDetails?: ProductUOM;
    batchDetails?: PartBatchDetails;
    isNotPriced?: boolean;
};

export enum detailPickingRange {
    STRICT = 'strict',
    SIBLING = 'sibling',
    SIBLING_BRAND = 'siblingBrand'
}

export type SOHeader = {
    soid?: string | null;
    so?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    soStatus?: 'draft' | 'confirmed' | 'cancelled';
    mpLoadComplete?: boolean;
    isParked?: boolean;
    invoicingStatus?: 'waiting' | 'partial' | 'complete' | 'na' | null;
    packingStatus?: 'waiting' | 'partial' | 'complete' | 'na' | null;
    packed3RdParty?: boolean;
    createdDateUTC?: Date;
    returnActionType?: 'None' | 'Resend' | 'Refund' | 'Pending' | 'Cancel' | null;
    isCredit?: boolean;
    isMasked?: boolean;
    contactId?: string;
    warehouseID?: string;
    orderDate?: Date;
    agentName?: string | null;
    authorName?: string | null;
    currency?: string | null;
    currencyRate?: number;
    readonly soReference?: string | null;
    warehouseCode?: string | null;
    warehouseName?: string | null;
    vatNumber?: string | null;
    deliveryDateFrom?: Date | null;
    deliveryDateTo?: Date | null;
    readonly dispatchDate?: Date | null;
    readonly dueDate?: Date | null;
    readonly deliveryDueDays?: number;
    readonly deliveryDispatchDays?: number;
    readonly deliveryBusinessDueDays?: number;
    readonly hasDispatchDate?: boolean;
    readonly hasDueDate?: boolean;
    currentHour?: number;
    currentDayOfWeek?: string | null;
    readonly hasPickingNotes?: boolean;
    readonly hasInvoiceNotes?: boolean;
    createdDateHour?: number;
    pckId?: number | null;
    customerName?: string | null;
    customerCode?: string | null;
    readonly customerCodeName?: string | null;
    customerReferenceID?: string | null;
    customerEORI?: string | null;
    contact?: DocumentContactDetails;
    isBackOrder?: boolean;
    isConsignment?: boolean;
    isFinalized?: boolean;
    creditTerms?: string | null;
    creditTermsId?: number;
    pickingNotes?: string | null;
    printingNotes?: string | null;
    invoiceNotes?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    origin?: 'direct' | 'edi' | 'pos' | 'repApp' | 'amazonMarketplace' | 'cDiscount' | 'eBay' | 'bolCom' | 'magento' | 'custom' | 'groupon' | 'fnac' | 'wooCommerce' | 'fruugo' | 'shopify' | 'b2BPortal' | 'sq' | 'import' | 'api' | 'repeatedSO' | 'realDe' | 'tradeByte' | 'onBuy' | 'wowcher' | 'linnworks' | 'limango' | 'rakutenFr' | 'goGroopie' | 'zalando' | 'visualSoft' | 'cdon' | 'bigCommerce' | 'etsy' | 'wayfair' | 'allegro' | 'theRange' | 'openCart' | 'mirakl' | 'pipeline' | 'tikTok' | 'walmart';
    readonly channelName?: string | null;
    originReference?: string | null;
    assignedCarrierId?: number | null;
    assignedPackageTemplateId?: number | null;
    assignedCarrierName?: string | null;
    draftShpId?: number | null;
    draftShpMessage?: string | null;
    draftShpLabelUrl?: string | null;
    warehouseAddress?: Address;
    billingAddress?: Address;
    shippingAddress?: Address;
    routePosition?: number | null;
    documentTags?: string | null;
    contactTags?: string | null;
    vatGroupDraft?: boolean;
    docStage?: number | null;
    pickingRange?: 'strict' | 'sibling' | 'siblingBrand' | null;
    dispatchMode?: 'split' | 'complete' | null;
    vatGroup?: string;
    agentID?: string | null;
    originMarketplaceId?: number | null;
    originMarketplaceName?: string | null;
    deliveryInstructionsNotes?: string | null;
    confirmationTokenId?: string | null;
    mergedIntoSO?: string | null;
    ioss?: string | null;
    freightDescription?: string | null;
    freightCharge?: number;
    orderWeight?: number | null;
    returnActionStatus?: 'none' | 'pending' | 'complete' | 'error' | null;
    readonly returnActionComplete?: boolean;
    isPosOrder?: boolean;
    isFulfillable?: boolean;
    isFulfillableAvailable?: boolean;
    notificationsFlag?: boolean;
    invProcess?: boolean;
    kitPricingMode?: number;
    isResend?: boolean;
    isResent?: boolean;
    splitFromSO?: string | null;
    customFields?: {
        [key: string]: (string | null);
    } | null;
    fulfilmentId?: number | null;
    fulfilmentStatus?: 'pending' | 'partially' | 'complete' | 'exception' | null;
    fulfilmentName?: string | null;
    listedSKUs?: string | null;
    listedMPSKUs?: string | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum soStatus {
    DRAFT = 'draft',
    CONFIRMED = 'confirmed',
    CANCELLED = 'cancelled'
}

export enum invoicingStatus {
    WAITING = 'waiting',
    PARTIAL = 'partial',
    COMPLETE = 'complete',
    NA = 'na'
}

export enum packingStatus2 {
    WAITING = 'waiting',
    PARTIAL = 'partial',
    COMPLETE = 'complete',
    NA = 'na'
}

export enum returnActionType {
    NONE = 'None',
    RESEND = 'Resend',
    REFUND = 'Refund',
    PENDING = 'Pending',
    CANCEL = 'Cancel'
}

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum origin {
    DIRECT = 'direct',
    EDI = 'edi',
    POS = 'pos',
    REP_APP = 'repApp',
    AMAZON_MARKETPLACE = 'amazonMarketplace',
    C_DISCOUNT = 'cDiscount',
    E_BAY = 'eBay',
    BOL_COM = 'bolCom',
    MAGENTO = 'magento',
    CUSTOM = 'custom',
    GROUPON = 'groupon',
    FNAC = 'fnac',
    WOO_COMMERCE = 'wooCommerce',
    FRUUGO = 'fruugo',
    SHOPIFY = 'shopify',
    B2BPORTAL = 'b2BPortal',
    SQ = 'sq',
    IMPORT = 'import',
    API = 'api',
    REPEATED_SO = 'repeatedSO',
    REAL_DE = 'realDe',
    TRADE_BYTE = 'tradeByte',
    ON_BUY = 'onBuy',
    WOWCHER = 'wowcher',
    LINNWORKS = 'linnworks',
    LIMANGO = 'limango',
    RAKUTEN_FR = 'rakutenFr',
    GO_GROOPIE = 'goGroopie',
    ZALANDO = 'zalando',
    VISUAL_SOFT = 'visualSoft',
    CDON = 'cdon',
    BIG_COMMERCE = 'bigCommerce',
    ETSY = 'etsy',
    WAYFAIR = 'wayfair',
    ALLEGRO = 'allegro',
    THE_RANGE = 'theRange',
    OPEN_CART = 'openCart',
    MIRAKL = 'mirakl',
    PIPELINE = 'pipeline',
    TIK_TOK = 'tikTok',
    WALMART = 'walmart'
}

export enum pickingRange {
    STRICT = 'strict',
    SIBLING = 'sibling',
    SIBLING_BRAND = 'siblingBrand'
}

export enum dispatchMode {
    SPLIT = 'split',
    COMPLETE = 'complete'
}

export enum returnActionStatus {
    NONE = 'none',
    PENDING = 'pending',
    COMPLETE = 'complete',
    ERROR = 'error'
}

export enum fulfilmentStatus {
    PENDING = 'pending',
    PARTIALLY = 'partially',
    COMPLETE = 'complete',
    EXCEPTION = 'exception'
}

export type SOTotals = {
    totalNet?: number;
    totalNetLcy?: number;
    totalGross?: number;
    totalGrossLcy?: number;
    totalDiscount?: number;
    totalVAT?: number;
    readonly totalTax?: number;
    totalPaid?: number | null;
    totalDue?: number | null;
    total?: number;
    uomTotals?: Array<UOMTotal> | null;
    totalQtyInDefaultUOM?: number | null;
    totalQty?: number;
    totalUnreceivedValue?: number;
    totalQtyConfirmed?: number;
    totalQtyRemaining?: number;
    totalQtyPacked?: number;
    totalCBM?: number;
    totalEnteredWeight?: number;
    packedCalculatedWeight?: number;
    confirmedCalculatedWeight?: number;
    packedWeightGrams?: number;
    confirmedWeightGrams?: number;
    confirmedWeightLb?: number;
    confirmedWeightLbGross?: number;
    confirmedDimensionsMinCM?: number;
    confirmedDimensionsMedCM?: number;
    confirmedDimensionsMaxCM?: number;
    confirmedDimensionsGirth?: number;
    readonly confirmedDimensionsCM3?: number;
    pendingWeightGrams?: number;
    pendingDimensionsMinCM?: number;
    pendingDimensionsMedCM?: number;
    pendingDimensionsMaxCM?: number;
    pendingDimensionsGirth?: number;
    readonly pendingDimensionsCM3?: number;
    totalSaving?: number | null;
};

export type SalesOverview = {
    results?: SalesOverviewSegment;
    previous?: SalesOverviewSegment;
};

export type SalesOverviewRanged = {
    results?: SalesOverviewSegment;
    previous?: SalesOverviewSegment;
    dateRanges?: DateRanges;
};

export type SalesOverviewSegment = {
    salesValueNet?: number;
    salesValueGross?: number;
    orders?: number;
    itemsSold?: number;
    grossProfit?: number;
    grossProfitMarkup?: number;
    grossProfitMargin?: number;
};

export type SalesOverviewSegmentDate = {
    salesValueNet?: number;
    salesValueGross?: number;
    orders?: number;
    itemsSold?: number;
    grossProfit?: number;
    grossProfitMarkup?: number;
    grossProfitMargin?: number;
    dateName?: string | null;
};

export type SalesOverviewSegmentItem = {
    salesValueNet?: number;
    salesValueGross?: number;
    orders?: number;
    itemsSold?: number;
    grossProfit?: number;
    grossProfitMarkup?: number;
    grossProfitMargin?: number;
    itemSku?: string | null;
    readonly itemSKU?: string | null;
    itemTitle?: string | null;
};

export type SalesReportDrillDownQty = {
    readonly document?: string | null;
    documentType?: string | null;
    documentId?: string | null;
    date?: Date;
    isCredit?: boolean;
    contactName?: string | null;
    warehouseName?: string | null;
    grossPrice?: number;
    netPrice?: number;
    uomName?: string | null;
    isPromotion?: boolean;
    qty?: number;
};

export type SalesReportDrillDownQtyListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<SalesReportDrillDownQty> | null;
};

export type SegmentDetails = {
    id?: number;
    segmentName: string;
    segmentCode: string;
    taxNumber?: string | null;
    eori?: string | null;
    currency?: string | null;
    isActive?: boolean;
    defaultItemCOO?: string | null;
    defaultItemHSCode?: string | null;
};

export type SegmentDetailsListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<SegmentDetails> | null;
};

export type SegmentDetailsResponseData = {
    data?: SegmentDetails;
};

export type SerializableConfigItemWithValue = {
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    dataType?: 'text' | 'list' | 'int' | 'double' | 'boolean' | 'sensativE_TEXT' | 'servicE_ITEM' | 'documenT_TAG';
    mandatory?: boolean;
    configName?: string | null;
    configDescription?: string | null;
    configHelp?: string | null;
    options?: {
        [key: string]: (string | null);
    } | null;
    configValue?: unknown;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum dataType {
    TEXT = 'text',
    LIST = 'list',
    INT = 'int',
    DOUBLE = 'double',
    BOOLEAN = 'boolean',
    SENSATIV_E_TEXT = 'sensativE_TEXT',
    SERVIC_E_ITEM = 'servicE_ITEM',
    DOCUMEN_T_TAG = 'documenT_TAG'
}

export type ShipmentDetail = {
    shpId?: number;
    shipperName?: string | null;
    shipperScac?: string | null;
    containerNumber?: string | null;
    bolNumber?: string | null;
    shipmentReference?: string | null;
    loadingDate?: Date | null;
    orderedDate?: Date | null;
    departureDate?: Date | null;
    arrivalDate?: Date | null;
    containerType?: string | null;
    shpStatusName?: string | null;
    asns?: Array<AsnDetail> | null;
    customFields?: Array<CustomFieldResult> | null;
};

export type ShipmentDetailListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<ShipmentDetail> | null;
};

export type ShipmentWithPackages = {
    id?: number;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'PENDING_PICKUP' | 'IN_TRANSIT' | 'DELIVERED' | 'EXCEPTION' | 'UNKNOWN' | 'DRAFT';
    carrierName?: string | null;
    carrierTracking?: string | null;
    consignmentId?: string | null;
    receiverNotified?: boolean;
    packages?: Array<PackageInfo> | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum status4 {
    PENDING_PICKUP = 'PENDING_PICKUP',
    IN_TRANSIT = 'IN_TRANSIT',
    DELIVERED = 'DELIVERED',
    EXCEPTION = 'EXCEPTION',
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT'
}

export type ShpDeliveryRequest = {
    items?: Array<ShpDeliveryRequestItem> | null;
    notes?: string | null;
    signatureBase64?: string | null;
    codReceived?: number;
    receivedBy?: string | null;
    notesAttention?: boolean;
};

export type ShpDeliveryRequestItem = {
    id?: string | null;
    validatedQty?: number | null;
};

export type ShpDocTotal = {
    totalNet?: number;
    totalNetLcy?: number;
    totalGross?: number;
    totalGrossLcy?: number;
    totalDiscount?: number;
    totalVAT?: number;
    readonly totalTax?: number;
    totalPaid?: number | null;
    totalDue?: number | null;
    total?: number;
    uomTotals?: Array<UOMTotal> | null;
    totalQtyInDefaultUOM?: number | null;
    totalQty?: number;
    totalUnreceivedValue?: number;
    totalWeightInKg?: number | null;
    totalWeightInGr?: number | null;
};

export type SpApi_FulfillmentInbound_Address = {
    name?: string | null;
    addressLine1?: string | null;
    addressLine2?: string | null;
    districtOrCounty?: string | null;
    city?: string | null;
    stateOrProvinceCode?: string | null;
    countryCode?: string | null;
    postalCode?: string | null;
};

export type SpkDocument = {
    id?: number;
    readonly documentId?: string | null;
    details?: string | null;
    pickupDateUtc?: Date | null;
    /**
     * distance (in meters) from last location
     */
    returnDistance?: number | null;
    /**
     * duration (in seconds) from last location
     */
    returnDuration?: number | null;
    shipments?: Array<SpkShipment> | null;
};

export type SpkDocumentUnpagedListResults = {
    results?: Array<SpkDocument> | null;
};

export type SpkShipment = {
    id?: number;
    readonly documentId?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    status?: 'PENDING PICKUP' | 'IN TRANSIT' | 'DELIVERED' | 'EXCEPTION' | 'UNKNOWN' | 'DRAFT';
    destinationAddress?: DocumentAddress;
    date?: Date;
    codValue?: number | null;
    deliveryInstructions?: string | null;
    driverNotes?: string | null;
    pickupPosition?: number | null;
    pickupDuration?: number | null;
    pickupDistance?: number | null;
    items?: Array<SpkShipmentItem> | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum status5 {
    PENDING_PICKUP = 'PENDING PICKUP',
    IN_TRANSIT = 'IN TRANSIT',
    DELIVERED = 'DELIVERED',
    EXCEPTION = 'EXCEPTION',
    UNKNOWN = 'UNKNOWN',
    DRAFT = 'DRAFT'
}

export type SpkShipmentItem = {
    id?: number;
    item?: DocumentItemDetailsBase;
    identifiers?: Array<(string)> | null;
    itemDescription?: string | null;
    qtyPacked?: number;
    qtyValidated?: number;
    packNumber?: number;
    packSerial?: string | null;
    packSSCC?: string | null;
    palletSerial?: string | null;
    palletSSCC?: string | null;
    packedWeight?: number | null;
};

export type StockTransaction = {
    docId?: number;
};

export type StorageDataRequest = {
    value: string;
    /**
     * Value content type, text/plain is default
     */
    mimeType?: string | null;
};

export type StoreInfo = {
    name: string;
    welcomeMessage?: string | null;
    iconUrl: string;
    backgroundUrl?: string | null;
    isAuthenticated: boolean;
};

export type StoreInfoRequest = {
    host: string;
    token?: string | null;
};

export type StoreInfoResponseData = {
    data?: StoreInfo;
};

export type StringIdName = {
    id?: string | null;
    name?: string | null;
};

export type StringResponseData = {
    data?: string | null;
};

export type StringSuccessMessage = {
    success?: boolean;
    message?: string | null;
    warning?: string | null;
    objectId?: string | null;
    props?: unknown;
    messages?: Array<(string)> | null;
    tag?: string | null;
    readonly value?: string | null;
};

export type StringUnpagedListResults = {
    results?: Array<(string)> | null;
};

export type SuccessMessage_1ResponseData = {
    data?: StringSuccessMessage;
};

export type SuccessResult = {
    success?: boolean;
};

export type SuccessResultResponseData = {
    data?: SuccessResult;
};

export type SyncStatus = {
    sync?: boolean;
    lastSync?: Date | null;
};

export type TRC = {
    transactionDescription?: string | null;
    transactionReference?: string | null;
    class?: string | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * <li><b>Adjustment</b>: Stock Adjustment</li>
     * <li><b>Stocktake</b>: Stock take</li>
     * <li><b>BinToBin</b>: Bin to Bin transfer</li>
     * <li><b>BinCount</b>: Bin Count</li>
     * </ul>
     *
     */
    transactionType: 'adjustment' | 'stocktake' | 'binToBin' | 'binCount';
    transactionDate: Date;
    /**
     * Used for 'Bin to Bin transfer'
     */
    originBinLocation?: string | null;
    /**
     * Used for 'Bin to Bin transfer'
     */
    destinationBinLocation?: string | null;
    /**
     * Warehouse Code
     */
    warehouseCode?: string | null;
    lines: Array<TRCLine>;
    confirm?: boolean;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * <li><b>Adjustment</b>: Stock Adjustment</li>
 * <li><b>Stocktake</b>: Stock take</li>
 * <li><b>BinToBin</b>: Bin to Bin transfer</li>
 * <li><b>BinCount</b>: Bin Count</li>
 * </ul>
 *
 */
export enum transactionType {
    ADJUSTMENT = 'adjustment',
    STOCKTAKE = 'stocktake',
    BIN_TO_BIN = 'binToBin',
    BIN_COUNT = 'binCount'
}

export type TRCLine = {
    qty: number;
    batchId?: number | null;
    uomName?: string | null;
    bestBeforeDate?: Date | null;
    productionDate?: Date | null;
    lotNumber?: string | null;
    itemSku: string;
    binLocation?: string | null;
    weight?: number | null;
};

export type TRN = {
    header?: TRNHeader;
    lines?: Array<TRNDetails> | null;
    totals?: TRNTotals;
    tags?: Array<DocumentTag> | null;
    readonly docType?: string | null;
    readonly docId?: string | null;
};

export type TRNDetails = {
    inventoryCount?: number;
    inventoryAvailable?: number;
    inventoryBlocked?: number;
    inventoryExpected?: number;
    inventoryReserved?: number;
    inventoryAvailableOtherWarehouses?: number;
    inventoryExpectedDetails?: string | null;
    binLocationA?: string | null;
    binLocationB?: string | null;
    binLocation?: string | null;
    binPriority?: number | null;
    itemExpectedDate?: Date | null;
    partId?: string;
    partTitle?: string | null;
    partCode?: string | null;
    partEAN?: string | null;
    partUPC?: string | null;
    partASIN?: string | null;
    partISBN?: string | null;
    partBrandName?: string | null;
    partCategoryName?: string | null;
    partDepartmentName?: string | null;
    partImageS?: string | null;
    partImageL?: string | null;
    partImageM?: string | null;
    partImageO?: string | null;
    partMPN?: string | null;
    partType?: 'STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM' | null;
    readonly itemTypeDescription?: string | null;
    pricingMethod?: 'QUANTITY' | 'WEIGHT' | 'SIZE' | null;
    partNominalCode?: string | null;
    stockingWarehouseId?: string | null;
    partBuyingPrice?: number | null;
    partBuyingCurrency?: string | null;
    partBuyingPriceLCY?: number | null;
    parentPartId?: string | null;
    inventoryModelId?: number | null;
    inventoryModelName?: string | null;
    readonly isStockItem?: boolean;
    readonly isInventoryItem?: boolean;
    internalComments?: string | null;
    itemTags?: string | null;
    sellableItem?: boolean | null;
    isEOL?: boolean;
    docReference?: string | null;
    specifications?: {
        [key: string]: unknown;
    } | null;
    itemHsCode?: string | null;
    itemCOO?: string | null;
    itemOnOrderDetails?: Array<ItemOnOrderDetail> | null;
    detailID?: number;
    uomId?: number;
    qty?: number;
    qtyPacked?: number;
    qtyReceived?: number;
    unitPrice?: number;
    currency?: string | null;
    barcodeData?: string | null;
    tBatchID?: number | null;
    readonly subtotalValue?: number;
    tbinLocation?: string | null;
    uomName?: string | null;
    instructions?: string | null;
    mpSellerSku?: string | null;
    uomDetails?: ProductUOM;
    dimensionsMinCM?: number;
    dimensionsMedCM?: number;
    dimensionsMaxCM?: number;
    readonly cbmEach?: number;
};

export type TRNHeader = {
    trnid?: number;
    trn?: string | null;
    transferDate?: Date | null;
    userID?: number | null;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    transferStatus?: 'draft' | 'confirmed';
    originWarehouse?: string | null;
    destinationWarehouse?: string | null;
    quickTrn?: boolean;
    statusPack?: number | null;
    statusDelivery?: number | null;
    statusReceive?: number | null;
    pricelistID?: string | null;
    pickingNotes?: string | null;
    trnReference?: string | null;
    originWarehouseName?: string | null;
    destinationWarehouseName?: string | null;
    mpid?: number | null;
    warehouseAddress?: Address;
    shippingAddress?: Address;
    isFinalised?: boolean;
    assignedCarrierId?: number | null;
    trnApiData?: string | null;
    customFields?: {
        [key: string]: (string | null);
    } | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum transferStatus {
    DRAFT = 'draft',
    CONFIRMED = 'confirmed'
}

export type TRNLine = {
    qty: number;
    batchId?: number | null;
    uomName?: string | null;
    bestBeforeDate?: Date | null;
    productionDate?: Date | null;
    lotNumber?: string | null;
    itemSku: string;
    binLocation?: string | null;
};

export type TRNPayload = {
    direction: 'inbound' | 'outbound';
    transaferDate: Date;
    transaferReference?: string | null;
    instantTransfer: boolean;
    /**
     * Warehouse code of transfer warehouse
     */
    warehouseCode: string;
    lines: Array<TRNLine>;
};

export enum direction2 {
    INBOUND = 'inbound',
    OUTBOUND = 'outbound'
}

export type TRNTotals = {
    totalNet?: number;
    totalNetLcy?: number;
    totalGross?: number;
    totalGrossLcy?: number;
    totalDiscount?: number;
    totalVAT?: number;
    readonly totalTax?: number;
    totalPaid?: number | null;
    totalDue?: number | null;
    total?: number;
    uomTotals?: Array<UOMTotal> | null;
    totalQtyInDefaultUOM?: number | null;
    totalQty?: number;
    totalUnreceivedValue?: number;
    totalWeightInKg?: number;
    totalWeightInGr?: number;
    totalCBM?: number;
};

export type Ticket = {
    id?: string | null;
    token?: string | null;
    created?: Date;
    updated?: Date | null;
    open?: boolean;
    status?: string | null;
    subject?: string | null;
    description?: string | null;
    sender?: string | null;
    type?: string | null;
};

export type TicketConversation = {
    id?: string | null;
    created_at?: Date;
    updated_at?: Date | null;
    body?: string | null;
    incoming?: boolean;
    from?: string | null;
};

export type TicketList = {
    emailValidated?: boolean;
    tickets?: Array<Ticket> | null;
};

export type TicketListResponseData = {
    data?: TicketList;
};

export type TicketWithConversations = {
    id?: string | null;
    token?: string | null;
    created?: Date;
    updated?: Date | null;
    open?: boolean;
    status?: string | null;
    subject?: string | null;
    description?: string | null;
    sender?: string | null;
    type?: string | null;
    descriptionHtml?: string | null;
    agentName?: string | null;
    conversations?: Array<TicketConversation> | null;
};

export type TicketWithConversationsResponseData = {
    data?: TicketWithConversations;
};

export type TrustedDevice = {
    id?: string | null;
    name?: string | null;
    location?: string | null;
    createdTime?: Date;
    lastUsedTime?: Date | null;
    thisDevice?: boolean;
};

export type TrustedDeviceUnpagedListResults = {
    results?: Array<TrustedDevice> | null;
};

export type UOMTotal = {
    uomName?: string | null;
    qty?: number;
};

export type User = {
    id?: string | null;
    name?: string | null;
    email?: string | null;
    role?: string | null;
    locale?: string | null;
    emailValidated?: boolean;
    organization?: Organisation;
    settings?: UserSettings;
};

export type UserBase = {
    id?: number;
    name?: string | null;
    active?: boolean;
    role?: IdName;
};

export type UserBaseUnpagedListResults = {
    results?: Array<UserBase> | null;
};

export type UserInviteRequest = {
    firstName: string;
    lastName: string;
    emailAddress: string;
    roleId: number;
    warehouseId: string;
};

export type UserPasswordResetRequest = {
    password1: string;
    password2: string;
    token: string;
};

export type UserPasswordUpdateRequest = {
    password1: string;
    password2: string;
    currentPassword: string;
};

export type UserProfileBase = {
    nameFirst: string;
    nameLast: string;
};

export type UserProfileBaseResponseData = {
    data?: UserProfileBase;
};

export type UserSettings = {
    printQueueId?: number | null;
    warehouseId?: string | null;
};

export type VATBreakdown = {
    vatCode?: string | null;
    vatRate?: number;
    lines?: number;
    net?: number;
    vatAmount?: number;
    total?: number;
};

export type WarehouseBin = {
    id?: number;
    name: string;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type: 'STORAGE' | 'TOTE' | 'SHIP' | 'RECEIVING' | 'PICK';
    lastBinCount?: Date | null;
    priority?: number;
    dimensions?: Dimensions;
    utilization?: number | null;
    utilizationPercent?: number | null;
    color?: string | null;
    maxPickQty?: number | null;
};

/**
 * <p>Possible values:</p>
 * <ul>
 * </ul>
 *
 */
export enum type6 {
    STORAGE = 'STORAGE',
    TOTE = 'TOTE',
    SHIP = 'SHIP',
    RECEIVING = 'RECEIVING',
    PICK = 'PICK'
}

export type WarehouseBinListResults = {
    totalCount?: number | null;
    offset?: number | null;
    limit?: number | null;
    results?: Array<WarehouseBin> | null;
};

export type WarehouseBinUpsert = {
    id?: number;
    name: string;
    /**
     * <p>Possible values:</p>
     * <ul>
     * </ul>
     *
     */
    type: 'STORAGE' | 'TOTE' | 'SHIP' | 'RECEIVING' | 'PICK';
    priority?: number;
    dimensions?: Dimensions;
    color?: string | null;
    maxPickQty?: number | null;
};

export type WarehouseDetails = {
    id?: string;
    code?: string | null;
    name?: string | null;
    isGroup?: boolean;
    isDefault?: boolean;
    address?: DocumentAddress;
};

export type WarehouseDetailsUnpagedListResults = {
    results?: Array<WarehouseDetails> | null;
};

export type WarehouseZone = {
    id?: number;
    name: string;
    minPriority: number;
    maxPriority: number;
};

export type WarehouseZoneUnpagedListResults = {
    results?: Array<WarehouseZone> | null;
};

export type Weight = {
    value?: number | null;
    uom?: 'kg' | 'g' | 'oz' | 'lb' | null;
};

export enum uom2 {
    KG = 'kg',
    G = 'g',
    OZ = 'oz',
    LB = 'lb'
}

export type WorkflowBase = {
    id?: number;
    name?: string | null;
    groupItems?: boolean;
    pckMode?: number;
};

export type GetDocumentsAttachmentsDocumenttypeDocumentidData = {
    path: {
        documentId: string;
        documentType: string;
    };
};

export type GetDocumentsAttachmentsDocumenttypeDocumentidResponse = DocumentAttachmentUnpagedListResults;

export type GetDocumentsAttachmentsDocumenttypeDocumentidError = ErrorResponse & unknown;

export type PostDocumentsAttachmentsDocumenttypeDocumentidData = {
    body?: {
        file: Array<((Blob | File))>;
        description?: string;
    };
    path: {
        documentId: string;
        documentType: string;
    };
};

export type PostDocumentsAttachmentsDocumenttypeDocumentidResponse = void;

export type PostDocumentsAttachmentsDocumenttypeDocumentidError = ErrorResponse & unknown;

export type PostDocumentsBulkInsertDocumenttypeDocumentidData = {
    body?: DocumentItemBulkInsertBulkUpsertRequest;
    path: {
        documentId: string;
        documentType: string;
    };
};

export type PostDocumentsBulkInsertDocumenttypeDocumentidResponse = void;

export type PostDocumentsBulkInsertDocumenttypeDocumentidError = ErrorResponse & unknown;

export type GetDocumentsDefinitionDocumentnameData = {
    path: {
        documentName: string;
    };
};

export type GetDocumentsDefinitionDocumentnameResponse = DocumentDefinitionResponseData;

export type GetDocumentsDefinitionDocumentnameError = ErrorResponse & unknown;

export type GetDocumentsDetailsDocumenttypeDocumentidData = {
    path: {
        documentId: string;
        documentType: string;
    };
};

export type GetDocumentsDetailsDocumenttypeDocumentidResponse = DocumentDetailsResponseData;

export type GetDocumentsDetailsDocumenttypeDocumentidError = ErrorResponse & unknown;

export type PostDocumentsExportDocumenttypeDocumentidData = {
    body?: DocumentExportUpdate;
    path: {
        documentId: string;
        documentType: string;
    };
};

export type PostDocumentsExportDocumenttypeDocumentidResponse = void;

export type PostDocumentsExportDocumenttypeDocumentidError = ErrorResponse & unknown;

export type GetDocumentsExportPendingHeaderidData = {
    path: {
        headerId: number;
    };
};

export type GetDocumentsExportPendingHeaderidResponse = ExportPendingResponseData;

export type GetDocumentsExportPendingHeaderidError = ErrorResponse & unknown;

export type GetDocumentsItemLookupDocumenttypeData = {
    path: {
        documentType: string;
    };
};

export type GetDocumentsItemLookupDocumenttypeResponse = ItemLookupDocumentUnpagedListResults;

export type GetDocumentsItemLookupDocumenttypeError = ErrorResponse & unknown;

export type GetDocumentsItemPriceDocumenttypeItemidData = {
    path: {
        documentType: string;
        itemId: string;
    };
};

export type GetDocumentsItemPriceDocumenttypeItemidResponse = ItemPriceLookupResponseData;

export type GetDocumentsItemPriceDocumenttypeItemidError = ErrorResponse & unknown;

export type GetDocumentsNotesDocumenttypeDocumentidData = {
    path: {
        documentId: string;
        documentType: string;
    };
};

export type GetDocumentsNotesDocumenttypeDocumentidResponse = DocumentNoteUnpagedListResults;

export type GetDocumentsNotesDocumenttypeDocumentidError = ErrorResponse & unknown;

export type PostDocumentsNotesDocumenttypeDocumentidData = {
    body?: NewDocumentNote;
    path: {
        documentId: string;
        documentType: string;
    };
};

export type PostDocumentsNotesDocumenttypeDocumentidResponse = DocumentNoteResponseData;

export type PostDocumentsNotesDocumenttypeDocumentidError = ErrorResponse & unknown;

export type DeleteDocumentsNotesNoteidData = {
    path: {
        noteId: number;
    };
};

export type DeleteDocumentsNotesNoteidResponse = void;

export type DeleteDocumentsNotesNoteidError = ErrorResponse & unknown;

export type GetDocumentsQueuesDocumenttypeData = {
    path: {
        documentType: string;
    };
};

export type GetDocumentsQueuesDocumenttypeResponse = DocumentQueueUnpagedListResults;

export type GetDocumentsQueuesDocumenttypeError = ErrorResponse & unknown;

export type GetDocumentsSearchData = {
    query: {
        documentTypes?: string;
        query: string;
    };
};

export type GetDocumentsSearchResponse = DocumentSearchResultUnpagedListResults;

export type GetDocumentsSearchError = ErrorResponse & unknown;

export type GetDocumentsStorageKeyData = {
    path: {
        key: string;
    };
};

export type PostDocumentsStorageKeyData = {
    body?: StorageDataRequest;
    path: {
        key: string;
    };
};

export type PostDocumentsTagsDocumenttypeDocumentidData = {
    body?: DocumentTagsUpdate;
    path: {
        documentId: string;
        documentType: string;
    };
};

export type PostDocumentsTagsDocumenttypeDocumentidResponse = void;

export type PostDocumentsTagsDocumenttypeDocumentidError = ErrorResponse & unknown;

export type PostInventoryCatalogIdUpsertData = {
    body?: ItemsCatalogUpsertBulkUpsertRequest;
    path: {
        id: number;
    };
};

export type PostInventoryCatalogIdUpsertResponse = void;

export type PostInventoryCatalogIdUpsertError = ErrorResponse & unknown;

export type GetInventoryCategoriesResponse = ItemCategoryUnpagedListResults;

export type GetInventoryCategoriesError = ErrorResponse & unknown;

export type PostInventoryCategoriesData = {
    body?: ItemCategoryUpsert;
    path: {
        id: number;
    };
};

export type PostInventoryCategoriesResponse = ItemCategoryResponseData;

export type PostInventoryCategoriesError = ErrorResponse & unknown;

export type PostInventoryCategoriesIdData = {
    body?: ItemCategoryUpsert;
    path: {
        id: number;
    };
};

export type PostInventoryCategoriesIdResponse = ItemCategoryResponseData;

export type PostInventoryCategoriesIdError = ErrorResponse & unknown;

export type PostInventoryItemData = {
    body?: CreateItemRequest;
};

export type PostInventoryItemResponse = ItemDetails;

export type PostInventoryItemError = ErrorResponse & unknown;

export type GetInventoryItemLabelsDocumenttypeDocumentidData = {
    path: {
        documentId: string;
        documentType: string;
    };
};

export type GetInventoryItemLabelsDocumenttypeDocumentidResponse = ItemLabelUnpagedListResults;

export type GetInventoryItemLabelsDocumenttypeDocumentidError = ErrorResponse & unknown;

export type PostInventoryItemLabelsDocumenttypeDocumentidData = {
    body?: BulkPrintItemLabelRequest;
    path: {
        documentId: string;
        documentType: string;
    };
};

export type PostInventoryItemLabelsDocumenttypeDocumentidResponse = void;

export type PostInventoryItemLabelsDocumenttypeDocumentidError = ErrorResponse & unknown;

export type GetInventoryItemLookupItemskuData = {
    path: {
        itemSku: string;
    };
};

export type GetInventoryItemLookupItemskuResponse = ItemLookupImageResponseData;

export type GetInventoryItemLookupItemskuError = ErrorResponse & unknown;

export type GetInventoryItemTagListResponse = ItemTagUnpagedListResults;

export type GetInventoryItemTagListError = ErrorResponse & unknown;

export type GetInventoryItemItemskuData = {
    path: {
        /**
         * Item SKU
         */
        itemSku: string;
    };
    query?: {
        /**
         * (Optional) UOM Code
         */
        uomCode?: string;
    };
};

export type GetInventoryItemItemskuResponse = ItemDetails;

export type GetInventoryItemItemskuError = ErrorResponse & unknown;

export type GetInventoryItemItemskuBatchesData = {
    path: {
        itemSku: string;
    };
};

export type GetInventoryItemItemskuBatchesResponse = ItemBatchInfoUnpagedListResults;

export type GetInventoryItemItemskuBatchesError = ErrorResponse & unknown;

export type PostInventoryItemItemskuContactContactcodeData = {
    body?: ItemContactInfoUpsert;
    path: {
        contactCode: string;
        itemSku: string;
    };
};

export type PostInventoryItemItemskuContactContactcodeResponse = void;

export type PostInventoryItemItemskuContactContactcodeError = ErrorResponse & unknown;

export type PostInventoryItemItemskuIdentifierData = {
    path: {
        /**
         * Item SKU
         */
        itemSku: string;
    };
    query: {
        /**
         * Item identifier text
         */
        identifier: string;
        /**
         * UOM Code or name, optional, uses item default UOM if left blank
         */
        uom?: string;
    };
};

export type PostInventoryItemItemskuIdentifierResponse = void;

export type PostInventoryItemItemskuIdentifierError = ErrorResponse & unknown;

export type GetInventoryItemItemskuImagesData = {
    path: {
        itemSku: string;
    };
};

export type GetInventoryItemItemskuImagesResponse = ItemImageUnpagedListResults;

export type GetInventoryItemItemskuImagesError = ErrorResponse & unknown;

export type PostInventoryItemItemskuImagesData = {
    body?: AppendItemImageRequest;
    path: {
        itemSku: string;
    };
};

export type PostInventoryItemItemskuImagesResponse = AppendItemImageResponseUnpagedListResults;

export type PostInventoryItemItemskuImagesError = ErrorResponse & unknown;

export type GetInventoryItemItemskuInventoryData = {
    path: {
        itemSku: string;
    };
    query?: {
        uomId?: number;
    };
};

export type GetInventoryItemItemskuInventoryResponse = ItemInventorySummaryResponseData;

export type GetInventoryItemItemskuInventoryError = ErrorResponse & unknown;

export type GetInventoryItemItemskuInventory3DData = {
    path: {
        itemSku: string;
    };
    query?: {
        warehouseId?: string;
    };
};

export type GetInventoryItemItemskuInventory3DResponse = ItemInventory3dSummaryUnpagedListResults;

export type GetInventoryItemItemskuInventory3DError = ErrorResponse & unknown;

export type GetInventoryItemItemskuInventoryLogData = {
    path: {
        itemSku: string;
    };
    query?: {
        batchId?: number;
        bin?: string;
        endDate?: Date;
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Offset items amount
         */
        offset?: number;
        startDate?: Date;
        transactionType?: string;
        warehouseId?: string;
    };
};

export type GetInventoryItemItemskuInventoryLogResponse = ItemInventoryLogListResults;

export type GetInventoryItemItemskuInventoryLogError = ErrorResponse & unknown;

export type GetInventoryItemItemskuInventoryDrilldownWarehouseidData = {
    path: {
        itemSku: string;
        warehouseId: string;
    };
    query: {
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Offset items amount
         */
        offset?: number;
        type: 'INBOUND' | 'OUTBOUND' | 'AGING' | 'UNINVOICED' | 'TRN' | 'POB2B' | 'PODD' | 'BLOCKED';
    };
};

export type GetInventoryItemItemskuInventoryDrilldownWarehouseidResponse = ItemInventoryDrilldownListResults;

export type GetInventoryItemItemskuInventoryDrilldownWarehouseidError = ErrorResponse & unknown;

export type GetInventoryItemItemskuPricingData = {
    path: {
        itemSku: string;
    };
};

export type GetInventoryItemItemskuPricingResponse = PricelistEntryPerItemUnpagedListResults;

export type GetInventoryItemItemskuPricingError = ErrorResponse & unknown;

export type GetInventoryItemItemskuQuickViewQvtypeData = {
    path: {
        itemSku: string;
        qvType: 'SALES' | 'PURCHASES';
    };
    query?: {
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Offset items amount
         */
        offset?: number;
    };
};

export type GetInventoryItemItemskuQuickViewQvtypeResponse = ItemQuickViewResultsListResults;

export type GetInventoryItemItemskuQuickViewQvtypeError = ErrorResponse & unknown;

export type GetInventoryItemItemskuUomData = {
    path: {
        itemSku: string;
    };
};

export type GetInventoryItemItemskuUomResponse = ItemUomUnpagedListResults;

export type GetInventoryItemItemskuUomError = ErrorResponse & unknown;

export type PostInventoryItemItemskuVendorContactcodeData = {
    body?: ItemVendorCatalogUpsert;
    path: {
        contactCode: string;
        itemSku: string;
    };
};

export type PostInventoryItemItemskuVendorContactcodeResponse = void;

export type PostInventoryItemItemskuVendorContactcodeError = ErrorResponse & unknown;

export type PostInventoryItemImagesData = {
    body?: {
        file: (Blob | File);
    };
    query?: {
        replace?: boolean;
        setDefault?: boolean;
        setPrivate?: boolean;
    };
};

export type PostInventoryItemImagesResponse = AppendItemImageDetailResponseResponseData;

export type PostInventoryItemImagesError = ErrorResponse & unknown;

export type GetInventoryItemListData = {
    query?: {
        /**
         * Filter by app category (Use the app category id)
         */
        appCategory?: Array<(number)>;
        /**
         * Indicates if the appCategory filter should be inclusive or exclusive
         */
        'appCategory.exclude'?: boolean;
        /**
         * Filter by item hidden (By default all items are returned)
         */
        appHidden?: 'ONLY' | 'EXCLUDE';
        /**
         * Filter by brand (Use the brand id)
         */
        brand?: Array<(number)>;
        /**
         * Indicates if the brand filter should be inclusive or exclusive
         */
        'brand.exclude'?: boolean;
        /**
         * Filter by category (Use the category id)
         */
        category?: Array<(number)>;
        /**
         * Indicates if the category filter should be inclusive or exclusive
         */
        'category.exclude'?: boolean;
        /**
         * Filter by department (Use the department id)
         */
        department?: Array<(number)>;
        /**
         * Indicates if the department filter should be inclusive or exclusive
         */
        'department.exclude'?: boolean;
        /**
         * Filter by EOL items (By default all items are returned)
         */
        eol?: 'ONLY' | 'EXCLUDE';
        /**
         * Filter to exclude by item tag (Use the tag id)
         */
        excludeTag?: Array<(number)>;
        /**
         * Filter by items in stock only
         */
        inStockOnly?: boolean;
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Filter by item marked as new (By default all items are returned)
         */
        markedNew?: 'ONLY' | 'EXCLUDE';
        /**
         * Offset items amount
         */
        offset?: number;
        query?: string;
        /**
         * Indicates if items should have all tags or any of the tags
         */
        requireAllTags?: boolean;
        /**
         * Filter by supplier (Code)
         */
        supplier?: Array<(string)>;
        /**
         * Indicates if the supplier filter should be inclusive or exclusive
         */
        'supplier.exclude'?: boolean;
        /**
         * Filter by item tag (Use the tag id)
         */
        tag?: Array<(number)>;
        /**
         * Filter by item type
         */
        type?: Array<('STOCK_ITEM' | 'SERVICE_ITEM' | 'KIT_ITEM' | 'BOM_ITEM' | 'GROUP_ITEM')>;
    };
};

export type GetInventoryItemListResponse = ListItemDetailListResults;

export type GetInventoryItemListError = ErrorResponse & unknown;

export type PatchInventoryItemTagsData = {
    body?: ItemTagsUpdate;
};

export type PatchInventoryItemTagsResponse = void;

export type PatchInventoryItemTagsError = ErrorResponse & unknown;

export type GetInventoryPriceListIdData = {
    path: {
        id: string;
    };
    query?: {
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Offset items amount
         */
        offset?: number;
    };
};

export type GetInventoryPriceListIdResponse = PricelistEntryListResults;

export type GetInventoryPriceListIdError = ErrorResponse & unknown;

export type GetInventoryPriceListListResponse = PricelistDetailsUnpagedListResults;

export type GetInventoryPriceListListError = ErrorResponse & unknown;

export type PostInventoryPriceListUpsertConditionalData = {
    body?: PricelistConditionalUpsertPricelistUpsert;
};

export type PostInventoryPriceListUpsertConditionalResponse = void;

export type PostInventoryPriceListUpsertConditionalError = ErrorResponse & unknown;

export type PostInventoryPriceListUpsertEntriesData = {
    body?: PricelistEntryUpsertPricelistUpsert;
};

export type PostInventoryPriceListUpsertEntriesResponse = void;

export type PostInventoryPriceListUpsertEntriesError = ErrorResponse & unknown;

export type PostInventoryPriceListUpsertUomData = {
    body?: PricelistUomUpsertPricelistUpsert;
};

export type PostInventoryPriceListUpsertUomResponse = void;

export type PostInventoryPriceListUpsertUomError = ErrorResponse & unknown;

export type PostInventoryPrintItemData = {
    body?: PrintItemLabelRequest;
};

export type PostInventoryPrintItemResponse = void;

export type PostInventoryPrintItemError = ErrorResponse & unknown;

export type PostInventoryPrintItemBulkData = {
    body?: PrintItemLabelBulkRequest;
};

export type PostInventoryPrintItemBulkResponse = void;

export type PostInventoryPrintItemBulkError = ErrorResponse & unknown;

export type GetInventoryStockSummaryData = {
    query?: {
        /**
         * A date (UTC) since last stock change
         */
        modifiedSinceUtc?: Date;
        /**
         * List of SKUs to retrieve
         */
        skus?: Array<(string)>;
        /**
         * When blank will use default warehouse, use * for all warehouses or specify warehouse code
         */
        warehouseCode?: string;
    };
};

export type GetInventoryStockSummaryResponse = ItemInventoryByItemWarehouseUnpagedListResults;

export type GetInventoryStockSummaryError = ErrorResponse & unknown;

export type GetInventoryStockSummaryDetailedData = {
    query?: {
        /**
         * A date (UTC) since last stock change
         */
        modifiedSinceUtc?: Date;
        /**
         * Filter for items in a pricelist
         */
        pricelistId?: string;
        /**
         * List of SKUs to retrieve
         */
        skus?: Array<(string)>;
        /**
         * When blank will use default warehouse, use * for all warehouses or specify warehouse code
         */
        warehouseCode?: string;
    };
};

export type GetInventoryStockSummaryDetailedResponse = ItemInventoryByItemWarehouseDetailedUnpagedListResults;

export type GetInventoryStockSummaryDetailedError = ErrorResponse & unknown;

export type PostInventoryTrcData = {
    body?: TRC;
};

export type PostInventoryTrcResponse = Int32SuccessMessage;

export type PostInventoryTrcError = ErrorResponse & unknown;

export type PostInventoryTrnData = {
    body?: TRNPayload;
};

export type PostInventoryTrnResponse = Int32SuccessMessage;

export type PostInventoryTrnError = ErrorResponse & unknown;

export type GetInventoryWarehousesData = {
    query?: {
        includeGroups?: boolean;
    };
};

export type GetInventoryWarehousesResponse = WarehouseDetailsUnpagedListResults;

export type GetInventoryWarehousesError = ErrorResponse & unknown;

export type PostInventoryWarehousesWarehouseidBinData = {
    body?: WarehouseBinUpsert;
    path: {
        warehouseId: string;
    };
};

export type PostInventoryWarehousesWarehouseidBinResponse = void;

export type PostInventoryWarehousesWarehouseidBinError = ErrorResponse & unknown;

export type GetInventoryWarehousesWarehouseidBinListData = {
    path: {
        warehouseId: string;
    };
};

export type GetInventoryWarehousesWarehouseidBinListResponse = StringUnpagedListResults;

export type GetInventoryWarehousesWarehouseidBinListError = ErrorResponse & unknown;

export type DeleteInventoryWarehousesWarehouseidBinBinidData = {
    path: {
        binId: number;
        warehouseId: string;
    };
};

export type DeleteInventoryWarehousesWarehouseidBinBinidResponse = void;

export type DeleteInventoryWarehousesWarehouseidBinBinidError = ErrorResponse & unknown;

export type GetInventoryWarehousesWarehouseidBinsData = {
    path: {
        warehouseId: string;
    };
    query?: {
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Offset items amount
         */
        offset?: number;
        query?: string;
    };
};

export type GetInventoryWarehousesWarehouseidBinsResponse = WarehouseBinListResults;

export type GetInventoryWarehousesWarehouseidBinsError = ErrorResponse & unknown;

export type PostInventoryWarehousesWarehouseidZoneData = {
    body?: WarehouseZone;
    path: {
        warehouseId: string;
    };
};

export type PostInventoryWarehousesWarehouseidZoneResponse = void;

export type PostInventoryWarehousesWarehouseidZoneError = ErrorResponse & unknown;

export type DeleteInventoryWarehousesWarehouseidZoneZoneidData = {
    path: {
        warehouseId: string;
        zoneId: string;
    };
    query?: {
        zoneId?: number;
    };
};

export type DeleteInventoryWarehousesWarehouseidZoneZoneidResponse = void;

export type DeleteInventoryWarehousesWarehouseidZoneZoneidError = ErrorResponse & unknown;

export type GetInventoryWarehousesWarehouseidZonesData = {
    path: {
        warehouseId: string;
    };
};

export type GetInventoryWarehousesWarehouseidZonesResponse = WarehouseZoneUnpagedListResults;

export type GetInventoryWarehousesWarehouseidZonesError = ErrorResponse & unknown;

export type GetMarketplacesResponse = MarketplaceDetailsUnpagedListResults;

export type GetMarketplacesError = ErrorResponse & unknown;

export type GetMarketplacesMpidData = {
    path: {
        mpId: string;
    };
};

export type GetMarketplacesMpidResponse = MarketplaceDetailsExtendedResponseData;

export type GetMarketplacesMpidError = ErrorResponse & unknown;

export type DeleteMarketplacesMpidData = {
    path: {
        mpId: string;
    };
};

export type DeleteMarketplacesMpidResponse = void;

export type DeleteMarketplacesMpidError = ErrorResponse & unknown;

export type PostMarketplacesMpidAmazonFbaInboundCreatePlanData = {
    body: FbaInboundCreatePlanRequest;
    path: {
        mpId: string;
    };
};

export type PostMarketplacesMpidAmazonFbaInboundCreatePlanResponse = FbaInboundCreatePlanResponseUnpagedListResults;

export type PostMarketplacesMpidAmazonFbaInboundCreatePlanError = ErrorResponse & unknown;

export type PostMarketplacesMpidAmazonFbaInboundCreateShipmentData = {
    body: FbaInboundCreateShipmentRequest;
    path: {
        mpId: string;
    };
};

export type PostMarketplacesMpidAmazonFbaInboundCreateShipmentResponse = FbaInboundCreateShipmentResponseResponseData;

export type PostMarketplacesMpidAmazonFbaInboundCreateShipmentError = ErrorResponse & unknown;

export type PostMarketplacesMpidAmazonFbaInboundPrepInstructionsData = {
    body: FbaInboundGetPrepInstructionsRequest;
    path: {
        mpId: string;
    };
};

export type PostMarketplacesMpidAmazonFbaInboundPrepInstructionsResponse = FbaInboundItemListPrepInstructionsResponseUnpagedListResults;

export type PostMarketplacesMpidAmazonFbaInboundPrepInstructionsError = ErrorResponse & unknown;

export type GetMarketplacesMpidListingsData = {
    path: {
        mpId: string;
    };
    query?: {
        fulfillment?: 'ANY' | 'MERCHANT' | 'MARKETPLACE';
        includeInventory?: string;
        includeValues?: boolean;
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        linked?: 'ANY' | 'LINKED' | 'UNLINKED';
        /**
         * Offset items amount
         */
        offset?: number;
        search?: string;
        sellerSku?: Array<(string)>;
    };
};

export type GetMarketplacesMpidListingsResponse = ListingDetailListResults;

export type GetMarketplacesMpidListingsError = ErrorResponse & unknown;

export type PostMarketplacesMpidListingsData = {
    body?: ListingBulkSearch;
    path: {
        mpId: string;
    };
};

export type PostMarketplacesMpidListingsResponse = ListingDetailUnpagedListResults;

export type PostMarketplacesMpidListingsError = ErrorResponse & unknown;

export type GetMarketplacesAmazonFbaInboundData = {
    query?: {
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        mpId?: string;
        /**
         * Offset items amount
         */
        offset?: number;
        packingStatus?: Array<('PENDING' | 'PARTIALLY' | 'COMPLETE' | 'NA')>;
        receiveStatus?: Array<('PENDING' | 'PARTIALLY' | 'COMPLETE' | 'NA')>;
    };
};

export type GetMarketplacesAmazonFbaInboundResponse = FbaInboundDocumentListResults;

export type GetMarketplacesAmazonFbaInboundError = ErrorResponse & unknown;

export type GetMarketplacesAmazonFbaInboundTrnidData = {
    path: {
        trnId: number;
    };
};

export type GetMarketplacesAmazonFbaInboundTrnidResponse = FbaInboundDocumentWithShipmentResponseData;

export type GetMarketplacesAmazonFbaInboundTrnidError = ErrorResponse & unknown;

export type PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoData = {
    body?: FbaInboundSubmitPakcageInfoRequest;
    path: {
        trnId: number;
    };
};

export type PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoResponse = void;

export type PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoError = ErrorResponse & unknown;

export type DeleteMarketplacesAmazonFbaInboundTrnidTransportData = {
    path: {
        trnId: number;
    };
};

export type DeleteMarketplacesAmazonFbaInboundTrnidTransportResponse = void;

export type DeleteMarketplacesAmazonFbaInboundTrnidTransportError = ErrorResponse & unknown;

export type PostMarketplacesAmazonFbaInboundTrnidTransportData = {
    body: FbaInboundPutTransportDetailsRequest;
    path: {
        trnId: number;
    };
};

export type PostMarketplacesAmazonFbaInboundTrnidTransportResponse = FbaInboundPutTransportDetailsResponseResponseData;

export type PostMarketplacesAmazonFbaInboundTrnidTransportError = ErrorResponse & unknown;

export type PostMarketplacesAmazonFbaInboundTrnidTransportConfirmData = {
    body: FbaInboundPutTransportDetailsRequest;
    path: {
        trnId: number;
    };
};

export type PostMarketplacesAmazonFbaInboundTrnidTransportConfirmResponse = void;

export type PostMarketplacesAmazonFbaInboundTrnidTransportConfirmError = ErrorResponse & unknown;

export type PostMarketplacesAmazonFbaInboundImportData = {
    body?: MpBulkInsertRequest;
};

export type PostMarketplacesAmazonFbaInboundImportResponse = StringResponseData;

export type PostMarketplacesAmazonFbaInboundImportError = ErrorResponse & unknown;

export type GetMarketplacesInventoryProfilesResponse = InventoryProfileUnpagedListResults;

export type GetMarketplacesInventoryProfilesError = ErrorResponse & unknown;

export type GetMarketplacesInventoryProfilesIdData = {
    path: {
        id: string;
    };
};

export type GetMarketplacesInventoryProfilesIdResponse = InventoryProfileWithDetailsResponseData;

export type GetMarketplacesInventoryProfilesIdError = ErrorResponse & unknown;

export type GetMarketplacesLinkedServicesResponse = LinkedServicesResponseData;

export type GetMarketplacesLinkedServicesError = ErrorResponse & unknown;

export type PostMarketplacesWayfairRegisterShipmentSoidData = {
    path: {
        soId: string;
    };
};

export type PostMarketplacesWayfairRegisterShipmentSoidResponse = void;

export type PostMarketplacesWayfairRegisterShipmentSoidError = ErrorResponse & unknown;

export type GetUserDataColumnsViewnameData = {
    path: {
        viewName: string;
    };
};

export type GetUserDataColumnsViewnameResponse = ColumnDisplayUnpagedListResults;

export type GetUserDataColumnsViewnameError = ErrorResponse & unknown;

export type PostUserEmailValidationRequestResponse = void;

export type PostUserEmailValidationRequestError = ErrorResponse & unknown;

export type GetUserNotificationsData = {
    query?: {
        /**
         * Items per page, default is 50, max 250
         */
        limit?: number;
        /**
         * Offset items amount
         */
        offset?: number;
    };
};

export type GetUserNotificationsResponse = NotificationListResults;

export type GetUserNotificationsError = ErrorResponse & unknown;

export type GetUserNotificationsCountResponse = NotificationCountResponseData;

export type GetUserNotificationsCountError = ErrorResponse & unknown;

export type GetUserOrganizationResponse = Organisation;

export type GetUserOrganizationError = ErrorResponse & unknown;

export type GetUserSelfResponse = User;

export type GetUserSelfError = ErrorResponse & unknown;

export type PostUserSupportTicketData = {
    body?: {
        files?: Array<((Blob | File))>;
        type: string;
        subject: string;
        body: string;
        ccEmail: Array<(string)>;
    };
};

export type PostUserSupportTicketResponse = void;

export type PostUserSupportTicketError = ErrorResponse & unknown;

export type GetUserSupportTicketTicketidData = {
    path: {
        ticketId: string;
    };
    query: {
        token: string;
    };
};

export type GetUserSupportTicketTicketidResponse = TicketWithConversationsResponseData;

export type GetUserSupportTicketTicketidError = ErrorResponse & unknown;

export type GetUserSupportTicketListData = {
    query?: {
        status?: 'OPEN' | 'CLOSED';
    };
};

export type GetUserSupportTicketListResponse = TicketListResponseData;

export type GetUserSupportTicketListError = ErrorResponse & unknown;

export type $OpenApiTs = {
    '/documents/attachments/{documentType}/{documentId}': {
        get: {
            req: GetDocumentsAttachmentsDocumenttypeDocumentidData;
            res: {
                /**
                 * OK
                 */
                '200': DocumentAttachmentUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostDocumentsAttachmentsDocumenttypeDocumentidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/bulk-insert/{documentType}/{documentId}': {
        post: {
            req: PostDocumentsBulkInsertDocumenttypeDocumentidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/definition/{documentName}': {
        get: {
            req: GetDocumentsDefinitionDocumentnameData;
            res: {
                /**
                 * OK
                 */
                '200': DocumentDefinitionResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/details/{documentType}/{documentId}': {
        get: {
            req: GetDocumentsDetailsDocumenttypeDocumentidData;
            res: {
                /**
                 * OK
                 */
                '200': DocumentDetailsResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/export/{documentType}/{documentId}': {
        post: {
            req: PostDocumentsExportDocumenttypeDocumentidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/export/pending/{headerId}': {
        get: {
            req: GetDocumentsExportPendingHeaderidData;
            res: {
                /**
                 * OK
                 */
                '200': ExportPendingResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/item-lookup/{documentType}': {
        get: {
            req: GetDocumentsItemLookupDocumenttypeData;
            res: {
                /**
                 * OK
                 */
                '200': ItemLookupDocumentUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/item-price/{documentType}/{itemId}': {
        get: {
            req: GetDocumentsItemPriceDocumenttypeItemidData;
            res: {
                /**
                 * OK
                 */
                '200': ItemPriceLookupResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/notes/{documentType}/{documentId}': {
        get: {
            req: GetDocumentsNotesDocumenttypeDocumentidData;
            res: {
                /**
                 * OK
                 */
                '200': DocumentNoteUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostDocumentsNotesDocumenttypeDocumentidData;
            res: {
                /**
                 * Created
                 */
                '201': DocumentNoteResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/notes/{noteId}': {
        delete: {
            req: DeleteDocumentsNotesNoteidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/queues/{documentType}': {
        get: {
            req: GetDocumentsQueuesDocumenttypeData;
            res: {
                /**
                 * OK
                 */
                '200': DocumentQueueUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/search': {
        get: {
            req: GetDocumentsSearchData;
            res: {
                /**
                 * OK
                 */
                '200': DocumentSearchResultUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/storage/{key}': {
        get: {
            req: GetDocumentsStorageKeyData;
            res: {
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostDocumentsStorageKeyData;
            res: {
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/documents/tags/{documentType}/{documentId}': {
        post: {
            req: PostDocumentsTagsDocumenttypeDocumentidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/catalog/{id}/upsert': {
        post: {
            req: PostInventoryCatalogIdUpsertData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/categories': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': ItemCategoryUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostInventoryCategoriesData;
            res: {
                /**
                 * OK
                 */
                '200': ItemCategoryResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/categories/{id}': {
        post: {
            req: PostInventoryCategoriesIdData;
            res: {
                /**
                 * OK
                 */
                '200': ItemCategoryResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/divisions': {
        get: {
            res: {
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item': {
        post: {
            req: PostInventoryItemData;
            res: {
                /**
                 * OK
                 */
                '200': ItemDetails;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item-labels/{documentType}/{documentId}': {
        get: {
            req: GetInventoryItemLabelsDocumenttypeDocumentidData;
            res: {
                /**
                 * OK
                 */
                '200': ItemLabelUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostInventoryItemLabelsDocumenttypeDocumentidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item-lookup/{itemSku}': {
        get: {
            req: GetInventoryItemLookupItemskuData;
            res: {
                /**
                 * OK
                 */
                '200': ItemLookupImageResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item-tag/list': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': ItemTagUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}': {
        get: {
            req: GetInventoryItemItemskuData;
            res: {
                /**
                 * OK
                 */
                '200': ItemDetails;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/batches': {
        get: {
            req: GetInventoryItemItemskuBatchesData;
            res: {
                /**
                 * OK
                 */
                '200': ItemBatchInfoUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/contact/{contactCode}': {
        post: {
            req: PostInventoryItemItemskuContactContactcodeData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/identifier': {
        post: {
            req: PostInventoryItemItemskuIdentifierData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/images': {
        get: {
            req: GetInventoryItemItemskuImagesData;
            res: {
                /**
                 * OK
                 */
                '200': ItemImageUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostInventoryItemItemskuImagesData;
            res: {
                /**
                 * OK
                 */
                '200': AppendItemImageResponseUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/inventory': {
        get: {
            req: GetInventoryItemItemskuInventoryData;
            res: {
                /**
                 * OK
                 */
                '200': ItemInventorySummaryResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/inventory-3d': {
        get: {
            req: GetInventoryItemItemskuInventory3DData;
            res: {
                /**
                 * OK
                 */
                '200': ItemInventory3dSummaryUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/inventory-log': {
        get: {
            req: GetInventoryItemItemskuInventoryLogData;
            res: {
                /**
                 * OK
                 */
                '200': ItemInventoryLogListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/inventory/drilldown/{warehouseId}': {
        get: {
            req: GetInventoryItemItemskuInventoryDrilldownWarehouseidData;
            res: {
                /**
                 * OK
                 */
                '200': ItemInventoryDrilldownListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/pricing': {
        get: {
            req: GetInventoryItemItemskuPricingData;
            res: {
                /**
                 * OK
                 */
                '200': PricelistEntryPerItemUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/quick-view/{qvType}': {
        get: {
            req: GetInventoryItemItemskuQuickViewQvtypeData;
            res: {
                /**
                 * OK
                 */
                '200': ItemQuickViewResultsListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/uom': {
        get: {
            req: GetInventoryItemItemskuUomData;
            res: {
                /**
                 * OK
                 */
                '200': ItemUomUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/{itemSku}/vendor/{contactCode}': {
        post: {
            req: PostInventoryItemItemskuVendorContactcodeData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/images': {
        post: {
            req: PostInventoryItemImagesData;
            res: {
                /**
                 * OK
                 */
                '200': AppendItemImageDetailResponseResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/list': {
        get: {
            req: GetInventoryItemListData;
            res: {
                /**
                 * OK
                 */
                '200': ListItemDetailListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/item/tags': {
        patch: {
            req: PatchInventoryItemTagsData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/price-list/{id}': {
        get: {
            req: GetInventoryPriceListIdData;
            res: {
                /**
                 * OK
                 */
                '200': PricelistEntryListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/price-list/list': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': PricelistDetailsUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Not Found
                 */
                '404': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/price-list/upsert/conditional': {
        post: {
            req: PostInventoryPriceListUpsertConditionalData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/price-list/upsert/entries': {
        post: {
            req: PostInventoryPriceListUpsertEntriesData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/price-list/upsert/uom': {
        post: {
            req: PostInventoryPriceListUpsertUomData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/print-item': {
        post: {
            req: PostInventoryPrintItemData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/print-item-bulk': {
        post: {
            req: PostInventoryPrintItemBulkData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/stock-summary': {
        get: {
            req: GetInventoryStockSummaryData;
            res: {
                /**
                 * OK
                 */
                '200': ItemInventoryByItemWarehouseUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/stock-summary-detailed': {
        get: {
            req: GetInventoryStockSummaryDetailedData;
            res: {
                /**
                 * OK
                 */
                '200': ItemInventoryByItemWarehouseDetailedUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/trc': {
        post: {
            req: PostInventoryTrcData;
            res: {
                /**
                 * OK
                 */
                '200': Int32SuccessMessage;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/trn': {
        post: {
            req: PostInventoryTrnData;
            res: {
                /**
                 * OK
                 */
                '200': Int32SuccessMessage;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses': {
        get: {
            req: GetInventoryWarehousesData;
            res: {
                /**
                 * OK
                 */
                '200': WarehouseDetailsUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/bin': {
        post: {
            req: PostInventoryWarehousesWarehouseidBinData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/bin-list': {
        get: {
            req: GetInventoryWarehousesWarehouseidBinListData;
            res: {
                /**
                 * OK
                 */
                '200': StringUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/bin/{binId}': {
        delete: {
            req: DeleteInventoryWarehousesWarehouseidBinBinidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/bins': {
        get: {
            req: GetInventoryWarehousesWarehouseidBinsData;
            res: {
                /**
                 * OK
                 */
                '200': WarehouseBinListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/zone': {
        post: {
            req: PostInventoryWarehousesWarehouseidZoneData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/zone/{zoneId}': {
        delete: {
            req: DeleteInventoryWarehousesWarehouseidZoneZoneidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/inventory/warehouses/{warehouseId}/zones': {
        get: {
            req: GetInventoryWarehousesWarehouseidZonesData;
            res: {
                /**
                 * OK
                 */
                '200': WarehouseZoneUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': MarketplaceDetailsUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/{mpId}': {
        get: {
            req: GetMarketplacesMpidData;
            res: {
                /**
                 * OK
                 */
                '200': MarketplaceDetailsExtendedResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        delete: {
            req: DeleteMarketplacesMpidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/{mpId}/amazon/fba-inbound/create-plan': {
        post: {
            req: PostMarketplacesMpidAmazonFbaInboundCreatePlanData;
            res: {
                /**
                 * OK
                 */
                '200': FbaInboundCreatePlanResponseUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/{mpId}/amazon/fba-inbound/create-shipment': {
        post: {
            req: PostMarketplacesMpidAmazonFbaInboundCreateShipmentData;
            res: {
                /**
                 * OK
                 */
                '200': FbaInboundCreateShipmentResponseResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/{mpId}/amazon/fba-inbound/prep-instructions': {
        post: {
            req: PostMarketplacesMpidAmazonFbaInboundPrepInstructionsData;
            res: {
                /**
                 * OK
                 */
                '200': FbaInboundItemListPrepInstructionsResponseUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/{mpId}/listings': {
        get: {
            req: GetMarketplacesMpidListingsData;
            res: {
                /**
                 * OK
                 */
                '200': ListingDetailListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostMarketplacesMpidListingsData;
            res: {
                /**
                 * OK
                 */
                '200': ListingDetailUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/amazon/fba-inbound': {
        get: {
            req: GetMarketplacesAmazonFbaInboundData;
            res: {
                /**
                 * OK
                 */
                '200': FbaInboundDocumentListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/amazon/fba-inbound/{trnId}': {
        get: {
            req: GetMarketplacesAmazonFbaInboundTrnidData;
            res: {
                /**
                 * OK
                 */
                '200': FbaInboundDocumentWithShipmentResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/amazon/fba-inbound/{trnId}/submit-package-info': {
        post: {
            req: PostMarketplacesAmazonFbaInboundTrnidSubmitPackageInfoData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/amazon/fba-inbound/{trnId}/transport': {
        delete: {
            req: DeleteMarketplacesAmazonFbaInboundTrnidTransportData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
        post: {
            req: PostMarketplacesAmazonFbaInboundTrnidTransportData;
            res: {
                /**
                 * OK
                 */
                '200': FbaInboundPutTransportDetailsResponseResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/amazon/fba-inbound/{trnId}/transport-confirm': {
        post: {
            req: PostMarketplacesAmazonFbaInboundTrnidTransportConfirmData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/amazon/fba-inbound/import': {
        post: {
            req: PostMarketplacesAmazonFbaInboundImportData;
            res: {
                /**
                 * OK
                 */
                '200': StringResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/inventory-profiles': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': InventoryProfileUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/inventory-profiles/{id}': {
        get: {
            req: GetMarketplacesInventoryProfilesIdData;
            res: {
                /**
                 * OK
                 */
                '200': InventoryProfileWithDetailsResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/linked-services': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': LinkedServicesResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/marketplaces/wayfair/register-shipment/{soId}': {
        post: {
            req: PostMarketplacesWayfairRegisterShipmentSoidData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/data-columns/{viewName}': {
        get: {
            req: GetUserDataColumnsViewnameData;
            res: {
                /**
                 * OK
                 */
                '200': ColumnDisplayUnpagedListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/email-validation-request': {
        post: {
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/notifications': {
        get: {
            req: GetUserNotificationsData;
            res: {
                /**
                 * OK
                 */
                '200': NotificationListResults;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/notifications-count': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': NotificationCountResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/organization': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': Organisation;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/self': {
        get: {
            res: {
                /**
                 * OK
                 */
                '200': User;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/support-ticket': {
        post: {
            req: PostUserSupportTicketData;
            res: {
                /**
                 * No Content
                 */
                '204': void;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/support-ticket/{ticketId}': {
        get: {
            req: GetUserSupportTicketTicketidData;
            res: {
                /**
                 * OK
                 */
                '200': TicketWithConversationsResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
    '/user/support-ticket/list': {
        get: {
            req: GetUserSupportTicketListData;
            res: {
                /**
                 * OK
                 */
                '200': TicketListResponseData;
                /**
                 * Bad Request
                 */
                '400': ErrorResponse;
                /**
                 * Unauthorized
                 */
                '401': unknown;
                /**
                 * Internal Server Error
                 */
                '500': ErrorResponse;
            };
        };
    };
};

export type GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer = (data: any) => Promise<GetDocumentsAttachmentsDocumenttypeDocumentidResponse>;

export type DocumentAttachmentUnpagedListResultsModelResponseTransformer = (data: any) => DocumentAttachmentUnpagedListResults;

export type DocumentAttachmentModelResponseTransformer = (data: any) => DocumentAttachment;

export const DocumentAttachmentModelResponseTransformer: DocumentAttachmentModelResponseTransformer = data => {
    if (data?.createdDate) {
        data.createdDate = new Date(data.createdDate);
    }
    return data;
};

export const DocumentAttachmentUnpagedListResultsModelResponseTransformer: DocumentAttachmentUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(DocumentAttachmentModelResponseTransformer);
    }
    return data;
};

export const GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer: GetDocumentsAttachmentsDocumenttypeDocumentidResponseTransformer = async (data) => {
    DocumentAttachmentUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetDocumentsNotesDocumenttypeDocumentidResponseTransformer = (data: any) => Promise<GetDocumentsNotesDocumenttypeDocumentidResponse>;

export type DocumentNoteUnpagedListResultsModelResponseTransformer = (data: any) => DocumentNoteUnpagedListResults;

export type DocumentNoteModelResponseTransformer = (data: any) => DocumentNote;

export const DocumentNoteModelResponseTransformer: DocumentNoteModelResponseTransformer = data => {
    if (data?.createdDate) {
        data.createdDate = new Date(data.createdDate);
    }
    return data;
};

export const DocumentNoteUnpagedListResultsModelResponseTransformer: DocumentNoteUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(DocumentNoteModelResponseTransformer);
    }
    return data;
};

export const GetDocumentsNotesDocumenttypeDocumentidResponseTransformer: GetDocumentsNotesDocumenttypeDocumentidResponseTransformer = async (data) => {
    DocumentNoteUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type PostDocumentsNotesDocumenttypeDocumentidResponseTransformer = (data: any) => Promise<PostDocumentsNotesDocumenttypeDocumentidResponse>;

export type DocumentNoteResponseDataModelResponseTransformer = (data: any) => DocumentNoteResponseData;

export const DocumentNoteResponseDataModelResponseTransformer: DocumentNoteResponseDataModelResponseTransformer = data => {
    if (data?.data) {
        DocumentNoteModelResponseTransformer(data.data);
    }
    return data;
};

export const PostDocumentsNotesDocumenttypeDocumentidResponseTransformer: PostDocumentsNotesDocumenttypeDocumentidResponseTransformer = async (data) => {
    DocumentNoteResponseDataModelResponseTransformer(data);
    return data;
};

export type GetDocumentsQueuesDocumenttypeResponseTransformer = (data: any) => Promise<GetDocumentsQueuesDocumenttypeResponse>;

export type DocumentQueueUnpagedListResultsModelResponseTransformer = (data: any) => DocumentQueueUnpagedListResults;

export type DocumentQueueModelResponseTransformer = (data: any) => DocumentQueue;

export type DocumentQueueCountModelResponseTransformer = (data: any) => DocumentQueueCount;

export const DocumentQueueCountModelResponseTransformer: DocumentQueueCountModelResponseTransformer = data => {
    if (data?.updated) {
        data.updated = new Date(data.updated);
    }
    return data;
};

export const DocumentQueueModelResponseTransformer: DocumentQueueModelResponseTransformer = data => {
    if (data?.queueCount) {
        DocumentQueueCountModelResponseTransformer(data.queueCount);
    }
    return data;
};

export const DocumentQueueUnpagedListResultsModelResponseTransformer: DocumentQueueUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(DocumentQueueModelResponseTransformer);
    }
    return data;
};

export const GetDocumentsQueuesDocumenttypeResponseTransformer: GetDocumentsQueuesDocumenttypeResponseTransformer = async (data) => {
    DocumentQueueUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetDocumentsSearchResponseTransformer = (data: any) => Promise<GetDocumentsSearchResponse>;

export type DocumentSearchResultUnpagedListResultsModelResponseTransformer = (data: any) => DocumentSearchResultUnpagedListResults;

export type DocumentSearchResultModelResponseTransformer = (data: any) => DocumentSearchResult;

export const DocumentSearchResultModelResponseTransformer: DocumentSearchResultModelResponseTransformer = data => {
    if (data?.documentDate) {
        data.documentDate = new Date(data.documentDate);
    }
    return data;
};

export const DocumentSearchResultUnpagedListResultsModelResponseTransformer: DocumentSearchResultUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(DocumentSearchResultModelResponseTransformer);
    }
    return data;
};

export const GetDocumentsSearchResponseTransformer: GetDocumentsSearchResponseTransformer = async (data) => {
    DocumentSearchResultUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type PostInventoryItemResponseTransformer = (data: any) => Promise<PostInventoryItemResponse>;

export type ItemDetailsModelResponseTransformer = (data: any) => ItemDetails;

export type ItemInventoryModelResponseTransformer = (data: any) => ItemInventory;

export const ItemInventoryModelResponseTransformer: ItemInventoryModelResponseTransformer = data => {
    if (data?.onOrderEta) {
        data.onOrderEta = new Date(data.onOrderEta);
    }
    return data;
};

export type ItemAppInfoModelResponseTransformer = (data: any) => ItemAppInfo;

export const ItemAppInfoModelResponseTransformer: ItemAppInfoModelResponseTransformer = data => {
    if (data?.newEndDate) {
        data.newEndDate = new Date(data.newEndDate);
    }
    return data;
};

export const ItemDetailsModelResponseTransformer: ItemDetailsModelResponseTransformer = data => {
    if (data?.inventory) {
        ItemInventoryModelResponseTransformer(data.inventory);
    }
    if (data?.app) {
        ItemAppInfoModelResponseTransformer(data.app);
    }
    return data;
};

export const PostInventoryItemResponseTransformer: PostInventoryItemResponseTransformer = async (data) => {
    ItemDetailsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer = (data: any) => Promise<GetInventoryItemLabelsDocumenttypeDocumentidResponse>;

export type ItemLabelUnpagedListResultsModelResponseTransformer = (data: any) => ItemLabelUnpagedListResults;

export type ItemLabelModelResponseTransformer = (data: any) => ItemLabel;

export type ItemBatchInfoModelResponseTransformer = (data: any) => ItemBatchInfo;

export const ItemBatchInfoModelResponseTransformer: ItemBatchInfoModelResponseTransformer = data => {
    if (data?.productionDate) {
        data.productionDate = new Date(data.productionDate);
    }
    if (data?.bestBeforeDate) {
        data.bestBeforeDate = new Date(data.bestBeforeDate);
    }
    return data;
};

export const ItemLabelModelResponseTransformer: ItemLabelModelResponseTransformer = data => {
    if (data?.batch) {
        ItemBatchInfoModelResponseTransformer(data.batch);
    }
    return data;
};

export const ItemLabelUnpagedListResultsModelResponseTransformer: ItemLabelUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemLabelModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer: GetInventoryItemLabelsDocumenttypeDocumentidResponseTransformer = async (data) => {
    ItemLabelUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuResponse>;

export const GetInventoryItemItemskuResponseTransformer: GetInventoryItemItemskuResponseTransformer = async (data) => {
    ItemDetailsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuBatchesResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuBatchesResponse>;

export type ItemBatchInfoUnpagedListResultsModelResponseTransformer = (data: any) => ItemBatchInfoUnpagedListResults;

export const ItemBatchInfoUnpagedListResultsModelResponseTransformer: ItemBatchInfoUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemBatchInfoModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemItemskuBatchesResponseTransformer: GetInventoryItemItemskuBatchesResponseTransformer = async (data) => {
    ItemBatchInfoUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuInventory3DResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuInventory3DResponse>;

export type ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer = (data: any) => ItemInventory3dSummaryUnpagedListResults;

export type ItemInventory3dSummaryModelResponseTransformer = (data: any) => ItemInventory3dSummary;

export const ItemInventory3dSummaryModelResponseTransformer: ItemInventory3dSummaryModelResponseTransformer = data => {
    if (data?.batchDetails) {
        ItemBatchInfoModelResponseTransformer(data.batchDetails);
    }
    return data;
};

export const ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer: ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemInventory3dSummaryModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemItemskuInventory3DResponseTransformer: GetInventoryItemItemskuInventory3DResponseTransformer = async (data) => {
    ItemInventory3dSummaryUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuInventoryLogResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuInventoryLogResponse>;

export type ItemInventoryLogListResultsModelResponseTransformer = (data: any) => ItemInventoryLogListResults;

export type ItemInventoryLogModelResponseTransformer = (data: any) => ItemInventoryLog;

export const ItemInventoryLogModelResponseTransformer: ItemInventoryLogModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    if (data?.batchInfo) {
        ItemBatchInfoModelResponseTransformer(data.batchInfo);
    }
    return data;
};

export const ItemInventoryLogListResultsModelResponseTransformer: ItemInventoryLogListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemInventoryLogModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemItemskuInventoryLogResponseTransformer: GetInventoryItemItemskuInventoryLogResponseTransformer = async (data) => {
    ItemInventoryLogListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuInventoryDrilldownWarehouseidResponse>;

export type ItemInventoryDrilldownListResultsModelResponseTransformer = (data: any) => ItemInventoryDrilldownListResults;

export type ItemInventoryDrilldownModelResponseTransformer = (data: any) => ItemInventoryDrilldown;

export const ItemInventoryDrilldownModelResponseTransformer: ItemInventoryDrilldownModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    return data;
};

export const ItemInventoryDrilldownListResultsModelResponseTransformer: ItemInventoryDrilldownListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemInventoryDrilldownModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer: GetInventoryItemItemskuInventoryDrilldownWarehouseidResponseTransformer = async (data) => {
    ItemInventoryDrilldownListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuPricingResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuPricingResponse>;

export type PricelistEntryPerItemUnpagedListResultsModelResponseTransformer = (data: any) => PricelistEntryPerItemUnpagedListResults;

export type PricelistEntryPerItemModelResponseTransformer = (data: any) => PricelistEntryPerItem;

export type PricelistEntryConditionalModelResponseTransformer = (data: any) => PricelistEntryConditional;

export const PricelistEntryConditionalModelResponseTransformer: PricelistEntryConditionalModelResponseTransformer = data => {
    if (data?.startDate) {
        data.startDate = new Date(data.startDate);
    }
    if (data?.endDate) {
        data.endDate = new Date(data.endDate);
    }
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export type PricelistUomEntryModelResponseTransformer = (data: any) => PricelistUomEntry;

export const PricelistUomEntryModelResponseTransformer: PricelistUomEntryModelResponseTransformer = data => {
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    return data;
};

export const PricelistEntryPerItemModelResponseTransformer: PricelistEntryPerItemModelResponseTransformer = data => {
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    if (Array.isArray(data?.conditionalPricing)) {
        data.conditionalPricing.forEach(PricelistEntryConditionalModelResponseTransformer);
    }
    if (Array.isArray(data?.uomPricing)) {
        data.uomPricing.forEach(PricelistUomEntryModelResponseTransformer);
    }
    return data;
};

export const PricelistEntryPerItemUnpagedListResultsModelResponseTransformer: PricelistEntryPerItemUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(PricelistEntryPerItemModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemItemskuPricingResponseTransformer: GetInventoryItemItemskuPricingResponseTransformer = async (data) => {
    PricelistEntryPerItemUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryItemItemskuQuickViewQvtypeResponseTransformer = (data: any) => Promise<GetInventoryItemItemskuQuickViewQvtypeResponse>;

export type ItemQuickViewResultsListResultsModelResponseTransformer = (data: any) => ItemQuickViewResultsListResults;

export type ItemQuickViewResultsModelResponseTransformer = (data: any) => ItemQuickViewResults;

export const ItemQuickViewResultsModelResponseTransformer: ItemQuickViewResultsModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    return data;
};

export const ItemQuickViewResultsListResultsModelResponseTransformer: ItemQuickViewResultsListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemQuickViewResultsModelResponseTransformer);
    }
    return data;
};

export const GetInventoryItemItemskuQuickViewQvtypeResponseTransformer: GetInventoryItemItemskuQuickViewQvtypeResponseTransformer = async (data) => {
    ItemQuickViewResultsListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryPriceListIdResponseTransformer = (data: any) => Promise<GetInventoryPriceListIdResponse>;

export type PricelistEntryListResultsModelResponseTransformer = (data: any) => PricelistEntryListResults;

export type PricelistEntryModelResponseTransformer = (data: any) => PricelistEntry;

export const PricelistEntryModelResponseTransformer: PricelistEntryModelResponseTransformer = data => {
    if (data?.updatedAt) {
        data.updatedAt = new Date(data.updatedAt);
    }
    if (Array.isArray(data?.conditionalPricing)) {
        data.conditionalPricing.forEach(PricelistEntryConditionalModelResponseTransformer);
    }
    if (Array.isArray(data?.uomPricing)) {
        data.uomPricing.forEach(PricelistUomEntryModelResponseTransformer);
    }
    return data;
};

export const PricelistEntryListResultsModelResponseTransformer: PricelistEntryListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(PricelistEntryModelResponseTransformer);
    }
    return data;
};

export const GetInventoryPriceListIdResponseTransformer: GetInventoryPriceListIdResponseTransformer = async (data) => {
    PricelistEntryListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryStockSummaryResponseTransformer = (data: any) => Promise<GetInventoryStockSummaryResponse>;

export type ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer = (data: any) => ItemInventoryByItemWarehouseUnpagedListResults;

export type ItemInventoryByItemWarehouseModelResponseTransformer = (data: any) => ItemInventoryByItemWarehouse;

export const ItemInventoryByItemWarehouseModelResponseTransformer: ItemInventoryByItemWarehouseModelResponseTransformer = data => {
    if (data?.lastModified) {
        data.lastModified = new Date(data.lastModified);
    }
    return data;
};

export const ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer: ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemInventoryByItemWarehouseModelResponseTransformer);
    }
    return data;
};

export const GetInventoryStockSummaryResponseTransformer: GetInventoryStockSummaryResponseTransformer = async (data) => {
    ItemInventoryByItemWarehouseUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryStockSummaryDetailedResponseTransformer = (data: any) => Promise<GetInventoryStockSummaryDetailedResponse>;

export type ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer = (data: any) => ItemInventoryByItemWarehouseDetailedUnpagedListResults;

export type ItemInventoryByItemWarehouseDetailedModelResponseTransformer = (data: any) => ItemInventoryByItemWarehouseDetailed;

export const ItemInventoryByItemWarehouseDetailedModelResponseTransformer: ItemInventoryByItemWarehouseDetailedModelResponseTransformer = data => {
    if (data?.lastModified) {
        data.lastModified = new Date(data.lastModified);
    }
    if (data?.batchDetails) {
        ItemBatchInfoModelResponseTransformer(data.batchDetails);
    }
    return data;
};

export const ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer: ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(ItemInventoryByItemWarehouseDetailedModelResponseTransformer);
    }
    return data;
};

export const GetInventoryStockSummaryDetailedResponseTransformer: GetInventoryStockSummaryDetailedResponseTransformer = async (data) => {
    ItemInventoryByItemWarehouseDetailedUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetInventoryWarehousesWarehouseidBinsResponseTransformer = (data: any) => Promise<GetInventoryWarehousesWarehouseidBinsResponse>;

export type WarehouseBinListResultsModelResponseTransformer = (data: any) => WarehouseBinListResults;

export type WarehouseBinModelResponseTransformer = (data: any) => WarehouseBin;

export const WarehouseBinModelResponseTransformer: WarehouseBinModelResponseTransformer = data => {
    if (data?.lastBinCount) {
        data.lastBinCount = new Date(data.lastBinCount);
    }
    return data;
};

export const WarehouseBinListResultsModelResponseTransformer: WarehouseBinListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(WarehouseBinModelResponseTransformer);
    }
    return data;
};

export const GetInventoryWarehousesWarehouseidBinsResponseTransformer: GetInventoryWarehousesWarehouseidBinsResponseTransformer = async (data) => {
    WarehouseBinListResultsModelResponseTransformer(data);
    return data;
};

export type GetMarketplacesResponseTransformer = (data: any) => Promise<GetMarketplacesResponse>;

export type MarketplaceDetailsUnpagedListResultsModelResponseTransformer = (data: any) => MarketplaceDetailsUnpagedListResults;

export type MarketplaceDetailsModelResponseTransformer = (data: any) => MarketplaceDetails;

export type SyncStatusModelResponseTransformer = (data: any) => SyncStatus;

export const SyncStatusModelResponseTransformer: SyncStatusModelResponseTransformer = data => {
    if (data?.lastSync) {
        data.lastSync = new Date(data.lastSync);
    }
    return data;
};

export type MarketplaceErrorDetailsModelResponseTransformer = (data: any) => MarketplaceErrorDetails;

export const MarketplaceErrorDetailsModelResponseTransformer: MarketplaceErrorDetailsModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    return data;
};

export const MarketplaceDetailsModelResponseTransformer: MarketplaceDetailsModelResponseTransformer = data => {
    if (data?.ordersSync) {
        SyncStatusModelResponseTransformer(data.ordersSync);
    }
    if (data?.pricesSync) {
        SyncStatusModelResponseTransformer(data.pricesSync);
    }
    if (data?.inventorySync) {
        SyncStatusModelResponseTransformer(data.inventorySync);
    }
    if (data?.exception) {
        MarketplaceErrorDetailsModelResponseTransformer(data.exception);
    }
    return data;
};

export const MarketplaceDetailsUnpagedListResultsModelResponseTransformer: MarketplaceDetailsUnpagedListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(MarketplaceDetailsModelResponseTransformer);
    }
    return data;
};

export const GetMarketplacesResponseTransformer: GetMarketplacesResponseTransformer = async (data) => {
    MarketplaceDetailsUnpagedListResultsModelResponseTransformer(data);
    return data;
};

export type GetMarketplacesMpidResponseTransformer = (data: any) => Promise<GetMarketplacesMpidResponse>;

export type MarketplaceDetailsExtendedResponseDataModelResponseTransformer = (data: any) => MarketplaceDetailsExtendedResponseData;

export type MarketplaceDetailsExtendedModelResponseTransformer = (data: any) => MarketplaceDetailsExtended;

export type OrdersSyncStatusModelResponseTransformer = (data: any) => OrdersSyncStatus;

export const OrdersSyncStatusModelResponseTransformer: OrdersSyncStatusModelResponseTransformer = data => {
    if (data?.lastSync) {
        data.lastSync = new Date(data.lastSync);
    }
    if (data?.minimumDate) {
        data.minimumDate = new Date(data.minimumDate);
    }
    return data;
};

export type InventorySyncStatusModelResponseTransformer = (data: any) => InventorySyncStatus;

export const InventorySyncStatusModelResponseTransformer: InventorySyncStatusModelResponseTransformer = data => {
    if (data?.lastSync) {
        data.lastSync = new Date(data.lastSync);
    }
    return data;
};

export type ListingSyncStatusModelResponseTransformer = (data: any) => ListingSyncStatus;

export const ListingSyncStatusModelResponseTransformer: ListingSyncStatusModelResponseTransformer = data => {
    if (data?.lastSync) {
        data.lastSync = new Date(data.lastSync);
    }
    return data;
};

export const MarketplaceDetailsExtendedModelResponseTransformer: MarketplaceDetailsExtendedModelResponseTransformer = data => {
    if (data?.pricesSync) {
        SyncStatusModelResponseTransformer(data.pricesSync);
    }
    if (data?.exception) {
        MarketplaceErrorDetailsModelResponseTransformer(data.exception);
    }
    if (data?.ordersSync) {
        OrdersSyncStatusModelResponseTransformer(data.ordersSync);
    }
    if (data?.inventorySync) {
        InventorySyncStatusModelResponseTransformer(data.inventorySync);
    }
    if (data?.listingSync) {
        ListingSyncStatusModelResponseTransformer(data.listingSync);
    }
    return data;
};

export const MarketplaceDetailsExtendedResponseDataModelResponseTransformer: MarketplaceDetailsExtendedResponseDataModelResponseTransformer = data => {
    if (data?.data) {
        MarketplaceDetailsExtendedModelResponseTransformer(data.data);
    }
    return data;
};

export const GetMarketplacesMpidResponseTransformer: GetMarketplacesMpidResponseTransformer = async (data) => {
    MarketplaceDetailsExtendedResponseDataModelResponseTransformer(data);
    return data;
};

export type GetMarketplacesAmazonFbaInboundResponseTransformer = (data: any) => Promise<GetMarketplacesAmazonFbaInboundResponse>;

export type FbaInboundDocumentListResultsModelResponseTransformer = (data: any) => FbaInboundDocumentListResults;

export type FbaInboundDocumentModelResponseTransformer = (data: any) => FbaInboundDocument;

export const FbaInboundDocumentModelResponseTransformer: FbaInboundDocumentModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    return data;
};

export const FbaInboundDocumentListResultsModelResponseTransformer: FbaInboundDocumentListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(FbaInboundDocumentModelResponseTransformer);
    }
    return data;
};

export const GetMarketplacesAmazonFbaInboundResponseTransformer: GetMarketplacesAmazonFbaInboundResponseTransformer = async (data) => {
    FbaInboundDocumentListResultsModelResponseTransformer(data);
    return data;
};

export type GetMarketplacesAmazonFbaInboundTrnidResponseTransformer = (data: any) => Promise<GetMarketplacesAmazonFbaInboundTrnidResponse>;

export type FbaInboundDocumentWithShipmentResponseDataModelResponseTransformer = (data: any) => FbaInboundDocumentWithShipmentResponseData;

export type FbaInboundDocumentWithShipmentModelResponseTransformer = (data: any) => FbaInboundDocumentWithShipment;

export type FbaInboundShipmentStatusModelResponseTransformer = (data: any) => FbaInboundShipmentStatus;

export const FbaInboundShipmentStatusModelResponseTransformer: FbaInboundShipmentStatusModelResponseTransformer = data => {
    if (data?.confirmedNeedByDate) {
        data.confirmedNeedByDate = new Date(data.confirmedNeedByDate);
    }
    return data;
};

export type ShipmentWithPackagesModelResponseTransformer = (data: any) => ShipmentWithPackages;

export type PackageInfoModelResponseTransformer = (data: any) => PackageInfo;

export const PackageInfoModelResponseTransformer: PackageInfoModelResponseTransformer = data => {
    if (data?.packingDate) {
        data.packingDate = new Date(data.packingDate);
    }
    return data;
};

export const ShipmentWithPackagesModelResponseTransformer: ShipmentWithPackagesModelResponseTransformer = data => {
    if (Array.isArray(data?.packages)) {
        data.packages.forEach(PackageInfoModelResponseTransformer);
    }
    return data;
};

export const FbaInboundDocumentWithShipmentModelResponseTransformer: FbaInboundDocumentWithShipmentModelResponseTransformer = data => {
    if (data?.date) {
        data.date = new Date(data.date);
    }
    if (data?.inboundInfo) {
        FbaInboundShipmentStatusModelResponseTransformer(data.inboundInfo);
    }
    if (Array.isArray(data?.shipments)) {
        data.shipments.forEach(ShipmentWithPackagesModelResponseTransformer);
    }
    if (Array.isArray(data?.pendingPackages)) {
        data.pendingPackages.forEach(PackageInfoModelResponseTransformer);
    }
    return data;
};

export const FbaInboundDocumentWithShipmentResponseDataModelResponseTransformer: FbaInboundDocumentWithShipmentResponseDataModelResponseTransformer = data => {
    if (data?.data) {
        FbaInboundDocumentWithShipmentModelResponseTransformer(data.data);
    }
    return data;
};

export const GetMarketplacesAmazonFbaInboundTrnidResponseTransformer: GetMarketplacesAmazonFbaInboundTrnidResponseTransformer = async (data) => {
    FbaInboundDocumentWithShipmentResponseDataModelResponseTransformer(data);
    return data;
};

export type GetUserNotificationsResponseTransformer = (data: any) => Promise<GetUserNotificationsResponse>;

export type NotificationListResultsModelResponseTransformer = (data: any) => NotificationListResults;

export type NotificationModelResponseTransformer = (data: any) => Notification;

export const NotificationModelResponseTransformer: NotificationModelResponseTransformer = data => {
    if (data?.createdAtUtc) {
        data.createdAtUtc = new Date(data.createdAtUtc);
    }
    return data;
};

export const NotificationListResultsModelResponseTransformer: NotificationListResultsModelResponseTransformer = data => {
    if (Array.isArray(data?.results)) {
        data.results.forEach(NotificationModelResponseTransformer);
    }
    return data;
};

export const GetUserNotificationsResponseTransformer: GetUserNotificationsResponseTransformer = async (data) => {
    NotificationListResultsModelResponseTransformer(data);
    return data;
};

export type GetUserSupportTicketTicketidResponseTransformer = (data: any) => Promise<GetUserSupportTicketTicketidResponse>;

export type TicketWithConversationsResponseDataModelResponseTransformer = (data: any) => TicketWithConversationsResponseData;

export type TicketWithConversationsModelResponseTransformer = (data: any) => TicketWithConversations;

export type TicketConversationModelResponseTransformer = (data: any) => TicketConversation;

export const TicketConversationModelResponseTransformer: TicketConversationModelResponseTransformer = data => {
    if (data?.created_at) {
        data.created_at = new Date(data.created_at);
    }
    if (data?.updated_at) {
        data.updated_at = new Date(data.updated_at);
    }
    return data;
};

export const TicketWithConversationsModelResponseTransformer: TicketWithConversationsModelResponseTransformer = data => {
    if (data?.created) {
        data.created = new Date(data.created);
    }
    if (data?.updated) {
        data.updated = new Date(data.updated);
    }
    if (Array.isArray(data?.conversations)) {
        data.conversations.forEach(TicketConversationModelResponseTransformer);
    }
    return data;
};

export const TicketWithConversationsResponseDataModelResponseTransformer: TicketWithConversationsResponseDataModelResponseTransformer = data => {
    if (data?.data) {
        TicketWithConversationsModelResponseTransformer(data.data);
    }
    return data;
};

export const GetUserSupportTicketTicketidResponseTransformer: GetUserSupportTicketTicketidResponseTransformer = async (data) => {
    TicketWithConversationsResponseDataModelResponseTransformer(data);
    return data;
};

export type GetUserSupportTicketListResponseTransformer = (data: any) => Promise<GetUserSupportTicketListResponse>;

export type TicketListResponseDataModelResponseTransformer = (data: any) => TicketListResponseData;

export type TicketListModelResponseTransformer = (data: any) => TicketList;

export type TicketModelResponseTransformer = (data: any) => Ticket;

export const TicketModelResponseTransformer: TicketModelResponseTransformer = data => {
    if (data?.created) {
        data.created = new Date(data.created);
    }
    if (data?.updated) {
        data.updated = new Date(data.updated);
    }
    return data;
};

export const TicketListModelResponseTransformer: TicketListModelResponseTransformer = data => {
    if (Array.isArray(data?.tickets)) {
        data.tickets.forEach(TicketModelResponseTransformer);
    }
    return data;
};

export const TicketListResponseDataModelResponseTransformer: TicketListResponseDataModelResponseTransformer = data => {
    if (data?.data) {
        TicketListModelResponseTransformer(data.data);
    }
    return data;
};

export const GetUserSupportTicketListResponseTransformer: GetUserSupportTicketListResponseTransformer = async (data) => {
    TicketListResponseDataModelResponseTransformer(data);
    return data;
};